var loop_app = {

	settings: {
	},

	vars: {
		focusableElements : 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"], [data-tabindex="0"]',
		focusableOverlayEls : [],
		firstFocusablOverlayeEl : null,
		lastFocusableOverlayEl : null
	},

	init: function() {
		if(typeof this.translations == 'undefined'){
			// add some default translations
			this.translations = {
				'close': 'Close',
				'prev_slide': 'Previous slide',
				'next_slide': 'Next slide',
				'go_to_slide': 'Go to slide {{index}}',
				'prev_image': 'Previous Image',
				'next_image': 'Next Image'
			};
		}

		this.initLanguage();
		this.initGlobalExtensions();
		this.initLocalExtensions($('body'));

		const icons = document.querySelectorAll('[class*="icon--"]');
		icons.forEach(icon => {
			icon.setAttribute('aria-hidden', 'true');
		});

		const elements = document.querySelectorAll('[data-tabindex]');
		elements.forEach(element => {
			element.removeAttribute('data-tabindex');
			element.removeAttribute('tabindex'); 
		});
	},

	parse: function($context) {
		this.initLocalExtensions($context);
	},

	initGlobalExtensions: function() {
		var t = this;
		for (var globalExt in t.globalExt) {
			if (!loop_app.obj[globalExt]) {
				loop_app.obj[globalExt] = new t.globalExt[globalExt]();
			}
		}
	},

	initLocalExtensions: function($context) {
		var t = this;
		var extensions = _.toPairs(t.ext);

		// pushing execution of dotdotdot to the bottom, because it interferes with email encryption
		extensions = extensions.sort(function(a, b){
			if(a[0] == 'dotdotdot'){
				return 10;
			}

			if(a[0] < b[0]){
				return -1;
			}

			if(a[0] > b[0]){
				return 1;
			}

			return 0;
		});

		for (var key in extensions) {
			var $els;
			var extension = extensions[key];
			var ext = extension[0];

			if(ext == 'ultimate-rte'){
				$els = $context.findOrSelf('.' + ext);
			} else if(ext == 'hyphens') {
				$els = $context.findOrSelf('.u-hyphens');
			} else {
				$els = $context.findOrSelf('.js-' + ext);
			}

			$els.each(function() {
				var fn = new t.ext[ext]($(this));

				$(this).data('obj_' + ext, fn);

				if (loop_app.obj[ext] === undefined) loop_app.obj[ext] = [];
				if ($(this).data('objectName')) {
					loop_app.obj[ext][$(this).data('objectName')] = fn;
				} else {
					loop_app.obj[ext].push(fn);
				}
			});
		}
	},

	initLanguage: function(){
		if($('html').attr('lang') == 'de'){
			moment.locale('de-at');
			loop_app.language = 'de';
		} else {
			moment.locale('en');
			loop_app.language = 'en';
		}
	},

	initGoogleMaps: function(){
		if(typeof google !== 'undefined' && typeof google.maps !== 'undefined' || loop_app.googleMapsTriggered){
			return;
		}

		loop_app.googleMapsTriggered = true;

		window.initMap = function(){
			loop_app.googleMapsReady = true;
			$(window).trigger('googleMapsReady');
		};

		// production key:
		$.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyAB1Rox1JCV6XbqvyzjeQonDkDTBqYynOc&callback=initMap");

		// developtment key:
		// $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCwgzytp17Zfog2OthktCLKtfv88qlLTsw&callback=initMap");
	},

	initYoutube: function(){
		if(loop_app.youtubeTriggered || loop_app.youtubeReady){
			return;
		}

		loop_app.youtubeTriggered = true;

		window.onYouTubeIframeAPIReady = function(){
			loop_app.youtubeReady = true;
			$(window).trigger('youtubeReady');
		};

		var tag = document.createElement('script');

		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	},

	initRecaptcha: function(){
		if(loop_app.recaptchaTriggered){
			return;
		}

		loop_app.recaptchaTriggered = true;

		window.reCaptchaCallback = function(){
			loop_app.recaptchaReady = true;
			$(window).trigger('recaptchaReady');
		};

		$.getScript("https://www.google.com/recaptcha/api.js?onload=reCaptchaCallback&render=explicit&hl=" + loop_app.language);
	},

	rot13: function(str) {
		return str.replace(/([A-M])|([N-Z])/gi, function(m, p1, p2) {
			return String.fromCharCode(m.charCodeAt(0) + (p1 ? 13 : -13));
		});
	},

	setFocusableOverlayEls : function($element) {
		loop_app.vars.focusableOverlayEls = $element.find(loop_app.vars.focusableElements).filter(':visible');
		loop_app.vars.firstFocusablOverlayeEl = loop_app.vars.focusableOverlayEls[0];
		loop_app.vars.lastFocusableOverlayEl = loop_app.vars.focusableOverlayEls[ loop_app.vars.focusableOverlayEls.length - 1 ];

		setTimeout(function() { 
			$element.find('.js-overlay-focus').trigger('focus');
			$element.focus();
		}, 350);
	},

	handleKeyDownOverlay : function(e, $element, obj){
		var KEY_TAB = 9;
		var KEY_ESC = 27;

		switch(e.keyCode) {
			case KEY_TAB:
				// if ( loop_app.vars.focusableOverlayEls.length === 1 ) {
				// 	console.log('keydown1');
				// 	e.preventDefault();
				// 	break;
				// } 

				if ( e.shiftKey ) {
					loop_app.handleBackwardTab(e);
				} else {
					loop_app.handleForwardTab(e);
				}
			
				break;
			case KEY_ESC:
				$element.data('obj_' + obj).closeOverlay();
				break;
			default:
				break;
		} // end switch
	},

	handleBackwardTab : function(e) {
		if ( document.activeElement === loop_app.vars.firstFocusablOverlayeEl ) {
			e.preventDefault();
			loop_app.vars.lastFocusableOverlayEl.focus(e);
		}
	},

	handleForwardTab : function(e) {
		if ( document.activeElement === loop_app.vars.lastFocusableOverlayEl ) {
			e.preventDefault();
			loop_app.vars.firstFocusablOverlayeEl.focus();
		}
	},

	resetFocus : function() {
		window.tabbable.tabbable(document.body)[0].focus();
	},

	initDateRangePickerTabNav : function($datePickerButton) {
		$dateRangePicker = $datePickerButton.data('dateRangePicker')

		const datePickerButton = $datePickerButton.get(0);
		const dialog = $dateRangePicker.getDatePicker().get(0);
		dialog.setAttribute('role', 'dialog');

		const dialogLabel = datePickerButton.labels[0] && datePickerButton.labels[0].textContent.trim();

		if (dialogLabel) {
			dialog.setAttribute('aria-label', dialogLabel);
		}

		const makeButtonsAccessible = () => {
			document.querySelectorAll('.day').forEach(day => {
				loop_app.createA11yButton(day);
				
				day.setAttribute('aria-label', moment(parseInt(day.getAttribute('time'))).format('dddd Do MMMM YYYY'));
	
				if(!day.classList.contains('valid')) {
					day.setAttribute('tabindex', '-1');
				}
			});
	
			document.querySelectorAll('span.prev, span.next').forEach(button => {
				loop_app.createA11yButton(button);
			});
		}

		const observer = new MutationObserver(makeButtonsAccessible);

		const focusTrap = window.focusTrap.createFocusTrap(dialog,{
			onActivate: function(){
				datePickerButton.setAttribute('tabindex', '-1');
			},
			onDeactivate: function(){
				datePickerButton.setAttribute('tabindex', '0');
				$dateRangePicker.close();
			},
			initialFocus: () => dialog.querySelector('.day.first-date-selected') || dialog.querySelector('.day.real-today') || dialog.querySelector('.day.valid') || undefined,
			clickOutsideDeactivates: true
		});

		makeButtonsAccessible();
		observer.observe(dialog, { childList: true, subtree: true });
		
		focusTrap.activate();
		return focusTrap;
	},

	/**
	 * Create an accessible button from an element
	 * Only use this function if you can't use a button element
	 * @param {HTMLElement} element
	 * @param {Object} options
	 * @param {string} options.role
	 */
	createA11yButton (element, { role = 'button' } = {}) {
		if (element.tagName === 'BUTTON') {
			return;
		}

		if (!element.getAttribute('role')) element.setAttribute('role', role);
		element.setAttribute('tabindex', '0');


		if(element.dataset.a11yButton) {
			return;
		}

		element.setAttribute('data-a11y-button', 'true');

		element.addEventListener('keydown', function (e) {
			const key = e.key !== undefined ? e.key : e.keyCode;

			if (
				key === 'Enter' ||
				key === 13 ||
				['Spacebar', ' '].indexOf(key) >= 0 ||
				key === 32
			) {
				e.preventDefault();

				if (typeof element.click === 'function') {
					element.click();
				} else {
					element.dispatchEvent(
						new MouseEvent('click', { bubbles: true }),
					);
				}
			}
		});
	},

	ext: {},
	globalExt: {},
	obj: {},
};

$(function() {
	loop_app.init();
});

$.fn.findOrSelf = function(selector) {
	return this.find(selector).add(this.filter(selector));
};

function FlightSearchDetailOverlay(marker, map, templateString, closeCallback, position){
	this._marker = marker;
	this._map = map;
	this._position = position || 'top';
	this._template = _.template(templateString);
	this._closeCallback = closeCallback;

	this.setMap(map);
}

$(window).on('googleMapsReady', function(){
	FlightSearchDetailOverlay.prototype = new google.maps.OverlayView();

	FlightSearchDetailOverlay.prototype.onAdd = function(){
		var $element = $(this._template(this._marker.data));
		var panes = this.getPanes();
		var context = this;

		if(this._position == 'top'){
			$element.addClass('doverlay--top');
		} else {
			$element.addClass('doverlay--bottom');
		}

		$element.on('click', '.js-doverlay-close', function(e){
			e.preventDefault();
			context._closeCallback();
		});

		panes.overlayMouseTarget.appendChild($element[0]);
		this.$element = $element;

		$element.velocity({
			translateY: [0, 10],
			opacity: [1, 0]
		}, {
			duration: 400,
			easing: 'easeOutQuart'
		});
	};

	FlightSearchDetailOverlay.prototype.draw = function(){
		var overlayProjection = this.getProjection();
		var elementHeight = this.$element.outerHeight();
		var elementWidth = this.$element.outerWidth();
		var origin = overlayProjection.fromLatLngToDivPixel(this._marker.getPosition());

		loop_app.initLocalExtensions(this.$element);

		if(this._position == 'top'){
			this.$element.css({
				left: origin.x - elementWidth/2,
				top: origin.y - elementHeight - 10
			});
		} else {
			this.$element.css({
				left: origin.x - elementWidth/2,
				top: origin.y + 10
			});
		}
	};

	FlightSearchDetailOverlay.prototype.onRemove = function(){
		var context = this;

		this.$element.velocity({
			translateY: [10, 0],
			opacity: [0, 1]
		}, {
			duration: 400,
			easing: 'easeOutQuart',
			complete: function(){
				context.$element.remove();
			}
		});
	};

	FlightSearchDetailOverlay.prototype.getBounds = function(){
		var overlayProjection = this.getProjection();
		var elementHeight = this.$element.outerHeight();
		var elementWidth = this.$element.outerWidth();
		var origin = overlayProjection.fromLatLngToDivPixel(this._marker.getPosition());
		var ne = new google.maps.Point(origin.x + elementWidth/2, origin.y);
		var sw = new google.maps.Point(origin.x - elementWidth/2, origin.y + elementHeight + 200);
		var bounds;

		if(this._position == 'top'){
			ne.y -= elementHeight - 10;
			sw.y -= elementHeight - 10;
		} else {
			ne.y += 10;
			sw.y += 10;
		}

		bounds = new google.maps.LatLngBounds(overlayProjection.fromDivPixelToLatLng(sw), overlayProjection.fromDivPixelToLatLng(ne));

		return bounds;
	};
});

function FlightSearchHoverOverlay(markerOrCluster, clickCallback){
	if(markerOrCluster.getMarkers){
		this._cluster = markerOrCluster;
	} else {
		this._marker = markerOrCluster;
	}

	this._clickCallback = clickCallback;

	this.setMap(markerOrCluster.getMap());
}

$(window).on('googleMapsReady', function(){
	FlightSearchHoverOverlay.prototype = new google.maps.OverlayView();

	FlightSearchHoverOverlay.prototype.onAdd = function(){
		var $element = $('<div class="hoverlay"></div>');
		var panes = this.getPanes();
		var context = this;
		var $item;
		var addItemListener = function($item, marker){
			$item.on('click', function(e){
				e.preventDefault();
				context._clickCallback(marker);
			});
		};

		if(this._cluster){
			_.forEach(this._cluster.getMarkers(), function(marker){
				$item = $('<div class="hoverlay__item">'+marker.data.name+'</div>').appendTo($element);
				addItemListener($item, marker);
			});
		} else {
			$item = $('<div class="hoverlay__item">'+this._marker.data.name+'</div>').appendTo($element);
			addItemListener($item, this._marker);
		}

		$element.on('mouseenter', function(){
			context.isHoveringOverlay = true;
		});

		$element.on('mouseleave', function(){
			context.isHoveringOverlay = false;

			if(!context.isHoveringOverlay && !context.isHoveringMarker){
				context.setMap(null);
			}
		});

		panes.overlayMouseTarget.appendChild($element[0]);
		this.$element = $element;

		$element.velocity({
			translateY: [0, 10],
			opacity: [1, 0]
		}, {
			duration: 300,
			easing: 'easeOutQuart'
		});
	};

	FlightSearchHoverOverlay.prototype.draw = function(){
		var overlayProjection = this.getProjection();
		var elementHeight = this.$element.outerHeight();
		var elementWidth = this.$element.outerWidth();
		var position;

		if(this._cluster){
			position = overlayProjection.fromLatLngToDivPixel(this._cluster.getCenter());
			position.y += 19;
		} else {
			position = overlayProjection.fromLatLngToDivPixel(this._marker.getPosition());
		}

		this.$element.css({
			left: position.x - elementWidth/2,
			top: position.y - elementHeight - 10
		});
	};

	FlightSearchHoverOverlay.prototype.onRemove = function(){
		var context = this;

		this.$element.velocity({
			translateY: [10, 0],
			opacity: [0, 1]
		}, {
			duration: 300,
			easing: 'easeOutQuart',
			complete: function(){
				context.$element.remove();
			}
		});

	};
});

loop_app.globalExt['custom-validation-methods'] = function() {
	var api = {};

	var init = function() {
		$.validator.addMethod( "timeFromTo", function( value, element, parameter ) {
			var from = moment(parameter[0], 'HH:mm');
			var to = moment(parameter[1], 'HH:mm');
			var input = moment(value, 'HH:mm');

			return this.optional( element ) ||
				/^([01]\d|2[0-3]|[0-9])(:[0-5]\d){1,2}$/.test( value ) &&
					from.isValid() &&
					to.isValid() &&
					input.isValid() &&
					input.isSameOrAfter(from) &&
					input.isSameOrBefore(to);

		},
			//$('html').attr('lang') == 'de' ? "Bitte eine gültige Zeit zwischen {0} und {1} angeben" : "Please enter a valid time, between {0} and {1}" 
			$.validator.messages['time'] ? $.validator.messages['time'] : $('html').attr('lang') == 'de' ? "Bitte eine gültige Zeit zwischen {0} und {1} angeben" : "Please enter a valid time, between {0} and {1}"
		);

		$.validator.addMethod( "dateMin", function( value, element, parameter ) {
			var mDate = moment(parameter, 'YYYY-MM-DD');
			var mValue = moment(value, 'DD.MM.YYYY');

			if(!mValue.isValid()){
				mValue = moment(value, 'YYYY-MM-DD');
			}

			return this.optional( element ) ||
				mValue.isValid() &&
				mDate.isValid() &&
				mValue.isSameOrAfter(mDate);

		},
			//$('html').attr('lang') == 'de' ? "Bitte eine gültiges Datum ab {0} angeben" : "Please enter a valid date, on/after {0}" 
			$.validator.messages['customDate'] ? $.validator.messages['customDate'] : $('html').attr('lang') == 'de' ? "Bitte eine gültiges Datum ab {0} angeben" : "Please enter a valid date, on/after {0}"
		);

		$.validator.addMethod( "time", function( value, element, parameter ) {
			var mDate = moment(parameter, 'YYYY-MM-DD');
			var mValue = moment(value, 'DD.MM.YYYY');

			if(!mValue.isValid()){
				mValue = moment(value, 'YYYY-MM-DD');
			}

			return this.optional( element ) ||
				/^([01]\d|2[0-3]|[0-9])(:[0-5]\d){1,2}$/.test( value );

		},
			// $('html').attr('lang') == 'de' ? "Bitte eine gültige Zeit angeben (HH:MM)" : "Please enter a valid time format (HH:MM)"
			$.validator.messages['customTimeFormat'] ? $.validator.messages['customTimeFormat'] : $('html').attr('lang') == 'de' ? "Bitte eine gültige Zeit angeben (HH:MM)" : "Please enter a valid time format (HH:MM)"
		);

		$.validator.addMethod( "timeDifference", function( value, element, parameter ) {
			// var from = moment(parameter[0], 'HH:mm');
			// var to = moment(parameter[1], 'HH:mm');

			// var value1 = moment(value, 'HH:mm');
			// var value2 = moment($('[name='+parameter[2].value]+']'), 'HH:mm');

			var $form = $(element).parents('.js-form');
			
			var dateIn = $form.find('[name=parking_in_date]').val();
			var dateOut = $form.find('[name=parking_out_date]').val();
			
			var timeIn = $form.find('[name=parking_in_time]').val();
			var timeOut = $form.find('[name=parking_out_time]').val();

			if (!dateIn && !dateOut && !timeIn && !timeOut) {
				return true;
			}

			dateIn = (dateIn == '') ? moment().format('DD.MM.YYYY') : dateIn;
			dateOut = (dateOut == '') ? moment().format('DD.MM.YYYY') : dateOut;

			var from = moment(dateIn+' '+timeIn, 'DD.MM.YYYY HH:mm');
			var to = moment(dateOut+ ' '+timeOut, 'DD.MM.YYYY HH:mm');

			var diff = (to.diff(from, 'minutes'));

			if (diff > parseInt(parameter) || isNaN(diff)) {
			 	return true;
			} else {
				return false;
			}
			// console.log(value1 + ' ' + value2 );

			// if(!mValue.isValid()){
			// 	mValue = moment(value, 'YYYY-MM-DD');
			// }

			return true;

		},
			// $('html').attr('lang') == 'de' ? "Die Minimum Dauer ist 21 Minuten" : "The minimum time is 21 minutes" 
			$.validator.messages['customDuration'] ? $.validator.messages['customDuration'] : $('html').attr('lang') == 'de' ? "Die Minimum Dauer ist 21 Minuten" : "The minimum time is 21 minutes"
		);

		$.validator.addMethod( "doNotAllowUrls", function( value, element ) {
			var startsWithHttpHttps = new RegExp("([http|https]://)([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(value);
			var startsWithWWW = new RegExp("(www\\.)([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(value);

			return !(startsWithWWW || startsWithHttpHttps);

		},
			// $('html').attr('lang') == 'de' ? "Bitte eine gültige Zeit angeben (HH:MM)" : "Please enter a valid time format (HH:MM)"
			$.validator.messages['noUrlAllowed'] ? $.validator.messages['noUrlAllowed'] : $('html').attr('lang') == 'de' ? "Eingabe einer URL in diesem Feld ungültig." : "It is not allowed to use any URLs in this field."
		);
	};

	init();
	return api;
};

loop_app.globalExt['darksite-check'] = function() {
	var api = {};
	var timeout;

	var init = function() {
		// don't do anything on darksite
		if($('.js-site').find('.header--dark, .footer--dark').length >= 2){
			setCookie();
			return;
		}

		createTimeout();
	};

	var createTimeout = function(){
		timeout = window.setTimeout(function(){
			$.ajax({
				method: 'get',
				url: '/?darksite_check=1',
				dataType: 'json',
				success: function(data){
					// check for darksite and reload if activated
					if(data.darksite_active){
						setCookie();
						window.location.reload(true);
					}

					createTimeout();
				},
				error: function(){
					createTimeout();
				},
			});
		}, getInterval());
	};

	var getInterval = function(){
		if(Cookies.get('darksite_seen') === '1'){
			return 1000 * 60 * 5; // 5 minutes
		} else {
			return 1000 * 60; // 1 minute
		}
	};

	var setCookie = function(){
		Cookies.set('darksite_seen', '1');
	};

	init();
	return api;
};

loop_app.globalExt['resize-lock-transitions'] = function() {
	var api = {};
	var $site = $('.js-site');
	var timeout;

	var init = function() {
		addListener();
	};

	var addListener = function(){
		$(window).on('resize', function(){
			lock();

			window.clearTimeout(timeout);

			timeout = window.setTimeout(function(){
				unlock();
			}, 200);
		});
	};

	var lock = function(){
		$site.addClass('has-transitions-locked');
	};

	var unlock = function(){
		$site.removeClass('has-transitions-locked');
	};

	init();
	return api;
};

loop_app.ext["a11y-loop-overlay"] = function ($jqueryElement) {
  const api = {};

  const element = $jqueryElement.get(0);

  const overlayFocusTrap = window.focusTrap.createFocusTrap(element, {
    clickOutsideDeactivates: false,
    escapeDeactivates: false,
    tabbableOptions: {
      getShadowRoot: true,
    },
  });

  function init() {
    element.setAttribute("role", "dialog");
    element.setAttribute("aria-modal", "true");

    // Create a MutationObserver to watch for style changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "style"
        ) {
          const display = window.getComputedStyle(element).display;
          if (display === "block") {
            overlayFocusTrap.activate();
          } else if (display === "none") {
            overlayFocusTrap.deactivate();
          }
        }
      });
    });

    // Start observing the element for style changes
    observer.observe(element, {
      attributes: true,
      attributeFilter: ["style"],
    });

    // Delay is needed to ensure the shadow root is available
    setTimeout(() => {
      element.shadowRoot
        .querySelector(".lc-overlay__content")
        .removeAttribute("tabindex");

      const style = document.createElement("style");
      style.textContent = `
          /* Imitate outline styles as in __general.scss */
          .lc-overlay__close:focus-visible {
            outline: 1px solid #e2001a; /* $color-secondary */
	          outline-offset: 2px;
	          outline-style: auto;
          }
        `;
      element.shadowRoot.appendChild(style);
    }, 500);
  }

  init();

  return api;
};

loop_app.ext['activity-finder'] = function($el) {
	var api = {};

	var $element = $el;
	var $rangeslider = $element.find('.js-activity-finder-rangeslider');
	var $custom = $element.find('.js-activity-finder-custom');
	var $input = $element.find('.js-activity-finder-input');
	var $value = $element.find('.js-activity-finder-value');
	var $unitSingular = $element.find('.js-activity-finder-unit-singular');
	var $unitPlural = $element.find('.js-activity-finder-unit-plural');

	var data = JSON.parse($element.find('.js-activity-finder-data').html());
	var dataPairs;
	var dataKeys;
	var slider;
	var value;

	var init = function() {
		dataPairs = _.sortBy(
			_.map(
				_.toPairs(data),
				function(v){
					v[0] = parseFloat(v[0]);
					return v;
				}
			),
			function(v){
				return v[0];
			}
		);

		dataKeys = _.map(dataPairs, function(v){
			return v[0];
		});

		updateValue(parseFloat(_.head(dataPairs[0])));

		slider = noUiSlider.create($custom[0], {
			start: value,
			connect: [true, false],
			range: {
				'min': parseFloat(_.head(dataPairs)[0]),
				'max': parseFloat(_.last(dataPairs)[0]),
			},
		});

		slider.on('update', function(values, handle, unencoded, tap, positions){
			var lastDifference = Infinity;
			var newValue;

			_.forEach(dataKeys, function(key){
				var difference = Math.abs(key - unencoded[0]);

				if(difference < lastDifference){
					newValue = key;
					lastDifference = difference;
				}
			});

			updateValue(newValue);
		});

		addListener();
	};

	var updateValue = function(newValue){
		if(newValue === value){
			return;
		}

		if(dataKeys.indexOf(newValue) >= 0){
			value = newValue;
			formattedValue = value;

			if(loop_app.language == 'de'){
				formattedValue = value.toString().replace('\.', '\,');
			}

			$value.text(formattedValue);
			$input.val(value);

			if(value === 1){
				$unitSingular.show();
				$unitPlural.hide();
			} else {
				$unitSingular.hide();
				$unitPlural.show();
			}
		}
	};

	var addListener = function(){
		$element.on('submit', function(e){
			e.preventDefault();

			if(data[value]){
				window.location.href = data[value];
			}
		});

		$input.on('keydown', function(e){

			var steps = slider.steps()[0];
			var value = parseInt(slider.get());
			
			if (e.keyCode == 37 || e.keyCode == 40 || e.keyCode == 39 || e.keyCode == 38  ) {
				e.preventDefault();
				e.stopPropagation();
			}

			if (e.keyCode == 37 || e.keyCode == 40 ) {

				var position = steps[0];
				
                if (position === false) {
                    position = 1;
                }

                if (position !== null) {
                    slider.set(value - parseInt(position));
                }

			} else if (e.keyCode == 39 || e.keyCode == 38 ) {

				var position = steps[1];

				if (position === false) {
                    position = 1;
                }

                if (position !== null) {
                    slider.set(value + parseInt(position));
                }


			} else if (e.keyCode == 13) {
			
				e.preventDefault();
				e.stopPropagation();
			
			}
		});

	};

	var setSliderHandle = function(i, value) {
		var r = [null, null];
		r[i] = value;
		slider.set(r);
	};

	init();
	return api;
};

loop_app.ext['adverts'] = function($el) {
	var api = {};

	var $element = $el;

	var $adHtml = '';

	var init = function() {

		initWidths();

		// $element.find('.adsbygoogle').each(function(){
		// 	(adsbygoogle = window.adsbygoogle || []).push({});
		// });

	};

	var addListeners = function() {

	}

	var initWidths = function() {
		
		// $element.find('.adsbygoogle').each(function(){
		// 	$(this).css('width', $(this).parents('.js-ad-element-wrapper').width() + 'px');
		// });

	}

	init();
	addListeners();



	(function($,sr){

	  // debouncing function from John Hann
	  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
	  var debounce = function (func, threshold, execAsap) {
	      var timeout;

	      return function debounced () {
	          var obj = this, args = arguments;
	          function delayed () {
	              if (!execAsap)
	                  func.apply(obj, args);
	              timeout = null;
	          };

	          if (timeout)
	              clearTimeout(timeout);
	          else if (execAsap)
	              func.apply(obj, args);

	          timeout = setTimeout(delayed, threshold || 500);
	      };
	  }
	  // smartresize
	  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

	})(jQuery,'smartresize');

	// $(window).resize(function() {
	// 	$element.find('.adsbygoogle').css('display','none');
	// });

	// $(window).smartresize(function() {
	// 		initWidths();
	// 		$element.find('.adsbygoogle').each(function(){
	// 			$(this).removeAttr('data-adsbygoogle-status').css('display','block');
	// 			(adsbygoogle = window.adsbygoogle || []).push({});
	// 		});
	// });


	return api;
};

loop_app.ext['ajaxing'] = function($el) {
	var api = {};

	var $element = $el;
	var $form = $element.find('.js-ajaxing-form');
	var $filters = $element.find('.js-ajaxing-filter');
	var $content = $element.find('.js-ajaxing-content');

	var currentAjax;
	var lastParams;

	var init = function() {
		addListener();

		if(Modernizr.history){
			var params = getParams();
			window.history.replaceState({ajaxing: true, params: params}, '', window.location.href);
		}
	};

	var addListener = function(){
		$form.on('submit', function(e){
			e.preventDefault();
			loadContent();
		});

		$filters.on('change', function(){
			loadContent();
		});

		if(Modernizr.history){
			$(window).on('popstate', function(e){
				if(e.originalEvent.state && e.originalEvent.state.ajaxing){
					$filters.each(function(){
						var $filter = $(this);
						var params = e.originalEvent.state.params;
						var value = params[$filter.data('ajaxing-attribute') || ''];

						$filter.val(value);
						$filter.trigger('change');
					});

					loadContent(false);
				}
			});
		}
	};

	var loadContent = function(statechange){
		if(typeof statechange === 'undefined')
			statechange = true;

		var params = getParams();

		if(params == lastParams)
			return;

		lastParams = params;

		$element.addClass('is-loading');

		if(!Modernizr.history){
			window.location = window.location.pathname + '?' + $.param(params);
			return;
		}

		if(currentAjax){
			currentAjax.abort();
		}

		currentAjax = $.ajax({
			url: window.location.pathname,
			method: 'GET',
			data: params,
			success: function(data, textStatus, jqXHR){
				var $html = $(data);
				var $newContent = $html.find('.js-ajaxing-content').children();

				$content.children().velocity({
					opacity: 0
				}, {
					duration: 300,
					complete: function(){
						$element.removeClass('is-loading');

						$newContent.css('opacity', 0);

						$content.html($newContent);

						loop_app.initLocalExtensions($newContent);

						$content.children().velocity({
							translateY: [0, 20],
							opacity: [1, 0]
						}, {
							duration: 300,
							easing: 'easeOutQuart'
						});
					}
				});

				if(statechange){
					window.history.pushState({ajaxing: true, params: params}, '', this.url);
				}
			},
			error: function(){
				// TODO: error handling
			}
		});
	};

	var getParams = function(){
		var params = {};

		$filters.each(function(){
			var $filter = $(this);
			var value = $filter.val();

			if(value){
				params[$filter.data('ajaxing-attribute')] = value;
			}
		});

		return params;
	};

	init();
	return api;
};

loop_app.ext['arrival'] = function($el) {
	var api = {};

	var $element = $el;
	var $map = $element.find('.js-arrival-map');
	var $mapContainer = $element.find('.js-arrival-map-container');

	var map;
	var homeMarker;

	var lat = 47.792711;
	var lng = 13.003046;

	var init = function() {
		loop_app.initGoogleMaps();

		addListener();
		positionMap();
		initStates();
	};

	var initMap = function(){
		map = new google.maps.Map($map[0], {
			streetViewControl: false,
			mapTypeControl: false,
			scrollwheel: false,
			center: {
				lat: lat,
				lng: lng
			},
			zoom: 14,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_TOP
			},
			styles: mapStyles
		});

		renderHomePin();

		api.map = map;
	};

	var initStates = function(){
		enquire.register('screen and (min-width: 768px)', {
			match: function(){
				if(loop_app.googleMapsReady){
					initMap();
				} else {
					$(window).on('googleMapsReady', function(){
						initMap();
					});
				}
			}
		});
	};

	var addListener = function(){
		$(window).on('resize', _.debounce(function(){
			positionMap();
		}, 200));
	};

	var positionMap = function(){
		if($mapContainer.is(':visible')){
			var offset = $mapContainer.offset();

			$mapContainer.css({
				height: $element.outerHeight(),
				width: $element.outerWidth() - offset.left
			});

			if(map){
				google.maps.event.trigger(map, 'resize');
			}
		}
	};

	var renderHomePin = function(){
		homeMarker = new google.maps.Marker({
			map: map,
			cursor: 'grab',
			icon: {
				url: '/fileadmin/assets/img/marker/pin-home.svg',
				scaledSize: new google.maps.Size(34, 42),
			},
			zIndex: 10,
			optimized: false,
			position: {
				lat: lat,
				lng: lng
			}
		});
	};

	var isMapShowing = function(){
		return $(window).width() >= 768;
	};

	var mapStyles = [
		{
			"featureType": "administrative",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#444444"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "all",
			"stylers": [
				{
					"color": "#f2f2f2"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -100
				},
				{
					"lightness": 45
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit.station.airport",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"saturation": "-100"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"color": "#dfdfdf"
				},
				{
					"visibility": "on"
				}
			]
		}
	];


	init();
	return api;
};

loop_app.ext['autosize'] = function($el) {
	var api = {};

	var $element = $el;

	var init = function(){
		autosize($element);
	};

	init();
	return api;
};

loop_app.ext['booking'] = function($el) {
	var api = {};

	(function($) {
	    var origAppend = $.fn.prepend;

	    $.fn.append = function () {
	        return origAppend.apply(this, arguments).trigger("append");
	    };
	})(jQuery);

	var $element = $el;

	var $navigation = $element.find('.js-booking-nav');
	var $navigationWrapper = $element.find('.js-booking-nav-wrapper');
	var $navigationIndicator = $element.find('.js-booking-nav-indicator');
	var $navigationLinks = $element.find('.js-booking-nav-link');
	var $navigationItems = $element.find('.js-booking-nav-item');
	var $contentItems = $element.find('.js-booking-content-item');
	var $swiper = $element.find('.js-booking-swiper');

	var mySwiper;

	var init = function() {
		setTimeout(function(){
			// initSwiper();
			highlightActiveLink();
			addPaddingToLastLink();
			addListener();
			$contentItems.filter('.is-active').fadeIn(300).removeAttr('aria-hidden').removeAttr('inert').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');

			$navigationLinks.each(function(){
				var $link = $(this);

				$link.attr('tabindex', '0');
			});
		}, 1000);
	};

	var addListener = function(){
		$navigationLinks.on('mouseenter.header', function(e){
			var $link = $(this);
			repositionIndicator($(this).parent());
		});

		$navigationLinks.on('mouseleave.header', function(e){
			repositionIndicator($navigationItems.filter('.is-active'));
		});

		$navigationLinks.on('click', function(e){
			var $link = $(this);
			var key = getKey($link);

			// mySwiper.slideTo(mySwiper.slides.filter('[data-booking-target="'+key+'"]').index());
			if ($contentItems.filter('[data-booking-target="'+key+'"]').hasClass('is-active')) return;
			
			$contentItems.filter('.is-active')
			.removeClass('is-active')
			.fadeOut(300)
			.attr('inert','true')
			
			$navigationLinks.filter('.is-active').removeClass('is-active');
			
			setTimeout(function(){
				$link.addClass('is-active');
				$contentItems.filter('[data-booking-target="'+key+'"]')
				.addClass('is-active')
				.fadeIn(300)
				.removeAttr('aria-hidden')
				.removeAttr('inert')
				.find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
			
			}, 300);
		});

		$navigationLinks.on('keypress', function(e){
			if(e.which == 13){
				$(this).trigger('click');
			}
		});

		// $(window).on('resize', _.debounce(function(){
		// 	highlightActiveLink();
		// 	addPaddingToLastLink();
		// 	mySwiper.update();
		// }, 200));

		// $("body").on('DOMSubtreeModified', "#ypsnet-ibe", function() {
  //   		var lastheight = $('#ypsnet-ibe iframe').height();
  //   		setInterval(function(){
		// 	    if ($('#ypsnet-ibe iframe').height() != lastheight) {
		// 	        mySwiper.update();
		// 	        lastheight = $('#ypsnet-ibe iframe').height();
		// 	    }
		// 	}, 200);
		// });


	};

	var updateBookingSwiper = function() {
		// mySwiper.update();
	};

	var addPaddingToLastLink = function(){
		$navigationItems.last().css('margin-right', $navigationWrapper.css('padding-right'));
	};

	var getKey = function($tabOrSlide){
		return $tabOrSlide.data('booking-target');
	};

	var repositionIndicator = function($link){
		if (!$navigationIndicator.hasClass('dont-move')) {
			var width = 0;
			var left = 0;

			if(!$link || !$link.length){
				$link = $navigationLinks.filter('.is-active');
			}

			if($link.length){
				width = $link.width();
				// left = $link.position().left + parseFloat($link.css('padding-left')) + parseFloat($navigationWrapper.css('padding-left')) + Math.max(0, $navigationWrapper.offset().left);
				left = $link.position().left + parseFloat($link.css('padding-left')) + parseFloat($navigationWrapper.css('padding-left'));
			}

			$navigationIndicator.css({
				'-webkit-transform': 'translateX(' + left + 'px)',
				'-ms-transform': 'translateX(' + left + 'px)',
				'transform': 'translateX(' + left + 'px)',
				'width': width
			});
		}
	};
	
	var highlightActiveLink = function(){
		var $link = $navigationLinks.filter('.is-active');
	
		repositionIndicator($link);
	
		$navigation.animate({
			scrollLeft: Math.min($link.position().left, $navigation[0].scrollWidth - $navigation.width())
		}, {
			duration: 600,
		});
	};
	

	init();

	api.updateBookingSwiper = updateBookingSwiper;

	return api;
};

loop_app.ext['combinator'] = function($el) {
	var api = {};

	var $element = $el;
	var $image = $element.find('.js-combinator-image');
	var $imageElement = $element.find('.js-combinator-image-element');
	var $text = $element.find('.js-combinator-text');
	var $columns = $image.add($text);

	var direction = $element.data('direction');
	var resizeHandler;
	var disabled = true;

	var init = function() {
		initStates();
	};

	var initStates = function(){
		enquire.register('screen and (min-width: 1024px)', {
			match: function(){
				disabled = false;
				updateImage();

				$(window).on('resize.combinator', resizeHandler = _.debounce(function(){
					updateImage();
				}, 200));

				if($imageElement.is('img')){
					$imageElement.on('load.combinator', function(){
						$columns.matchHeight();
					});
				}
			},
			unmatch: function(){
				disabled = true;

				$(window).off('resize', resizeHandler);
				$columns.matchHeight({ remove: true });
				resetImage();

				if($imageElement.is('img')){
					$imageElement.off('load.combinator');
				}
			}
		});
	};

	var updateImage = function(){
		if(disabled){
			return;
		}

		var windowWidth = Math.min($(window).width(), 1600);

		if(direction == 'right'){
			$imageElement.css({
				right: 'auto',
				width: windowWidth / 2
			});
		} else {
			$imageElement.css({
				left: 'auto',
				width: windowWidth / 2
			});
		}

		$columns.matchHeight();
	};

	var resetImage = function(){
		$imageElement.css({
			right: '',
			left: '',
			width: '',
		});
	};

	init();
	return api;
};

loop_app.ext['cookie'] = function($el) {
	var api = {};

	var $element = $el;

	var init = function() {
		if(checkVisibility()){
			addListener();

			switchPosition();
			checkBottomPadding();
			lockContent();
		}

		if ($element.data('cookie-name') == 'salzburg_airport_cookie_accepted') {
			$('.js-cookie-disable').on('change', disableTracking);
		}
	};

	var checkVisibility = function(){
		var cookie = Cookies.get($element.data('cookie-name'));

		if(cookie == 1){
			$element.remove();

			if ($element.data('cookie-name') == 'salzburg_airport_cookie_accepted') {
				if (Cookies.get('salzburg_airport_cookie_disable_tracking') != 1) {
					// triggerTracking();
				}
			}

			return false;
		} else {
			$element.velocity('slideDown', {
				duration: 500,
				easing: 'easeOutQuart',
				complete: function(){

					if ($element.hasClass('noverlay')) {
						loop_app.setFocusableOverlayEls($element);

						$element.on('keydown', function(e) {
							loop_app.handleKeyDownOverlay(e, $element, 'cookie');
						});
						$('.js-site').attr('aria-hidden', 'true');
					}
				}
			});
			return true;
		}
	};

	var addListener = function(){
		$element.on('click', '.js-cookie-accept', function(e){
			e.preventDefault();

			var expiresAfter = $element.data('cookie-expires-after') || 365;

			Cookies.set($element.data('cookie-name'), '1', {expires: expiresAfter});

			var complete = function(){
				if ($element.hasClass('noverlay')) {
					$element.off('keydown');
					$('.js-site').removeAttr('aria-hidden');
				}
				
				$(this).remove();
				checkBottomPadding();
				unlockContent();
			};

			if($element.data('cookie-slideup')){
				$element.velocity('slideUp', {
					duration: 500,
					easing: 'easeOutQuart',
					complete: complete
				});
			} else {
				$element.velocity({
					translateY: 20,
					opacity: 0
				}, {
					duration: 300,
					easing: 'easeOutQuart',
					complete: complete
				});
			}

			if ($element.data('cookie-name') == 'salzburg_airport_cookie_accepted') {
				// triggerTracking();
			}
		});

		$(window).on('resize load', _.debounce(function(){
			checkBottomPadding();
			switchPosition();
		}, 200));
	};

	var disableTracking = function(e) {

		if ($('.js-cookie-disable').is(':checked')) {
			Cookies.remove('salzburg_airport_cookie_disable_tracking');

			// triggerTracking();
			
		} else {
			var expiresAfter = $element.data('cookie-expires-after') || 365;
			Cookies.set('salzburg_airport_cookie_disable_tracking', '1', {expires: expiresAfter});
		}

		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		return false;
	};

	var triggerTracking =  function() {

		if (!(window.location.host == 'test.salzburg-airport.com' || window.location.host.indexOf(".local") >= 0 || window.location.host.indexOf(".devlocal") >= 0 )) {
			var _gaq = _gaq || [];
			_gaq.push(['_setAccount', 'UA-22124891-1']);
			_gaq.push(['_gat._anonymizeIp']);
			_gaq.push(['_trackPageview']);

			(function() {
				var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
				ga.src = "https://www.googletagmanager.com/gtag/js?id=UA-22124891-1";
				var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
			})();

			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());
			
			gtag('config', 'UA-22124891-1', { 'anonymize_ip': true });
		}
	};

	var switchPosition = function(){
		if(!$element.data('cookie-switch-position')){
			return;
		}

		if($(window).width() >= 1280){
			$element.prependTo('.js-site');
		} else {
			$element.prependTo('.js-site-content');
		}

	};

	var checkBottomPadding = function(){
		if(!$element.data('cookie-push')){
			return;
		}

		var height = $element.outerHeight() || '';

		if($(window).width() >= 768){
			height = '';
		}

		$('.js-site, .js-overlay-inner').css('margin-bottom', height);
	};

	var lockContent = function(){
		if(!$element.data('cookie-overlay')){
			return;
		}

		var $site = $('.js-site');

		$site.css({
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			height: '100%',
			overflow: 'hidden',
		});
	};

	var unlockContent = function(){
		if(!$element.data('cookie-overlay')){
			return;
		}

		var $site = $('.js-site');

		$site.css({
			position: '',
			top: '',
			left: '',
			right: '',
			height: '',
			overflow: '',
		});
	};

	var closeOverlay = function(){
		$element.find('.js-cookie-accept').trigger('click');
	}

	api.closeOverlay = closeOverlay;
	init();
	return api;
};

loop_app.ext['datepicker'] = function($el) {
	var api = {};

	var $element = $el;
	var direction = $element.data('datepicker-direction');
	var offset = $element.data('datepicker-offset') || 0;
	var isInitial = true;

	var init = function(){
		
		var isParkingDatepicker = $element.hasClass('js-datepicker-parking');

		if(Modernizr.touch && ($('html').hasClass('mobile') || $('html').hasClass('tablet'))) {
			$element.attr('type', 'date');

			if (isParkingDatepicker) {
				$element.on($('html').hasClass('android') ? 'change' : 'blur', dateChanged);
			}

			return;
		} else {
			if (isParkingDatepicker) {
				$element.on('change', dateChanged);
			}
		}

		var startDate = moment($element.attr('data-start-date'), 'YYYY-MM-DD');

		if ($element.attr('name') == 'data[entry-date]' || $element.attr('name') == 'data[exit-date]') {
			startDate = moment();
			
		}

		$element.attr('data-start-date', startDate.format('DD.MM.YYYY'));

		loop_app.createA11yButton($element.get(0));
		$element.attr('readonly', 'readonly');

		/* $element.on('keydown', function(e) {
			e.preventDefault();
		}); */

		let focusTrap = null;

		$element.dateRangePicker({
			singleDate: true,
			singleMonth: true,
			autoClose: true,
			format: isParkingDatepicker ? 'DD/MM/YYYY' : 'DD.MM.YYYY',
			showTopbar: false,
			showTime: true,
			startOfWeek: 'monday',
			extraClass: direction == 'left' ? 'date-picker--left' : 'date-picker--bottom',
			language: loop_app.language,
			startDate: startDate.isValid() && startDate.format(isParkingDatepicker ? 'DD/MM/YYYY' : 'DD.MM.YYYY'),
			customOpenAnimation: function(cb){
				$(this).css('display', 'block');
				$(this).velocity({
					translateY: [0, 10],
					opacity: [1, 0]
				}, {
					duration: 200,
					complete: cb,
					display: 'block'
				});
			},
			customCloseAnimation: function(cb){
				$(this).velocity({
					translateY: 10,
					opacity: 0
				}, {
					duration: 200,
					complete: cb,
					display: 'none'
				});
			},
			setValue: function(s){
				if(!$(this).is(':disabled') && s != $(this).val()){
					$(this).val(s).trigger('input').trigger('keyup').trigger('change');
				}
			},
		})
		.bind('datepicker-open',function(){
			focusTrap = loop_app.initDateRangePickerTabNav($element);
		}).bind('datepicker-close',function(){
			if(focusTrap){
				focusTrap.deactivate();
			}
		})

		$element.on('datepicker-open', function(){
			calcPosition($element);
		});

		$(window).on('resize', resizeHandler);

		$element.on('updatedatepicker', function(){
			reInit();
		});
	};

	var dateChanged = function() {
		var end_date = $(this).parents('.js-form').find('.js-datepicker[name="data[exit-date]"]');
		var end_time = $(this).parents('.js-form').find('.js-timepicker[name="data[exit-time]"]');
		
		var timepicker_el = $(this).parent().parent().find('.js-timepicker');

		now = moment();
		var roundUp = now.minute() || now.second() || now.millisecond() ? now.add(1, 'hour').startOf('hour') : now.startOf('hour');
		now.add(1, 'hours').format('HH:mm');

		if (isInitial) {
			if (moment().isSame(moment($(this).val(), 'DD/MM/YYYY'), 'day')) {
				timepicker_el.val(roundUp.format('HH:mm')).removeAttr('disabled').parent().removeClass('is-disabled');
				end_time.val(roundUp.add(30, 'minutes').format('HH:mm')).removeAttr('disabled').parent().removeClass('is-disabled');
			} else {
				timepicker_el.val(roundUp.format('HH:mm')).removeAttr('disabled').parent().removeClass('is-disabled');
				end_time.val(roundUp.add(30, 'minutes').format('HH:mm')).removeAttr('disabled').parent().removeClass('is-disabled');
			}

			end_date.val($(this).val()).removeAttr('disabled').parent().removeClass('is-disabled');

			isInitial = false;
		}
	}
	var resizeHandler = _.debounce(function(){
		if($element.is(':hidden')){
			$element.data('dateRangePicker').close();
		} else {
			calcPosition($element);
		}
	}, 200);

	var destroy = function(){
		if(Modernizr.touch){
			$element.attr('type', 'text');
			return;
		}

		$element.data('dateRangePicker').destroy();
		$element.off('datepicker-open');
		$element.off('updatedatepicker');
		$(window).off('resize', resizeHandler);
	};

	var reInit = function(){
		destroy();
		init();
	};

	var calcPosition = function($input){
		var dateRangePicker = $input.data('dateRangePicker');
		var $datePicker = dateRangePicker.getDatePicker();
		var inputOffset = $input.offset();
		var windowWidth = $(window).width();

		$datePicker.find('.time').hide();
		$datePicker.find('.month-wrapper').css('width', '');

		$datePicker.removeClass('inline-wrapper');

		if(direction === 'left'){
			$datePicker.css({
				position: 'absolute',
				top: inputOffset.top,
				left: 'auto',
				right: windowWidth - inputOffset.left + 10 - offset
			});
		} else {
			$datePicker.css({
				position: 'absolute',
				top: inputOffset.top + $input.outerHeight() + 10 + offset,
				left: inputOffset.left,
			});
		}
	};

	var closeOverlay = function($date) {
		$element.data('dateRangePicker').close();
	}

	api.closeOverlay = closeOverlay;

	init();
	return api;
};

loop_app.ext['daterangepicker'] = function($el) {
	var api = {};

	var $element = $el;
	var $from = $element.find('.js-daterangepicker-from');
	var $to = $element.find('.js-daterangepicker-to');
	var $inputs = $from.add($to);
	var direction = $element.data('daterangepicker-direction');

	var init = function(){
		if(Modernizr.touch){
			$to.add($from).attr('type', 'date');
			return;
		}

		$to.add($from).each(function(){
			var $input = $(this);

			loop_app.createA11yButton($input.get(0));
			$input.attr('readonly', 'readonly');
	
			let focusTrap = null;

			$input.dateRangePicker({
				singleMonth: true,
				autoClose: true,
				format: 'DD.MM.YYYY',
				showTopbar: false,
				startOfWeek: 'monday',
				separator: ' to ',
				inline: true,
				hoveringTooltip: false,
				language: loop_app.language,
				extraClass: direction == 'left' ? 'date-picker--left' : 'date-picker--bottom',
				customOpenAnimation: function(cb){
					$(this).css('display', 'block');
					$(this).velocity({
						translateY: [0, 10],
						opacity: [1, 0]
					}, {
						duration: 200,
						complete: cb,
						display: 'block'
					});
				},
				customCloseAnimation: function(cb){
					$(this).velocity({
						translateY: 10,
						opacity: 0
					}, {
						duration: 200,
						complete: cb,
						display: 'none'
					});
				},
				getValue: function(){
					if ($from.val() && $to.val() ){
						return $from.val() + ' to ' + $to.val();
					} else {
						return '';
					}
				},
				setValue: function(s, s1, s2){
					$from.val(s1).trigger('input');
					$to.val(s2).trigger('input');
				}
			})
			.bind('datepicker-open',function(){
				focusTrap = loop_app.initDateRangePickerTabNav($input);
			})
			.bind('datepicker-close',function(){
				if(focusTrap){
					focusTrap.deactivate();
				}
			});

			$input.on('datepicker-open', function(){
				calcPosition($input);
			});

			$(window).on('resize', _.debounce(function(){
				if($input.is(':hidden')){
					$input.data('dateRangePicker').close();
				} else {
					calcPosition($input);
				}

			}, 200));
		});
	};

	var calcPosition = function($input){
		var dateRangePicker = $input.data('dateRangePicker');
		var $datePicker = dateRangePicker.getDatePicker();
		var elementOffset = $element.offset();
		var inputOffset = $input.offset();

		$datePicker.find('.time').hide();
		$datePicker.find('.month-wrapper').css('width', '');

		$datePicker.removeClass('inline-wrapper');


		if(direction === 'left'){
			$datePicker.css({
				position: 'absolute',
				top: elementOffset.top,
				left: elementOffset.left - $datePicker.outerWidth() - 10,
			});
		} else {
			$datePicker.css({
				position: 'absolute',
				top: inputOffset.top + $input.outerHeight() + 10,
				left: elementOffset.left,
			});
		}

	};

	init();
	return api;
};

loop_app.ext['destination-list-table'] = function($el) {
	var api = {};

	var $element = $el;
	var $body = $element.find('.js-destination-list-table-body');
	var $overlay = $('.js-overlay');

	var template = _.template($element.find('.js-city').html());
	var width = 0;
	var init = function(){
		addListener();
	};

	var addListener = function(){
		$element.on('keypress', '.js-destination-list-table-row[data-href]', function(e){
			if(e.which == 13){
				$(this).trigger('click');
			}
		});

		$element.on('click', '.js-destination-list-table-row[data-href]', function(){
			var url =
			$overlay.data('obj_overlay').load($(this).data('href'));
		});

		// //window width change
		// var width = $(window).width();
		// $(window).on('resize', function(){
		//    if($(this).width() != width){
		//       width = $(this).width();
		//       $('.js-destination-list-table-body-columns').html('');
		// 		$body.show();
		// 		setTimeout(function() { initColumnizer(); }, 500);
		//    }
		// });
	};

	var fillDestinationList = function(data){
		if(data.length){
			var html = '';
			var $rows;

			_.forEach(data, function(row){
				html += template(row);
			});

			$rows = $(html).filter(':not(text)');
			loop_app.initLocalExtensions($rows);

			$body.html($rows);
			$element.removeClass('is-empty');

			$rows.each(function(){
				var $row = $(this);

				$row.attr('tabindex', '0');
			});

			// if ($('html').hasClass('ios')) {
			// 	initColumnizer();
			// }

		} else {
			empty();
		}
	};

	var initColumnizer = function() {
		if ($(window).width() < 768) {
			$body.columnize({columns: 2, target: '.js-destination-list-table-body-columns'});
		} else if ($(window).width() < 1024) {
			$body.columnize({columns: 3, target: '.js-destination-list-table-body-columns'});
		} else {
			$body.columnize({columns: 4, target: '.js-destination-list-table-body-columns'});
		}

		$body.hide();
	}

	api.fillDestinationList = fillDestinationList;

	var empty = function(){
		$body.html();
		$element.addClass('is-empty');
	};
	api.empty = empty;

	init();
	return api;
};

loop_app.ext['destination-list'] = function($el) {
	var api = {};

	var $element = $el;
	var $table = $element.find('.js-destination-list-table');
	var $loader = $element.find('.js-destination-list-loader');

	var $continentSelect = $element.find('.js-destination-list-select-continent');
	var $landSelect = $element.find('.js-destination-list-select-land');
	var $directOnlyCheck = $element.find('.js-destination-list-direct-only');

	var templateContinentSelect = _.template($element.find('.js-destination-list-continent-select-template').html());
	var templateLandSelect = _.template($element.find('.js-destination-list-land-select-template').html());

	var $legend = $element.find('.js-destination-list-legend');

	var $filter = $element.find('.js-new-filter');

	var $search = $element.find('.js-destination-filter-search');
	var $filterForm = $element.find('.js-destination-filter-form');

	var filterContinent = '';
	var filterLand = '';
	var filterDirectOnly = false;
	var filterSearch = false;

	var init = function(){
		loadDestinaitonList();
		addListeners();
	};

	var filter = function() {
		// TODO: scoping issue, rewrite to $elment descendants

		$('.js-destination-list-table-row').removeClass('is-hidden');

		if (filterContinent !== '') {
			$('.js-destination-list-table-row[data-continent!="' + filterContinent + '"]').addClass('is-hidden');
		}

		if (filterLand !== '') {
			$('.js-destination-list-table-row[data-land!="' + filterLand + '"]').addClass('is-hidden');
		}

		if (filterDirectOnly == true) {
			$('.js-destination-list-table-row[data-is-direct!="true"]').addClass('is-hidden');
		}

		if (filterSearch != '') {
			$('.js-destination-list-table-row').each(function() {
				if ($(this).find('.js-table-city').length > 0) {
					if ( !$(this).find('.js-table-city').html().match(new RegExp(filterSearch,'i'))) {
						$(this).addClass('is-hidden');
					}
				}
			});
		}

		$('.js-destination-list-table-row').each(function(){
			if ($(this).hasClass('is-hidden')) {
				$(this).hide(0);
			} else {
				$(this).show(0);
			}
		});

		if ($('.js-destination-list-table-row:visible').length == 0){
			$table.addClass('is-empty');
		} else {
			$table.removeClass('is-empty');
		}

		$(window).trigger('scroll');
	};

	var addListeners = function() {
		$landSelect.on('change', landSelectChangeHandler);
		$continentSelect.on('change', continentSelectChangeHandler);

		$directOnlyCheck.on('change', directOnlyCheckChengeHandler);

		$search.on('keypress', searchKeyPressHandler);
		$search.on('blur change', search);

		$filterForm.on('submit', function(e){
			e.preventDefault();

			filter();
		});

		$(window).on('scroll', destinationListScrollHandler);
		$(window).on('resize', destinationListScrollHandler);
	};

	var loadDestinaitonList = function(url){
		if(!$element.data('api') && !url){
			return;
		}
		$loader.addClass('is-visible');

		$.ajax({
			url: $element.data('api'),
			success: function(data){

				fillTable(data);
				fillFilter(data);

				$loader.removeClass('is-visible');

				$(window).trigger('scroll');
			},
			error: function(){
				// TODO: error handling
				console.error(arguments);
				$loader.removeClass('is-visible');
			}
		});
	};

	var fillTable = function(data){
		$table.data('obj_destinationListTable').fillDestinationList(data);
	};

	var fillFilter = function(data) {
		if(data.length){
			var htmlContinent = '';
			var htmlLand = '';
			var $rowsContinent;
			var $rowsLand;

			var distinctContinents = _.orderBy(_.uniqBy(data, 'continent'), 'continent');
			var distinctLands = _.orderBy(_.uniqBy(data, 'land'), 'land');

			_.forEach(distinctContinents, function(row){
				htmlContinent += templateContinentSelect(row);
			});
			_.forEach(distinctLands, function(row){
				htmlLand += templateLandSelect(row);
			});
			$rowsContinent = $(htmlContinent).filter(':not(text)');
			$rowsLand = $(htmlLand).filter(':not(text)');

			$continentSelect.append($rowsContinent);
			$landSelect.append($rowsLand);
		}
	};

	var continentSelectChangeHandler = function(evt) {
		$landSelect.find('option').removeAttr('disabled');

		filterContinent = $(evt.currentTarget).val() || '';

		if (filterContinent !== "") {
			$landSelect.find('option[data-continent!="'+filterContinent+'"][value!=""][value!="*"]').attr('disabled','disabled');
		}

		if ($landSelect.hasClass('select2-hidden-accessible')) {
			$landSelect.select2("destroy");
			$landSelect.val('');
			$landSelect.removeData('oldTabindex');
			$filter.data('obj_new-filter').initSelect2($landSelect);
		} else {
			$landSelect.val('');
		}

		filterLand = "";

		filter();
	};

	var landSelectChangeHandler = function(evt) {
		if (evt.currentTarget) {
			filterLand = $(evt.currentTarget).val() || '';
		}

		filter();
	};

	var directOnlyCheckChengeHandler = function() {
		filterDirectOnly = $(this).is(':checked');

		filter();
	};

	var destinationListScrollHandler = function(e) {
		if ($(window).width() < 1279) {
			var currentScroll = $(this).scrollTop();

			var helper = $table.offset().top - $element.find('.destination-list__title__wrapper').offset().top;

			if ((currentScroll + $(window).height()) > ($table.outerHeight() + $table.offset().top + 50)) {
				$legend.addClass('is-stopped').css('top',($table.outerHeight() + 50 + helper - $legend.outerHeight()) + 'px');
			} else {
				$legend.removeClass('is-stopped').removeAttr('style');
			}

			if (currentScroll + $(window).height() < $table.offset().top + 150) {
				$legend.addClass('is-stopped').css('top',(150 + helper - $legend.outerHeight()) + 'px');
			} else {

			}

		} else {
			$legend.removeClass('is-stopped').removeAttr('style');
		}
	};

	var searchKeyPressHandler = function(e) {
		if(e.which == 13) {
			e.preventDefault();
			$(this).blur();
		}
	};

	var search = function() {
		filterSearch = makeComp($(this).val());
		filter();
	};

	//deaccent - used when searching
	var accents = {
		a: 'àáâãäåæ',
		c: 'ç',
		e: 'èéêëæ',
		i: 'ìíîï',
		n: 'ñ',
		o: 'òóôõöø',
		s: 'ß',
		u: 'ùúûü',
		y: 'ÿ'
	},
	chars = /[aceinosuy]/g;

	var makeComp = function(input) {
		return input.replace(chars, function(c){
			return '[' + c + accents[c] + ']';
		});
	};


	init();
	return api;
};

loop_app.ext['dotdotdot'] = function($el) {
	var api = {};

	var $element = $el;

	var wrap = ($element.data('wrap') ? $element.data('wrap') : 'word'); 

	var init = function() {
		$element.dotdotdot({
			watch: "window",
			wrap: wrap
		});
	};

	init();
	return api;
};

loop_app.ext['email-content'] = function($el) {
	var api = {};

	var $element = $el;

	var init = function() {
		var content = $element.html().trim();

		if(content){
			try {
				$element.html(atob(loop_app.rot13(content)));
				$element.addClass('is-done');
			} catch(error){
				console.error('could not email decode the following item, set it to display none', $element);
				$element.hide();
			}
		}
	};

	init();
	return api;
};

loop_app.ext['email-href'] = function($el) {
	var api = {};

	var $element = $el;

	var init = function() {
		var href = $element.attr('data-href');

		if(href){
			try {
				$element.attr('href', atob(loop_app.rot13(href)));
			} catch(error){
				console.error('could not email decode the following item, set it to display none', $element);
				$element.hide();
			}
		}
	};

	init();
	return api;
};

loop_app.ext['faq'] = function($el) {
	var api = {};

	var $element = $el;
	var $questions = $element.find('.js-faq-question');
	var $answer = $element.find('.js-faq-question-answer');
	var $search = $element.find('.js-faq-search');
	var $notFound = $element.find('.js-faq-not-found');
	var $reset = $element.find('.js-faq-reset');

	var init = function() {
		addListener();

		$questions.each(function(){
			$(this).attr('tabindex', '0');
		});
	};

	var addListener = function() {
		$questions.on('click', function(e){

			var donttoggle = ($(e.target).hasClass('form__checkbox__text') || $(e.target).hasClass('js-cookie-disable'));

			if (!donttoggle) {
				toggle($(this));
			}
		});

		$questions.on('keypress', function(e){
			if(e.which == 13){
				$(this).trigger('click');
			}
		});

		$search.on('input', _.debounce(searchEventHandler, 200));

		$reset.on('click', function(e){
			e.preventDefault();
			$search.val('');
			$search.trigger('input');
		});
	};

	var searchEventHandler = function() {
		var query = $(this).val().toLowerCase().trim();

		if (query !== '') {
			$questions.removeClass('is-found');
			$questions.unmark();

			$questions.mark(query, {
				each: function(mark){
					$(mark).closest('.js-faq-question').addClass('is-found');
				},
				done: function(){
					var $foundQuestions = $questions.filter('.is-found');
					var $notfoundQuestions = $questions.not('.is-found');

					$foundQuestions.each(function(){
						var $question = $(this);

						open($question);
						unhide($question);
					});

					$notfoundQuestions.each(function(){
						var $question = $(this);

						close($question);
						hide($question);
					});

					if(!$foundQuestions.length){
						showNotFound();
					} else {
						hideNotFound();
					}
				}
			});
		} else {
			$questions.unmark();
			unhideAll();
			closeAll();
			hideNotFound();
		}
	};

	var toggle = function($question){
		if($question.hasClass('is-active')){
			close($question);
		} else {
			$questions.filter('.is-active').each(function() {
				close($(this));
			});
			open($question);
		}
	};

	var open = function($question){
		if($question.hasClass('is-active'))
			return;

		var $answer = $question.find('.js-faq-question-answer');
		$question.addClass('is-active');

		if($question.hasClass('is-hidden')){
			$answer.show();
		} else {
			$answer.velocity('slideDown', { duration: 300 });
		}

	};

	var close = function($question){
		if(!$question.hasClass('is-active'))
			return;

		$question.removeClass('is-active').find('.js-faq-question-answer').velocity('slideUp', { duration: 300 });
	};

	var closeAll = function(){
		$questions.each(function(){
			close($(this));
		});
	};

	var hide = function($question){
		if($question.hasClass('is-hidden'))
			return;

		$question.addClass('is-hidden').velocity('slideUp', { duration: 300 });
	};

	var unhide = function($question){
		if(!$question.hasClass('is-hidden'))
			return;

		$question.removeClass('is-hidden').velocity('slideDown', { duration: 300 });
	};

	var unhideAll = function(){
		$questions.each(function(){
			unhide($(this));
		});
	};

	var showNotFound = function(){
		if($notFound.is(':visible'))
			return;

		$notFound.velocity('slideDown', { duration: 300 });
	};

	var hideNotFound = function(){
		if($notFound.is(':hidden'))
			return;

		$notFound.velocity('slideUp', { duration: 300 });
	};

	init();
	return api;
};

loop_app.ext['filter'] = function($el) {
	var api = {};

	var $element = $el;

	var $date = $element.find('.js-filter-datepicker');
	var $dateValue = $element.find('.js-filter-date-value');
	var $select = $element.find('.js-filter-select');

	var $mobileFilterTrigger = $element.find('.js-filter-mobile-trigger');
	var $filterForm = $element.find('.js-filter-form');

	var $searchTrigger = $element.find('.js-filter-search-trigger');
	var $searchWrapper = $element.find('.js-filter-search-wrapper');
	var $searchInput = $element.find('.js-filter-search-input');
	var $searchClose = $element.find('.js-filter-search-close');
	var $search = $element.find('.js-filter-search');

	var $destinationLegend = $('.js-destination-list-legend');
	var $destinationTable = $('.js-destination-list-legend');
	var $destinationList = $('.js-destination-list');

	var init = function() {
		initDropdowns();
		initDatepicker();
		addListener();
	};

	var addListener = function(){
		$mobileFilterTrigger.on('click', mobileFilterTriggerClickListener);
		$select.on('change', filterSelectChangeHandler);

		$searchTrigger.on('click', searchTriggerClickHandler);
		$searchClose.on('click', searchCloseClickHandler);

		$(window).on('resize', _.debounce(function(){
			if($(window).width() >= 1024){
				$filterForm.css('display', '');
			}
		}));
	};

	var initDatepicker = function(e) {
		if(!$date.length)
			return;

		if(Modernizr.touch){
			$date.attr('type', 'date');
			$date.parent().addClass('inited');
			return;
		}

		$date.dateRangePicker({
			singleDate:true,
			singleMonth:true,
			autoClose: true,
			format: 'YYYY-MM-DD',
			defaultTime: moment().startOf('day').toDate(),
			endDate: moment().startOf('day').toDate(),
			showTopbar: false,
			startOfWeek: 'monday',
			language: loop_app.language,
			extraClass: $(window).width() > 1024 ? 'date-picker--noise' : '',
			customOpenAnimation: function(cb){
				$(this).find('.month-wrapper').css('width', '');
				$(this).css('display', 'block');
				$(this).velocity({
					translateX: [-90, -90],
					translateY: [0, 10],
					opacity: [1, 0]
				}, {
					duration: 200,
					complete: cb,
					display: 'block'
				});
			},
			customCloseAnimation: function(cb){
				$(this).velocity({
					translateY: 10,
					opacity: 0
				}, {
					duration: 200,
					complete: cb,
					display: 'none'
				});
			},
		})
		.bind('datepicker-close',function(){
			if ($date.val()) {
				var value = $date.val();
				var formattedValue = moment(value).format('DD. MMMM YYYY');

				$dateValue.html(formattedValue);
			}
			$date.parent().removeClass('active');
		})
		.bind('datepicker-open',function(){
			$date.parent().addClass('active');
		});

		$date.parent().addClass('inited');
	};

	var initDropdowns = function() {
		// show default select on touch devices
		if(Modernizr.touch){
			$select.wrap('<div class="filter__select-wrap" />');

			$select.on('change', function(e){
				var $s = $(this);

				if($s.val() == '*'){
					e.preventDefault();
					$s.val('');
					$s.trigger('change');
				}
			});

			$select.each(function(){
				var $s = $(this);
				var $emptyOption = $s.find('option[value=""]');

				if($emptyOption.length && $s.attr('placeholder')){
					$emptyOption.html($s.attr('placeholder'));
					$emptyOption.prop('disabled', true);
				}
			});

			return;
		}

		$.each( $select, function( index, value ) {
			initSelect2(this);
		});
	};

	var initSelect2 = function(select) {
		var $input = $(select);

		$input.select2({
			theme: 'filter',
			width: 'auto',
			placeholder: $input.attr('placeholder'),
			dropdownAutoWidth: true,
			minimumResultsForSearch: Infinity,
		});

		$input.on('select2:selecting', function(e){
			if(e.params.args.data.id == '*'){
				e.preventDefault();
				$input.val('');
				$input.trigger('change');
				select2.close();
			}
		});

		var select2 = $input.data('select2');

		select2.dropdown._positionDropdown = function(){
			var $window = $(window);

			var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
			var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

			var newDirection = null;

			var offset = this.$container.offset();

			offset.bottom = offset.top + this.$container.outerHeight(false);

			var container = {
				height: this.$container.outerHeight(false)
			};

			container.top = offset.top;
			container.bottom = offset.top + container.height;

			var dropdown = {
				height: this.$dropdown.outerHeight(false)
			};

			var viewport = {
				top: $window.scrollTop(),
				bottom: $window.scrollTop() + $window.height()
			};

			var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
			var enoughRoomBelow = true;
			// var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

			var css = {
				left: offset.left,
				top: container.bottom
			};

			// Determine what the parent element is to use for calciulating the offset
			var $offsetParent = this.$dropdownParent;

			// For statically positoned elements, we need to get the element
			// that is determining the offset
			if ($offsetParent.css('position') === 'static') {
				$offsetParent = $offsetParent.offsetParent();
			}

			var parentOffset = $offsetParent.offset();

			css.top -= parentOffset.top;
			css.left -= parentOffset.left;

			if (!isCurrentlyAbove && !isCurrentlyBelow) {
				newDirection = 'below';
			}

			if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
				newDirection = 'above';
			} else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
				newDirection = 'below';
			}

			if (newDirection == 'above' ||
				(isCurrentlyAbove && newDirection !== 'below')) {
				css.top = container.top - parentOffset.top - dropdown.height;
			}

			if (newDirection !== null){
				this.$dropdown
					.removeClass('select2-dropdown--below select2-dropdown--above')
					.addClass('select2-dropdown--' + newDirection);
				this.$container
					.removeClass('select2-container--below select2-container--above')
					.addClass('select2-container--' + newDirection);
			}

			this.$dropdownContainer.css(css);
		};

		select2.dropdown._showDropdown = function (decorated) {
			select2.dropdown.$dropdownContainer.find('.select2-dropdown').css('visibility', 'hidden');
			select2.dropdown.$dropdownContainer.appendTo(select2.dropdown.$dropdownParent);

			select2.dropdown._positionDropdown();
			select2.dropdown._resizeDropdown();

			window.setTimeout(function(){
				var $dropdown = select2.dropdown.$dropdownContainer.find('.select2-dropdown');

				select2.dropdown.$dropdownContainer.find('.select2-dropdown').velocity({
					opacity: [1, 0],
					translateY: [0, 10]
				}, {
					duration: 300,
					visibility: 'visible',
					easing: 'easeOutQuart',
					display: 'block'
				});
			}, 10);
		};

		select2.dropdown._hideDropdown = function(){
			select2.dropdown.$dropdownContainer.find('.select2-dropdown').velocity({
				opacity: 0,
				translateY: 10
			}, {
				duration: 300,
				complete: function(){
					select2.dropdown.$dropdownContainer.detach();
				},
				visibility: 'hidden',
				display: 'block'
			});
		};

		// $input.next().find('.select2-selection__rendered').addClass('gray');
		filterSelect2ManageGray($input);

		$input.on('select2:select', function (e) {
			screenReaderFix($input);
		});

		setTimeout(function(){
			screenReaderFix($input);
		},500);
	};

	var screenReaderFix = function($input){
		if ($input.data('prepend')) {
			$input.next().find('.select2-selection__rendered').prepend('<span class="u-sr-only">'+ $input.data('prepend') + '</span>');
		} else if ($input.data('placeholder') && !$input.find('option:selected').attr('hidden')) {;
			$input.next().find('.select2-selection__rendered').prepend('<span class="u-sr-only">'+ $input.data('placeholder') + '</span>');
		}
	};

	var mobileFilterTriggerClickListener = function() {
		if ($(window).width() < 1024) {
			$mobileFilterTrigger.toggleClass('active');
			$filterForm.toggleClass('active');

			if ($element.hasClass('filter--destination-list')) {
				var helper = $destinationTable.offset().top - $destinationList.find('.destination-list__title__wrapper').offset().top;

				if($filterForm.hasClass('active')){

					var filterFormHeight = $filterForm.show().height();
					$filterForm.hide();

					$filterForm.velocity('slideDown');
					if ($destinationLegend.hasClass('is-stopped')) {
						$destinationLegend.filter('.is-stopped').velocity({
							top: ($destinationTable.outerHeight() + helper - $destinationLegend.outerHeight() + filterFormHeight),
						}, {
							duration: 400
						});
					}
				} else {
					$filterForm.velocity('slideUp');
					if ($destinationLegend.hasClass('is-stopped')) {
						$destinationLegend.filter('.is-stopped').velocity({
							top: ($destinationTable.outerHeight() + helper - $destinationLegend.outerHeight() - $filterForm.height()),
						}, {
							duration: 400
						});
					}
				}
			} else {
				if($filterForm.hasClass('active')){
					$filterForm.velocity('slideDown');
				} else {
					$filterForm.velocity('slideUp');
				}
			}
		}
	};

	var filterSelectChangeHandler = function(evt) {
		filterSelect2ManageGray($(evt.currentTarget));
	};

	var filterSelectManageGray = function(el) {
		if ($(el).val() != 'all') {
			$(el).removeClass('gray');
		} else {
			$(el).addClass('gray');
		}
	};


	var filterSelect2ManageGray = function(el) {
		if (el.val() != 'all') {
			el.next().find('.select2-selection__rendered').removeClass('gray');
			el.removeClass('gray');
		} else {
			el.next().find('.select2-selection__rendered').addClass('gray');
			el.addClass('gray');
		}
	};

	var searchTriggerClickHandler = function() {
		if (!$searchWrapper.hasClass('is-active')) {
			$searchWrapper.addClass('is-active');
			$search.focus();
			if ($(window).width() < 1024) {

				var searchInputHeight = $searchInput.show().height();
				$searchInput.hide();

				$searchInput.velocity('slideDown');

				if ($destinationLegend.hasClass('is-stopped')) {

					var helper = $destinationTable.offset().top - $destinationList.find('.destination-list__title__wrapper').offset().top;

					$destinationLegend.filter('.is-stopped').velocity({
						top: ($destinationTable.outerHeight() + helper - $destinationLegend.outerHeight() + searchInputHeight),
					}, {
						duration: 400
					});
				}
			}

		} else {
			$searchClose.trigger('click');
		}
	};

	var searchCloseClickHandler = function() {
		$searchWrapper.removeClass('is-active');
		$search.val('').blur();

		if ($(window).width() < 1024) {

			$searchInput.velocity('slideUp');

			var helper = $destinationTable.offset().top - $destinationList.find('.destination-list__title__wrapper').offset().top;

			if ($destinationLegend.hasClass('is-stopped')) {
				$destinationLegend.filter('.is-stopped').velocity({
					top: ($destinationTable.outerHeight() + helper - $destinationLegend.outerHeight() - $searchWrapper.height()),
				}, {
					duration: 400
				});
			}
		}
	};

	api.initSelect2 = initSelect2;
	api.filterSelectManageGray = filterSelectManageGray;
	init();
	return api;
};

loop_app.ext['filterable'] = function($el) {
	var api = {};

	var $element = $el;
	var $filters = $element.find('.js-filterable-filter');
	var $form = $element.find('.js-filterable-form');
	var $search = $element.find('.js-filterable-search');
	var $items = $element.find('.js-filterable-item');
	var $notFound = $element.find('.js-filterable-not-found');

	var init = function() {
		saveInitialFilterOptions();
		addListener();
	};

	var saveInitialFilterOptions = function(){
		$filters.each(function(){
			var $filter = $(this);

			$filter.data('options', $filter.children().clone());
		});
	};

	var addListener = function(){
		$filters.on('change', function(){
			filterItems();
		});

		$search.on('change', function(){
			filterItems();
		});

		$form.on('submit', function(e){
			e.preventDefault();
		});
	};
	
	var screenReaderFix = function($input){

		console.log($input.data('placeholder') && !$input.find('option:selected').attr('hidden'));

		if ($input.data('prepend')) {
			$input.next().find('.select2-selection__rendered').prepend('<span class="u-sr-only">'+ $input.data('prepend') + '</span>');
		} else if ($input.data('placeholder') && !$input.find('option:selected').attr('hidden')) {
			console.log($input.data('placeholder'));
			$input.next().find('.select2-selection__rendered').prepend('<span class="u-sr-only">'+ $input.data('placeholder') + '</span>');
		}
	};

	var filterItems = function(){
		var $visibleItems = $items.filter('*');
		var $parent = $items.parent();
		var query = _.lowerCase($search.val());
		var availableFilters = {};

		$filters.each(function(){
			var $filter = $(this);

			if($filter.val()){
				$visibleItems = $visibleItems.filter('[data-'+$filter.data('filterable-attribute')+'="'+$filter.val()+'"]');
			}
		});

		// check for possible filter combinations
		$visibleItems.each(function(){
			var $item = $(this);

			$filters.each(function(){
				var $filter = $(this);
				var filterAttribute = $filter.data('filterable-attribute');

				if(!availableFilters[filterAttribute]){
					availableFilters[filterAttribute] = [];
				}

				availableFilters[filterAttribute].push($item.attr('data-' + filterAttribute));
			});
		});

		// hide filter combinations with no result
		$filters.each(function(){
			var $filter = $(this);
			var filterAttribute = $filter.data('filterable-attribute');
			var filterValue = $filter.val();
			var $options = $filter.data('options').clone();

			if(filterValue == '*' || filterValue == '' || filterValue == null) {
				$options = $options.filter(function(){
					var $option = $(this);
					var optionValue = $option.attr('value');

					return optionValue == '*' || optionValue == '' || availableFilters[filterAttribute].indexOf(optionValue) >= 0;
				});
			} else {
				$options.each(function(){
					var $option = $(this);
					var optionValue = $option.attr('value');

					if(optionValue == filterValue){
						$option.prop('selected', true);
					} else {
						$option.prop('selected', false);
					}
				});

			}

			$filter.html($options);
				setTimeout(function(){
				screenReaderFix($filter);
			}, 500);
		});

		// search
		if(query){
			$visibleItems = $visibleItems.filter(function(){
				var $item = $(this);
				var haystack = _.lowerCase($item.data('search-text'));

				return haystack.indexOf(query) >= 0;
			});
		}

		$parent.css({
			height: $parent.height(),
			overflow: 'hidden',
			position: 'relative'
		});

		$notFound.velocity({
			opacity: 0,
		}, {
			duration: 299,
			display: 'none'
		});

		$items.velocity({
			opacity: 0,
		}, {
			duration: 300,
			display: 'none',
			complete: function(){
				var parentHeight;

				if($visibleItems.length){
					var $lastVisibleItem = $visibleItems.last();

					$visibleItems.css({
						display: 'block',
						visibility: 'hidden'
					});

					parentHeight = $lastVisibleItem.position().top + $lastVisibleItem.outerHeight();

					$visibleItems.each(function(index, element){
						$(this).velocity({
							opacity: 1,
							translateY: [0, 10],
						}, {
							duration: 300,
							visibility: 'visible',
							delay: index * 50
						});
					});
				} else {
					parentHeight = $notFound.outerHeight();

					$notFound.velocity({
						opacity: 1
					}, {
						display: 'block',
						duration: 300,
					});
				}

				$parent.velocity({
					height: [parentHeight, $parent.outerHeight()]
				}, {
					duration: 300,
					complete: function(){
						$parent.css('height', '');
					}
				});

			}
		});
	};

	init();
	return api;
};

loop_app.ext['flight-overview'] = function($el) {
	var api = {};

	var $element = $el;
	var $tabs = $element.find('.js-flight-overview-tab');
	var $swiper = $element.find('.js-flight-overview-swiper');
	var $searchInput = $element.find('.js-flight-overview-search-input');
	var $searchFilter = $element.find('.js-flight-overview-search-filter');
	var $desktopColumn = $element.find('.js-flight-overview-desktop-column');
	var $tables = $element.find('.js-flight-overview-table');
	var $searchTableLabels = $element.find('.js-flight-overview-search-label');
	var $footer = $element.find('.js-flight-overview-footer');
	var $allButton = $element.find('.js-flight-overview-all-button');

	var $bodyWrapper = $element.find('.js-flight-table-body-wrapper');

	var mySwiper;
	var autocompleteLookup = [];
	var lastSearchQuery = '';
	var lastSearchFilter = '';
	var isSearchExpanded = false;

	var swiperSettingsMobile = {
		autoHeight: true
	};
	var swiperSettingsDesktop = {
		autoHeight: true
	};
	var updateInterval;

	var init = function(){
		loadFlights();
		checkSearchTableLabel();
		updateFooterLink();
		initSwiper();
		initStates();
		initAutocomplete();
		addListener();
		startUpdateInterval();
	};

	var initStates = function(){
		enquire.register('screen and (min-width: 1280px)', {
			match: function(){

				var $activeSlide = mySwiper.slides.eq(mySwiper.activeIndex);
				var key = getKey($activeSlide);
				
				mySwiper.params = _.assign(mySwiper.params, swiperSettingsDesktop);
				
				mySwiper.update(true);
				$desktopColumn.matchHeight();

				if(key == 'widget'){
					mySwiper.slideTo(0, 0);
					showFooter();
				}
			},
			unmatch: function(){
				mySwiper.params = _.assign(mySwiper.params, swiperSettingsMobile);
				mySwiper.update(true);
				$desktopColumn.matchHeight({ remove: true });
			},
		});
	};

	var initAutocomplete = function(){
		$searchInput.autocomplete({
			lookup: autocompleteLookup,
			beforeRender: function($container){
				$container.addClass('autocomplete-suggestions--flight-overview');
			},
			formatResult: function(suggestion, currentValue){
				var value = suggestion.value;

				if(suggestion.airport && suggestion.shortcode){
					value = suggestion.airport;
					value += ' <span class="u-font-condensed">('+suggestion.shortcode+')</span>';
				}

				return value;
			},
			lookupFilter: function (suggestion, query, queryLowerCase) {

				if (suggestion.value.toLowerCase().indexOf(query.toLowerCase()) != 0) {
					return false;
				} else {
					return true;
				}
			},
		});

		$.ajax({
			url: $element.data('autocomplete-api'),
			success: function(data){
				autocompleteLookup = data;
				$searchInput.autocomplete('setOptions', {lookup: autocompleteLookup});
			},
			error: function(){
				console.error(arguments);
				// TODO: error handling
			}
		});
	};

	var addListener = function(){
		$tabs.on('click', function(e){
			e.preventDefault();

			var $tab = $(this);
			var key = $tab.data('tab-key');
			var $content = mySwiper.slides.filter('[data-tab-key="'+key+'"]');

			directSlideTo($content.index());
		});

		$searchInput.on('input.flight-overview change.flight-overview', _.debounce(function(){
			loadSearch($(this).val(), $searchFilter.filter(':visible:checked').val());
		}, 300));

		$searchFilter.on('change.flight-overview', function(){
			var $checkedRadio = $searchFilter.filter(':visible:checked');

			// also check hidden one (cause we have two, one for mobile, one for desktop)
			$searchFilter.filter('[value="'+$checkedRadio.attr('value')+'"]').prop('checked', true);

			checkSearchTableLabel();

			loadSearch(lastSearchQuery, $checkedRadio.val());
		});

		$element.on('open-flight-table-accordion', function(e, params){
			mySwiper.wrapper.stop().animate({
				height: '+=' + params.height
			}, {
				complete: function(){
					mySwiper.update();
				},
			}).css('overflow', 'visible');

			stopUpdateInterval();
		});

		$element.on('close-flight-table-accordion', function(e, params){
			mySwiper.wrapper.stop().animate({
				height: '-=' + params.height
			}, {
				complete: function(){
					mySwiper.update();
				},
			}).css('overflow', 'visible');

			startUpdateInterval();
		});
	};

	var startUpdateInterval = function(){
		updateInterval = window.setInterval(function(){
			loadFlights();
		}, 60000);
	};

	var stopUpdateInterval = function(){
		window.clearInterval(updateInterval);
	};

	var initSwiper = function(){
		mySwiper = new Swiper($swiper, _.assign({
			slidesPerView: 'auto',
			speed: 500,
			a11y: true,
			prevSlideMessage: loop_app.translations.prev_slide,
			nextSlideMessage: loop_app.translations.next_slide,
			paginationBulletMessage: loop_app.translations.go_to_slide,
			onSlideChangeStart: function(){
				var $activeSlide = mySwiper.slides.eq(mySwiper.activeIndex);
				var key = getKey($activeSlide);

				$tabs
					.removeClass('is-active')
					.filter('[data-tab-key="'+key+'"]')
					.addClass('is-active');

				if(key === 'search'){
					expandSearch();
				} else if(isSearchExpanded){
					collapseSearch();
				}

				updateFooterLink();

				window.setTimeout(function(){
					if(key === 'widget'){
						hideFooter();
					} else {
						showFooter();
					}
				});

				var activeTabKey = $(mySwiper.slides[mySwiper.activeIndex]).attr('data-tab-key');
				$tabs.filter('[aria-selected="true"]').attr('aria-selected','false');
				$tabs.filter('[data-tab-key="' + activeTabKey + '"]').attr('aria-selected','true');
			},
			onSlideChangeEnd: function(swiper){
				var $activeSlide = mySwiper.slides.eq(mySwiper.activeIndex);
				var key = getKey($activeSlide);

				if(mySwiper.slides.filter('.is-compressed').length){
					mySwiper.slides.removeClass('is-compressed');
					mySwiper.update(true);
				}

				$(swiper.slides).attr('inert','true');
				$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
			},
			onInit: function(swiper){
				$(swiper.slides).attr('inert','true');
				$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
			}
			
		}, swiperSettingsMobile));

		if ($('.js-flight-overview-notification').length > 0) {	
			$desktopColumn.matchHeight({ remove: true });
			$('.js-flight-overview-notification').addClass('inited');
		}
	};

	var loadFlights = function(){
		if ($('.js-flight-overview-notification').length < 1) {	

			$.ajax({
				url: $element.data('api'),
				method: 'POST',
				data: {
					limit: 8,
				},
				// data: {
				// 	startD: moment(),
				// 	endD:
				// },
				success: function(data){

					if(typeof data === 'string') {
						data = $.parseJSON(data);
					}

					var parsed_data = [];

					var current_time = moment(moment().subtract(1, 'hour').format("DD-MM-YYYY h:mm:ss A"), 'DD-MM-YYYY h:mm:ss A', true);

					_.forEach(data, function(type, key_data){
						var i = 0;

						var current_day = moment().format("YYYY-MM-DD");
						parsed_data[key_data] = [];

						_.remove(type, function(row){

							var date = moment(row.datetime);

							if((i >= 8 || date.isBefore(current_time)) && row.is_delayed != true){
								return true;
							} else {

								if (row.is_delayed == true && (row.status.indexOf('gelandet') >= 0 || row.status.indexOf('gestartet') >= 0 )) {

									var newTime = row.status.replace('gelandet ','').replace('gestartet','');

									if (newTime != '') {
										var newTimeHours = newTime.split(':')[0];
										var newTimeMinutes = newTime.split(':')[1];

										date.set({h: newTimeHours, m: newTimeMinutes});

										if (date.isBefore(current_time)) {
											return true;
										}
									}
								}

								i++;
								return false;
							}
						});

						_.forEach(type, function(row, key_type){
							if (!moment(row.datetime).isSame(current_day, 'day')) {
								parsed_data[key_data].push({'date_separator': moment(row.datetime).format("DD.MM.YYYY")});

								current_day = moment(row.datetime).format("YYYY-MM-DD");
							}
							
							parsed_data[key_data].push(row);
							// console.log( key_data );
						});
					});

					$tables.filter('[data-table="departure"]').data('obj_flightTable').fill(parsed_data.departure, false);
					$tables.filter('[data-table="arrival"]').data('obj_flightTable').fill(parsed_data.arrival, false);

					mySwiper.update();
					$(mySwiper.slides[mySwiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');

					if ($(window).width() >= 1280) {
						$desktopColumn.matchHeight();
					}
					
				},
				error: function(){
					// TODO: error handling
					console.error(arguments);
				}
			});

		}
	};

	var loadSearch = function(query, filter){
		var $searchTable = $tables.filter('[data-table="search"]');

		if(query === lastSearchQuery && filter === lastSearchFilter){
			return;
		}

		if(!query){
			lastSearchQuery = '';
			$searchTable.find('.js-flight-table-body').html('');
			return;
		}

		lastSearchFilter = filter;

		var result = $.grep(autocompleteLookup, function(e){ return e.value.toLowerCase().indexOf(query.toLowerCase()) == 0; });

		if (result.length == 1) {

			query = (result[0].shortcode) ? result[0].shortcode : result[0].value;

		}

		query = query.replace(' ','');
		lastSearchQuery = query;

		$.ajax({
			url: $element.data('api'),
			method: 'POST',
			data: {
				search: query,
				limit: 8,
			},
			success: function(data){

				if(window.location.href.indexOf("sbg-templates.local") > -1) {
					data = $.parseJSON(data);

					myData = data['arrival'];
				} else {
					var myData = data[filter];
				}

				// var myData = data[filter];

				var i = 0;
				_.remove(myData, function(row){
					var date = moment(row.datetime);

					// if(i >= 6 || date.isBefore(current_time)){
					// 	return true;
					// } else {
					// 	i++;
					// 	return false;
					// }

					if((i >= 8 || date.isBefore(current_time)) && row.is_delayed != true){
						return true;
					} else {

						if (row.is_delayed == true && (row.status.indexOf('gelandet') >= 0 || row.status.indexOf('gestartet') >= 0 )) {

							var newTime = row.status.replace('gelandet ','').replace('gestartet','');

							if (newTime != '') {
								var newTimeHours = newTime.split(':')[0];
								var newTimeMinutes = newTime.split(':')[1];

								date.set({h: newTimeHours, m: newTimeMinutes});

								if (date.isBefore(current_time)) {
									return true;
								}
							}
						}

						i++;
						return false;
					}
				});

				$searchTable.data('obj_flightTable').fill(myData, filter);
				updateFooterLink();
				mySwiper.update(true);
			},
			error: function(){
				// TODO: error handling
				console.error(arguments);
			}
		});
	};

	var getKey = function($tabOrSlide){
		return $tabOrSlide.data('tab-key');
	};

	var directSlideTo = function(index){
		var activeIndex = mySwiper.activeIndex;
		var toHide = _.range(mySwiper.activeIndex, index);

		_.forEach(toHide, function(i){
			if(i !== mySwiper.activeIndex){
				mySwiper.slides.eq(i).addClass('is-compressed');
			}
		});

		mySwiper.update(true);

		// slide to activeIndex because hiding the elements can mess with the activeIndex
		mySwiper.slideTo(activeIndex, 0, false);

		// let browser render changes before doing the actual slide
		window.setTimeout(function(){
			mySwiper.slideTo(index, 500);
		}, 10);
	};

	var expandSearch = function(){
		isSearchExpanded = true;
		$tabs.addClass('is-collapsed');
	};

	var collapseSearch = function(){
		isSearchExpanded = false;
		$tabs.removeClass('is-collapsed');
	};

	var checkSearchTableLabel = function(){
		var $checkedRadio = $searchFilter.filter(':visible:checked');

		$searchTableLabels
			.hide()
			.filter('[data-label="' + $checkedRadio.attr('value') + '"]')
			.show();
	};

	var showFooter = function(){
		if($footer.is(':hidden')){
			$footer
				.velocity('slideDown', {
					duration: 500,
					easing: 'easeOutQuad'
				})
				.velocity({
					opacity: 1
				}, {
					duration: 500,
					queue: false
				});
		}
	};

	var hideFooter = function(){
		if($footer.is(':visible')){
			$footer
				.velocity('slideUp', {
					duration: 500,
					easing: 'easeOutQuad'
				})
				.velocity({
					opacity: 0
				}, {
					duration: 500,
					queue: false
				});
		}
	};

	var updateFooterLink = function(){
		var $activeTab = $tabs.filter('.is-active');
		var tabKey = $activeTab.attr('data-tab-key');
		var link;

		if(tabKey == 'search'){
			// do search stuff
			var subTabKey = $searchFilter.filter(':visible:checked').val();
			link = $element.data(subTabKey + '-link');

			if(link){
				if(link.indexOf('?') >= 0){
					link += '&';
				} else {
					link += '?';
				}

				link += 'destination=' + $searchInput.val();

				$allButton.attr('href', link);
			}

		} else {
			link = $element.data(tabKey + '-link');

			if(link){
				$allButton.attr('href', link);
			}
		}
	};

	init();

	return api;
};

loop_app.ext['flight-plan'] = function($el) {
	var api = {};

	var $element = $el;

	var $filter = $element.find('.js-flight-plan-filter');
	var $tabs = $element.find('.js-flight-plan-tab');
	var $tabsWrapper = $('.js-flight-plan-tabs-wrapper');
	var $swiper = $element.find('.js-flight-plan-swiper');
	var $searchInput = $element.find('.js-flight-plan-search-input');
	var $airlineInput = $element.find('.js-flight-plan-airline');
	var $date = $element.find('.js-flight-plan-datepicker');
	var $airlineWing = $element.find('.js-flight-plan-airline-wing');
	var $tables = $element.find('.js-flight-plan-table');
	var $resetFilter = $element.find('.js-flight-plan-reset-filter');
	var $loadMore = $element.find('.js-flight-plan-load-more');
	var $loader = $element.find('.js-flight-plan-loader');

	var $focus = $element.find('.js-new-filter-datepicker-focus');

	var mySwiper;
	var autocompleteLookup = [];
	var airlineLookup = [];

	var loadedStartDate = {
		'arrival': moment().subtract(1, 'hour'),
		'departure': moment().subtract(1, 'hour'),
	}
	var loadedEndDate = {
		'arrival': moment().add(1, 'days').endOf('day'),
		'departure': moment().add(1, 'days').endOf('day')
	}
	
	var loadedStartDatePrev = {
		'arrival': moment().subtract(1, 'hour'),
		'departure': moment().subtract(1, 'hour'),
	}
	var loadedEndDatePrev = {
		'arrival': moment().add(1, 'days').endOf('day'),
		'departure': moment().add(1, 'days').endOf('day')
	}

	var currentFilter = [];

	var autoCompleteSearchIsSearching = false;
	var autoCompleteAirlineIsSearching = false;

	var maxDateTimestamp = moment($element.data('max-date'),'DD-MM-YYYY').startOf('day');

	var init = function() {
		loadFlights();

		initDatepicker();
		initAutoComplete();
		initSwiper();
		addListener();
	};

	var initDatepicker = function(e) {
		if(!$date.length){
			return;
		}

		if(Modernizr.touch && ($('html').hasClass('mobile') || $('html').hasClass('tablet'))) {

			var today = moment().format('YYYY-MM-DD');

			$date.attr('type', 'date').attr('min', today);
			$date.on('focus', function(){
				$date.parent().addClass('is-active');
			});
			$date.on('blur', function(){
				if (!$date.val()) {
					$date.parent().removeClass('is-active');
				}
			});

			$date.on('focus', function () {
				// Store the current value on focus and on change
				$(this).attr('data-prev-val', this.value);
			}).on('change', function(event) {

				var currentValue = $(this).val();

				if (moment($(this).val(), 'YYYY-MM-DD').isBefore(today)) {
					alert($date.data('min-allowed-date-message'));
					$(this).val($(this).data('prev-val'));
				} else {
					$resetFilter.addClass('is-enabled').attr('tabindex','0');
					applyFilter();
				}

			});
			return;
		}

		var mToday = moment();
		
		$date.attr('data-start-date', moment().format('DD.MM.YYYY'));
		$date.attr('data-end-date', moment($element.data('max-date'),'DD-MM-YYYY').format('DD.MM.YYYY'));
		
		loop_app.createA11yButton($date.get(0));
		$date.attr('readonly', 'readonly');

		let focusTrap = null;
		
		$date.dateRangePicker({
			singleDate: true,
			singleMonth: true,
			autoClose: true,
			startDate: moment().format('DD. MMMM YYYY'),
			endDate: moment($element.data('max-date'),'DD-MM-YYYY').format('DD. MMMM YYYY'),
			format: 'DD. MMMM YYYY',
			defaultTime: moment().startOf('day').toDate(),
			showTopbar: false,
			startOfWeek: 'monday',
			language: loop_app.language,
			extraClass: $(window).width() > 1024 ? 'date-picker--flight-plan' : '',
			customOpenAnimation: function(cb){
				$(this).css('display', 'block');
				$(this).velocity({
					translateY: [0, 10],
					opacity: [1, 0]
				}, {
					duration: 200,
					complete: cb,
					display: 'block'
				});
			},
			customCloseAnimation: function(cb){
				$(this).velocity({
					translateY: 10,
					opacity: 0
				}, {
					duration: 200,
					complete: cb,
					display: 'none'
				});
			},
			beforeShowDay: function(t){
				var mDate = moment(t);
				var valid = mDate.isSameOrAfter(mToday, 'day');

				return [valid];
			},
			/**
			 * Since the default datepicker doesn't set the value if it's readonly, we need to set it manually
			 * https://longbill.github.io/jquery-date-range-picker/
			 */
			setValue: function(s)
			{
				if(!$(this).is(':disabled') && s != $(this).val())
				{
					$(this).val(s);
				}
			},
		}).bind('datepicker-change', function(event, obj) {
			$resetFilter.addClass('is-enabled').attr('tabindex','0');

			applyFilter();
		}).on('change', function() {
			if ($searchInput.val() != '' ||  $airlineInput.val() != '' || $date.val() != '') {
				$resetFilter.addClass('is-enabled').attr('tabindex','0');
			}
			else {
				$resetFilter.removeClass('is-enabled').removeAttr('tabindex');
			}

			applyFilter();

		}).bind('datepicker-open',function(){
			focusTrap = loop_app.initDateRangePickerTabNav($date);
		}).bind('datepicker-close',function(){
			if(focusTrap){
				focusTrap.deactivate();
			}
		});

		window.setTimeout(function(){
			$date.data().dateRangePicker.getDatePicker().find('.month-wrapper').css('width', '');
		}, 100);

		$date.parent().addClass('inited');
	};

	var initSwiper = function(){
		mySwiper = new Swiper($swiper, {
			slidesPerView: 'auto',
			speed: 500,
			autoHeight: true,
			a11y: true,
			effect:'fade',
			prevSlideMessage: loop_app.translations.prev_slide,
			nextSlideMessage: loop_app.translations.next_slide,
			paginationBulletMessage: loop_app.translations.go_to_slide,
			initialSlide: $tabs.index($tabs.filter('.is-active')),
			simulateTouch: false,
			onSlideChangeStart: function(swiper){
				var $activeSlide = swiper.slides.eq(swiper.activeIndex);
				var key = getKey($activeSlide);

				if ($swiper.parents('.js-search-detail').length == 0) {
					var url = $element.data(key + '-url');

					if(url){
						history.pushState(null, null, url);
					}
				}

				$tabs
					.removeClass('is-active')
					.filter('[data-tab-key="'+key+'"]')
					.addClass('is-active');

				resetTableHeader();

				$(swiper.slides).attr('inert','true');
				$(swiper.slides).find('.js-flight-plan-load-more, .js-search-result-more').attr('tabindex','-1');
				$(swiper.slides[swiper.activeIndex]).removeAttr('inert');
				$(swiper.slides[swiper.activeIndex]).find('.js-flight-plan-load-more, .js-search-result-more').removeAttr('tabindex');

				var activeTabKey = $(swiper.slides[swiper.activeIndex]).attr('data-tab-key');
				$tabs.filter('[aria-selected="true"]').attr('aria-selected','false');
				$tabs.filter('[data-tab-key="' + activeTabKey + '"]').attr('aria-selected','true');
			},
			onInit: function(swiper) {
				$(swiper.slides).attr('inert','true');
				$(swiper.slides).find('.js-flight-plan-load-more, .js-search-result-more').attr('tabindex','-1');
				$(swiper.slides[swiper.activeIndex]).removeAttr('inert')
				$(swiper.slides[swiper.activeIndex]).find('.js-flight-plan-load-more, .js-search-result-more').removeAttr('tabindex');

				var activeTabKey = $(swiper.slides[swiper.activeIndex]).attr('data-tab-key');
				$tabs.filter('[data-tab-key="' + activeTabKey + '"]').attr('aria-selected','true');
			}
		});
	};

	var initAutoComplete = function() {
		if($searchInput.length){
			$searchInput.autocomplete({
				lookup: autocompleteLookup,
				beforeRender: function($container){
					$container.addClass('autocomplete-suggestions--flight-plan');
				},
				// width: 'flex',
				formatResult: function(suggestion, currentValue){

					var value = suggestion.value;

					if(suggestion.airport && suggestion.shortcode){
						value = suggestion.airport;
						value += ' <span class="u-font-condensed">('+suggestion.shortcode+')</span>';
					}

					return value;
				},

				lookupFilter: function (suggestion, query, queryLowerCase) {

					if (suggestion.value.toLowerCase().indexOf(query.toLowerCase()) != 0) {
						return false;
					} else {
						return true;
					}

				},
				onSelect: function(suggestion) {
					$resetFilter.addClass('is-enabled').attr('tabindex','0');
					applyFilter();
				},
				onSearchStart: function() {
					autoCompleteSearchIsSearching = true;
				},
				onHide: function() {
					autoCompleteSearchIsSearching = false;
				},
				onSearchComplete: function (query, suggestions) {
					if (suggestions.length == 0) {
						autoCompleteSearchIsSearching = false;
					}
				}
			});

			$.ajax({
				url: $element.data('autocomplete-api'),
				success: function(data){
					autocompleteLookup = data;
					$searchInput.autocomplete('setOptions', {lookup: autocompleteLookup});
				},
				error: function(){
					console.error(arguments);
					// TODO: error handling
				}
			});

			$searchInput.on('keypress', function(e){
				if(e.which == 13) {
					$(this).blur();
				}
			});

			$searchInput.on('blur', function(){
				if (!autoCompleteSearchIsSearching) {

					if ($searchInput.val() != '' ||  $airlineInput.val() != '' || $date.val() != '') {
						$resetFilter.addClass('is-enabled').attr('tabindex','0');
					}
					else {
						$resetFilter.removeClass('is-enabled').removeAttr('tabindex');
					}

					applyFilter();
				}
			});

			$searchInput.on('focus', function(e){
				e.preventDefault();
			});

			$airlineInput.on('keypress', function(e){
				if(e.which == 13) {
					$(this).blur();
				}
			});

			$airlineInput.on('blur', function(){

				if (!autoCompleteAirlineIsSearching) {

					if ($searchInput.val() != '' ||  $airlineInput.val() != '' || $date.val() != '') {
						$resetFilter.addClass('is-enabled').attr('tabindex','0');
					}
					else {
						$resetFilter.removeClass('is-enabled').removeAttr('tabindex');
					}

					applyFilter();
				}
			});
		}

		if($airlineInput.length){
			$airlineInput.autocomplete({
				lookup: airlineLookup,
				beforeRender: function($container){
					$container.addClass('autocomplete-suggestions--flight-plan-airlines');
				},
				formatResult: function(suggestion, currentValue){
					var value = suggestion.value;

					if(suggestion.wing_image){
						value += '<img class="autocomplete-suggestion__image" src="'+suggestion.wing_image+'">';
					}

					return value;
				},
				lookupFilter: function (suggestion, query, queryLowerCase) {

					if (suggestion.value.toLowerCase().indexOf(query.toLowerCase()) != 0) {
						return false;
					} else {
						return true;
					}
				},
				onSelect: function(suggestion) {
					$resetFilter.addClass('is-enabled').attr('tabindex','0');
					if(suggestion.wing_image){
						$airlineWing.attr('src', suggestion.wing_image);
					}

					applyFilter();
				},
				onInvalidateSelection: function(){
					$airlineWing.attr('src', $airlineWing.data('original-src'));
				},
				onSearchStart: function() {
					autoCompleteAirlineIsSearching = true;
				},
				onHide: function() {
					autoCompleteAirlineIsSearching = false;
				},
				onSearchComplete: function (query, suggestions) {
					if (suggestions.length == 0) {
						autoCompleteAirlineIsSearching = false;
					}
				}
			});

			$airlineWing.data('original-src', $airlineWing.attr('src'));

			$.ajax({
				url: $element.data('airline-autocomplete-api'),
				success: function(data){
					airlineLookup = data;
					$airlineInput.autocomplete('setOptions', {lookup: airlineLookup});

					if($airlineInput.val()){
						var value = $airlineInput.val();
						var autocomplete = $airlineInput.data('autocomplete');

						autocomplete.suggestions = _.cloneDeep(airlineLookup);

						var matchIndex = _.findIndex(autocomplete.suggestions, function(item){
							return _.trim(_.toLower(item.value)) == _.trim(_.toLower(value));
						});

						if(matchIndex >= 0){
							autocomplete.select(matchIndex);

						}
					}
				},
				error: function(){
					console.error(arguments);
					// TODO: error handling
				}
			});
		}

	};

	var addListener = function(){

		$resetFilter.on('click', resetFilterClickHandler);
		$resetFilter.on('keypress', resetFilterKeypressHandler);
		$loadMore.on('click', loadMoreClickHandler);

		$element.on('update', function(){
			mySwiper.update();
		});

		$tabs.on('click', function(e){
			e.preventDefault();

			var $tab = $(this);
			var key = $tab.data('tab-key');
			var $content = mySwiper.slides.filter('[data-tab-key="'+key+'"]');

			mySwiper.slideTo($content.index());
		});

		$(window).on('resize', _.debounce(function(){
			mySwiper.update();
		}, 200));

		$element.on('click', '.js-flight-plan-next', flightPlanNextClickHandler );
		$element.on('click', '.js-flight-plan-prev', flightPlanPrevClickHandler );

		$element.on('keypress', '.js-flight-plan-next', function(e) {
			if (e.keyCode == 13) {
				$(this).trigger('click');
			}
		} );
		$element.on('keypress', '.js-flight-plan-prev', function(e) {
			if (e.keyCode == 13) {
				$(this).trigger('click');
			}
		} );

		$filter.on('submit',function(e){
			e.preventDefault();
		});

		$date.on('keypress', function(e){
			if (e.keyCode == 13) {
				// $(this).trigger('click');
				$(this).data('dateRangePicker').open(0);

				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
			}
		});
	};

	var resetFilterClickHandler = function() {
		$resetFilter.removeClass('is-enabled').removeAttr('tabindex');

		$searchInput.val('');
		$searchInput.val('');

		if(!Modernizr.touch){
			$date.data('dateRangePicker').clear();
		} else {
			$date.val('').parent().removeClass('is-active');
		}

		$airlineInput.val('');
		$airlineInput.val('');
		$airlineWing.attr('src', $airlineWing.data('original-src'));

		applyFilter();
	};

	var resetFilterKeypressHandler = function(e) {
		if (e.keyCode == 13) {
			resetFilterClickHandler();
		}
	} ;

	var loadMoreClickHandler = function() {
		loadFlightPlanMore(getFilter(), $(this).data('more-table'));
	};

	var loadFlights = function(url){
		if(!$element.data('api') && !url){
			return;
		}

		var urlParameter = getUrlParameter();

		if(urlParameter.destination){
			$searchInput.val(unescape(urlParameter.destination));
		}

		if(urlParameter.airline){
			$airlineInput.val(decodeURIComponent(urlParameter.airline));
		}

		$loader.addClass('is-visible').addClass('is-top');

		$.ajax({
			url: $element.data('api'),
			method: 'POST',
			data: {
				startD: loadedStartDate['arrival'].format('X'),
				endD: loadedEndDate['arrival'].format('X'),
				search: $searchInput.val(),
			},
			success: function(data){
				if(typeof data === 'string') {
					data = $.parseJSON(data);
				}

				//if no flights returned because of the runway construction perform a search from starting on 29/05/2019
				if (data.arrival.length == 0 && data.departure.length == 0 && (moment() < moment('2019-05-29')) ) {

					var data = {
						search: '',
						airline: '',
						startD: moment('2019-05-29').format('X'),
						endD: moment('2019-05-29').add(3, 'days').endOf('day').format('X')
					};
					searchAjax('departure',data, 0, false, false);
					searchAjax('arrival',data, 0, false, false);

				// if there are no flights returned becuase of covid - trigger the search recursion 
				} else if (data.arrival.length == 0 && data.departure.length == 0) {
					var data = {
						search: $searchInput.val(),
						startD: loadedStartDate['arrival'].format('X'),
						endD: loadedEndDate['arrival'].format('X'),
					};

					searchAjax('departure',data, 0, false, false);
					searchAjax('arrival',data, 0, false, false);
				} else {
					fillTables(data);
					$loader.removeClass('is-visible is-top');
				}
				handleTabindexOfLoadedFLights();
			},
			error: function(){
				// TODO: error handling
				console.error(arguments);
				$loader.removeClass('is-visible is-top');
			}
		});
	};

	var loadFlightPlanMore = function(filter, table){
		$loader.addClass('is-visible is-bottom');

		var data = {
			search: filter.search,
			airline: filter.airline,
			startD: loadedEndDate[table].clone().add(1, 'day').startOf('day').format('X'),
			endD: loadedEndDate[table].clone().add(1, 'day').endOf('day').format('X')
		};

		$loadMore.addClass('is-disabled');

		searchAjax(table, data, 0, true, false);

	};

	var loadFlightPlanSearch = function(filter) {

		var format = 'DD. MMMM YYYY';

		if ($('html').hasClass('ios') || $('html').hasClass('android') || $('html').hasClass('mobile') || $('html').hasClass('tablet')) {
			format = 'YYYY-MM-DD';
		}

		var date = filter.date ? moment(filter.date, format) : moment().subtract(1, 'hour');
		var data1 = {
			search: filter.search,
			airline: filter.airline,
			startD: date.clone().format('X'),
			endD: filter.date ? date.clone().add(1, 'days').endOf('day').format('X') : moment().add(1, 'days').endOf('day').format('X')
		};

		var data2 = {
			search: filter.search,
			airline: filter.airline,
			startD: date.clone().format('X'),
			endD: filter.date ? date.clone().add(1, 'days').endOf('day').format('X') : moment().add(1, 'days').endOf('day').format('X')
		};

		$tables.each(function() {
			$(this).find('.js-flight-plan-load-more').css('visibility','visible');
		});

		$loader.addClass('is-visible is-top');

		searchAjax('departure',data1, 0, false, false);
		searchAjax('arrival',data2, 0, false, false);
	};

	var loadFlightPlanPrev = function(filter, table, startday){
		$loader.addClass('is-visible is-top');

		// var startD = (loadedStartDate[table].format('HH:mm:ss') != '00:00:00' ? loadedStartDate[table].clone().startOf('day').format('X') : loadedStartDate[table].clone().subtract(1, 'day').startOf('day').format('X') );
		var startD = moment(startday, 'DD/MM/YYYY').subtract(1, 'day').startOf('day');
		var endD = startD.clone().add(1, 'day').endOf('day');
		var data = {
			search: filter.search,
			airline: filter.airline,
			startD: startD.format('X'),
			endD: endD.format('X')
			// endD: loadedStartDatePrev[table].clone().format('X')

		};

		searchAjax(table, data, 0, false, true);
	};

	var searchAjax = function(table, postData, iteration, append, prepend, resultsData = []) {

		postData.table = table;

		$.ajax({
			url: $element.data('api'),
			method: 'POST',
			data: postData,
			success: function(data){
				if(typeof data === 'string') {
					data = $.parseJSON(data);
				}
				const fullData = prepend ? [...data[table], ...resultsData] : [...resultsData, ...data[table]];
				var today = moment().startOf('day');
				if ((fullData.length > 5) || (moment(postData.endD,'X') >= maxDateTimestamp) || (moment(postData.startD,'X') <= today)) {
					// console.log('endD '+table + ' ' +moment(loadedEndDate[table],'X').format('YYYY-MM-DD') + ' ' + (data[table].length > 5) + ' ' + (iteration == 4) + ' ' + (moment(loadedEndDate[table],'X') > moment($element.data('max-date'),'DD-MM-YYYY')));
					// console.log(data[table].length);

					if (moment(loadedEndDate[table],'X') >= maxDateTimestamp) {
						// console.log(iteration + ' ' + moment(loadedEndDate[table],'X').format('YYYY-MM-DD') + ' ' + maxDateTimestamp.format('YYYY-MM-DD'));
						$tables.filter('[data-table="'+ table +'"]').find('.js-flight-plan-load-more').css('visibility','hidden');

					}

					$tables.filter('[data-table="'+ table +'"]').data('obj_flightTable').fillFlightPlan(fullData, append, prepend);

					mySwiper.update(true);
					$loader.removeClass('is-visible');
					$loader.removeClass('is-top');
					$loader.removeClass('is-bottom');

					if (iteration == 0) {
						if (!prepend) {
							loadedStartDate[table] = moment(postData.startD,'X');
							loadedEndDate[table] = moment(postData.endD,'X');
						}
						if (!append) {
							loadedStartDatePrev[table] = moment(postData.startD,'X');
							loadedEndDatePrev[table] = moment(postData.endD,'X');
						}
					}
				} else {
					searchAjaxRecursion2(iteration + 1, table, postData, append, prepend, fullData);

					// 0 add 2 weeks
					// 1 add 1 month
					// 2 add 3 months
					// 3 add 6 months / end of flight plan

					// switch (iteration) {
					// 	case 0:
					// 		searchAjaxRecursion(1, 2, 'days',table, postData, append, prepend);
					// 		break;
					// 	case 1:
					// 		searchAjaxRecursion(2, 2, 'weeks',table, postData, append, prepend);
					// 		break;
					// 	case 2:
					// 		searchAjaxRecursion(3, 1, 'month', table, postData, append, prepend);
					// 		break;
					// 	case 3:
					// 		searchAjaxRecursion(4, 3, 'month', table, postData, append, prepend);
					// 		break;
					// 	case 4:
					// 		searchAjaxRecursion(5, 6, 'months', table, postData, append, prepend);
					// 		break;
					// }
				}

				if (append) {
					$loadMore.blur();
					$loadMore.removeClass('is-disabled');
				}
			},
			error: function(){
				// TODO: error handling
				console.error(arguments);
				$loader.removeClass('is-visible is-top');
				$loadMore.removeClass('is-disabled');
			}
		});
	};

	var searchAjaxRecursion = function(iteration, number, type, table, postData, append, prepend) {

		if (prepend) {

			var endD = moment(postData.endD, 'X');
			var startD = endD.clone().subtract(number, type).format('X');
			postData.startD = (startD < moment().startOf('day').format('X') ? moment().startOf('day').format('X') : startD);

		} else {

			var startD = moment(postData.startD, 'X');
			var endD = startD.clone().add(number, type).endOf('day').format('X');
			postData.endD = (endD > maxDateTimestamp.format('X') ? maxDateTimestamp.format('X') : endD);

		}

		if (!prepend) {
			loadedStartDate[table] = moment(postData.startD,'X');
			loadedEndDate[table] = moment(postData.endD,'X');
		}
		if (!append) {
			loadedStartDatePrev[table] = moment(postData.startD,'X');
			loadedEndDatePrev[table] = moment(postData.endD,'X');
		}

		searchAjax(table, postData, iteration, append, prepend);
	}
	var searchAjaxRecursion2 = function(iteration, table, postData, append, prepend, resultsData) {
		if (prepend) {

			var endD = moment(postData.startD, 'X');
			var startD = endD.clone().subtract(10, 'days').format('X');
			postData.endD = endD.format('X');
			postData.startD = (startD < moment().startOf('day').format('X') ? moment().startOf('day').format('X') : startD);

			loadedStartDatePrev[table] = moment(postData.startD,'X');
			loadedEndDatePrev[table] = moment(postData.endD,'X');
		} else {

			var startD = moment(postData.endD, 'X');
			var endD = startD.clone().add(10, 'days').endOf('day').format('X');
			postData.startD = startD.format('X');
			postData.endD = (endD > maxDateTimestamp.format('X') ? maxDateTimestamp.format('X') : endD);

			loadedStartDate[table] = moment(postData.startD,'X');
			loadedEndDate[table] = moment(postData.endD,'X');
		}
		searchAjax(table, postData, iteration, append, prepend, resultsData);
	}

	var applyFilter = function() {

		var filter = getFilter();

		if (JSON.stringify(currentFilter) != JSON.stringify(filter)) {
			currentFilter = filter;
			loadFlightPlanSearch(filter);
		}
	};

	var getFilter = function(){
		var output = {};
		var data = $filter.serializeArray().forEach(function(item){
			output[item.name] = item.value;
		});

		var result = $.grep(autocompleteLookup, function(e){ return e.value.toLowerCase().indexOf(output.search.toLowerCase()) == 0; });

		if (result.length == 1) {

			output.search = (result[0].shortcode) ? result[0].shortcode : result[0].value;

		}
		output.search = output.search.replace(' ','');

		return output;
	};

	var resetTableHeader = function() {
		// $tables.filter('.is-fixed-header').removeClass('is-fixed-header');
		// $tables.find('.flight-table__day.was-top').removeClass('was-top');
		// $tables.find('.flight-table__day.is-top').removeClass('is-top');

		// $tables.find('.flight-table__day:first').addClass('is-top');
	};

	var fillTables = function(data, loadMore){
		$tables.filter('[data-table="departure"]').data('obj_flightTable').fillFlightPlan(data.departure, loadMore);
		$tables.filter('[data-table="arrival"]').data('obj_flightTable').fillFlightPlan(data.arrival, loadMore);

		window.setTimeout(function(){
			mySwiper.update();
			// flightPlanTableScrolling();
		});
		setTimeout(function() {
			initStickyPolyfill();
		}, 200);
	};

	var formatAirline = function(airline) {
		var airlineHtml = '<span class="flag-text">'+ airline.text+'</span>';

		if ($(airline.element).data('img') != undefined) {
			airlineHtml += '<img src="' + $(airline.element).data('img') + '">';
		}

		return $(airlineHtml);
	};

	var getKey = function($tabOrSlide){
		return $tabOrSlide.data('tab-key');
	};

	var flightPlanNextClickHandler = function() {
		var $parentDay = $(this).parents('.flight-table__day');
		var $parentTableWrapper = $(this).parents('.js-flight-table');

		if ($parentDay.is(':last-child')) {
			$parentTableWrapper.find('.js-flight-plan-load-more').trigger('click');
		} else {
			$('html, body').animate({
				scrollTop: $parentDay.next().offset().top - $($('.js-flight-table-row')[0]).outerHeight() - $tabsWrapper.outerHeight() - $($('.flight-table__header')[0]).outerHeight()
			}, 500);
			$parentDay.next().find('.js-flight-plan-day-focus').trigger('focus');
		}

	};
	var flightPlanPrevClickHandler = function() {
		var $parentDay = $(this).parents('.flight-table__day');

		if ($parentDay.is(':first-child')) {

			loadFlightPlanPrev(getFilter(), $(this).parents('.js-flight-table').data('table'), $parentDay.data('day'));

		} else {
			$('html, body').animate({
				scrollTop: $parentDay.prev().offset().top - $($('.js-flight-table-row')[0]).outerHeight() - $tabsWrapper.outerHeight() - $($('.flight-table__header')[0]).outerHeight() + 3
			}, 500);
			$parentDay.prev().find('.js-flight-plan-day-focus').trigger('focus');
		}

	};

	var getUrlParameter = function(){
		return _.fromPairs(_.compact(_.map(location.search.slice(1).split('&'), function(item) {  if (item) return item.split('='); })));
	};

	var toQueryString = function(parameters){
		return _.join(_.map(_.toPairs(parameters), function(parameter){ return _.join(parameter, '='); }), '&');
	};

	var initStickyPolyfill = function() {
		var $sticky_elements = $('.js-sticky');

		Stickyfill.add($sticky_elements);
	};

	var closeOverlay = function() {
		$date.data('dateRangePicker').close();
	}

	var handleTabindexOfLoadedFLights = function() {
		$(mySwiper.slides[mySwiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
	}

	api.fillTables = fillTables;
	api.closeOverlay = closeOverlay;
	api.handleTabindexOfLoadedFLights = handleTabindexOfLoadedFLights;

	init();
	return api;
};

loop_app.ext['flight-search'] = function($el) {
	var api = {};

	var $element = $el;
	var $switch = $element.find('.js-flight-search-switch');
	var $inputs = $element.find('.js-flight-search-input');
	var $map = $element.find('.js-flight-search-map');
	var $mapContainer = $element.find('.js-flight-search-map-container');
	var $filter = $element.find('.js-flight-search-filter');
	var $form = $element.find('.js-flight-search-form');
	var $resets = $element.find('.js-flight-search-reset');
	var $checkbox = $element.find('.js-flight-search-checkbox');

	var map;
	var markers = [];
	var markerCluster;
	var homeMarker;
	var openMarker;
	var hoverMarker;
	var destinations = [];
	var isFullscreen = $element.data('fullscreen') || false;
	var doverlayTemplateString = $element.find('.js-flight-search-doverlay-template').html();
	var allowFormSubmit = false;

	var init = function() {
		addListener();
		positionElement();
		positionMap();
		initStates();
		initAutocomplete();
		loadDestinations();
	};

	var initMap = function(){
		map = new google.maps.Map($map[0], {
			streetViewControl: false,
			mapTypeControl: false,
			scrollwheel: isFullscreen,
			center: {
				lat: 47.811195,
				lng: 13.033229
			},
			zoom: 5,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_TOP
			},
			styles: mapStyles
		});

		if(destinations && !markers.length){
			renderPins(destinations);
		}

		api.map = map;

		map.addListener('click', function(){
			closeAllMarkerHover();
		});
	};

	var initStates = function(){
		enquire.register('screen and (min-width: 768px)', {
			match: function(){
				loop_app.initGoogleMaps();

				if(loop_app.googleMapsReady){
					initMap();
				} else {
					$(window).on('googleMapsReady', function(){
						initMap();
					});
				}
			}
		});
	};

	var initAutocomplete = function(){
		$inputs.autocomplete({
			lookup: getFilteredDestinations(),
			beforeRender: function($container){
				$container.addClass('autocomplete-suggestions--flight-search');
			},
			formatResult: function(suggestion, currentValue){
				var value = suggestion.value;

				if(suggestion.name && suggestion.shortcode){
					value = suggestion.name;
					value += ' <span class="u-font-condensed">('+suggestion.shortcode+')</span>';
				}

				return value;
			},
			onSelect: function(){
				if(isMapShowing() && !allowFormSubmit){
					$form.trigger('submit');
				}
			}
		});
	};

	var addListener = function(){
		$switch.on('click.flight-search', function(e){
			e.preventDefault();
			switchInputs();
		});

		$switch.on('keypress.flight-search', function(e){
			if (e.keyCode == 13) {
				e.preventDefault();
				$(this).trigger('click');
			}
		});

		$filter.on('change.flight-search', function(e){
			filter();
		});

		$inputs.on('input', function(e){
			if($(this).val() === ''){
				closeDetail();
			}
		});

		$resets.on('click', function(e){
			e.preventDefault();
			getActiveInput().val('').trigger('input');
			closeDetail();
		});

		$form.on('submit.flight-search', function(e){
			if(isMapShowing() && !allowFormSubmit){
				e.preventDefault();

				var query = getActiveInput().val().toLowerCase();

				if(!query){
					return;
				}

				var foundMarker = _.find(markers, function(marker){
					return marker.data.value.toLowerCase().indexOf(query) !== -1;
				});

				if(foundMarker){
					openDetail(foundMarker);
				} else {
					alert('not found');
				}
			} else {
				$inputs.each(function(){
					var $input = $(this);
					var inputValue = $input.val();

					$input.val(inputValue.replace(/ \(.*?\)$/, ''));
				});
			}
		});

		$(window).on('resize', _.debounce(function(){
			positionElement();
			positionMap();
		}, 200));
	};

	var switchInputs = function(){
		var $activeInput = getActiveInput();
		var $inactiveInput = $inputs.not($activeInput);
		var activeValue = $activeInput.val();
		var inactiveValue = $inactiveInput.val();

		$inactiveInput.prop('readonly', false);
		$activeInput.prop('readonly', true);

		$inactiveInput.val(activeValue);
		$activeInput.val(inactiveValue);

		$activeInput.trigger('input');
		$inactiveInput.trigger('input');
	};

	var getActiveInput = function(){
		return $inputs.not('[readonly]');
	};

	var getActiveDirection = function(){
		return getActiveInput().data('name');
	};

	var checkCheckBox = function(){
		if(openMarker && !openMarker.data.is_direct){
			$checkbox.addClass('is-disabled');
			$checkbox.find('.js-flight-search-filter-text-on').hide();
			$checkbox.find('.js-flight-search-filter-text-off').show();
			$filter.prop('checked', false);
			$filter.prop('disabled', true);
		} else {
			$checkbox.removeClass('is-disabled');
			$filter.prop('disabled', false);
			$checkbox.find('.js-flight-search-filter-text-on').show();
			$checkbox.find('.js-flight-search-filter-text-off').hide();
		}
	};

	var positionElement = function(){
		if(isFullscreen && $(window).width() > 767){
			var offset = $element.offset();

			$element.css({
				height: $(window).height() - offset.top
			});
		}
	};

	var positionMap = function(){
		if($mapContainer.is(':visible')){
			var offset = $mapContainer.offset();

			$mapContainer.css({
				height: $element.outerHeight(),
				width: $element.outerWidth() - offset.left
			});

			if(map){
				google.maps.event.trigger(map, 'resize');
			}
		}
	};

	var loadDestinations = function(){
		$element.addClass('is-loading');

		$.ajax({
			url: $element.data('destinations-api'),
			success: function(data){
				$element.removeClass('is-loading');
				destinations = data;

				// add value attribute to destinations for autocomplete
				_.forEach(destinations, function(destination){
					destination.value = destination.name + ' ('+destination.shortcode+')';
				});

				if($(window).width() >= 768){
					if(loop_app.googleMapsReady){
						if(!markers.length){
							renderPins(destinations);
						}
					} else {
						$(window).on('googleMapsReady', function(){
							if(!markers.length){
								renderPins(destinations);
							}
						});
					}
				}

				$inputs.autocomplete('setOptions', {lookup: getFilteredDestinations()});
			},
			error: function(){
				// TODO: error handling
				console.error(arguments);
			}
		});
	};

	var renderPins = function(markersData){
		_.forEach(markersData, function(markerData){
			var icon;
			var myMarker;

			var markerTitle = markerData.name;
			if(markerData.is_home){
				icon = {
					url: '/fileadmin/assets/img/marker/pin-home.svg',
					scaledSize: new google.maps.Size(34, 42),
				};
			} else if(markerData.is_direct){
				icon = {
					url: '/fileadmin/assets/img/marker/pin-red.svg',
					scaledSize: new google.maps.Size(29, 36),
				};
			} else {
				icon = {
					url: '/fileadmin/assets/img/marker/pin-blue.svg',
					scaledSize: new google.maps.Size(29, 36),
				};
			}

			var markerTitle = markerData.name;

			if (!markerData.is_home) {

			}

			myMarker = new google.maps.Marker({
				map: map,
				cursor: 'grab',
				icon: icon,
				zIndex: 10,
				optimized: false,
				position: {
					lat: markerData.lat,
					lng: markerData.lng
				},
			});

			myMarker.data = markerData;

			if(myMarker.data.is_home){
				homeMarker = myMarker;
			}

			var markerHoverIn = function(){
				closeAllMarkerHover();

				if(!myMarker.hover || !myMarker.hover.getMap() && !openMarker){
					myMarker.hover = new FlightSearchHoverOverlay(myMarker, openDetail);
				}

				hoverMarker = myMarker;
				myMarker.hover.isHoveringMarker = true;
			};

			myMarker.addListener('mouseover', markerHoverIn);
			myMarker.addListener('mousedown', markerHoverIn);

			myMarker.addListener('mouseout', function(){
				window.setTimeout(function(){
					myMarker.hover.isHoveringMarker = false;

					if(hoverMarker === myMarker){
						hoverMarker = undefined;
					}

					if(!myMarker.hover.isHoveringOverlay && !myMarker.hover.isHoveringMarker){
						myMarker.hover.setMap(null);
					}
				});
			});

			markers.push(myMarker);
		});

		markerCluster = new MarkerClusterer(map, markers, {
			gridSize: 20,
			ignoreHidden: true,
			styles: [
				{
					height: 36,
					width: 29,
					textColor: '#020202',
					textSize: 12,
					anchorText: [-3, 0],
					url: '/fileadmin/assets/img/marker/pin-red.svg',
				}, {
					height: 36,
					width: 29,
					textColor: '#020202',
					textSize: 12,
					anchorText: [-3, 0],
					url: '/fileadmin/assets/img/marker/pin-blue.svg',
				}, {
					height: 39,
					width: 39,
					textColor: '#020202',
					textSize: 12,
					anchorText: [-1, -5],
					url: '/fileadmin/assets/img/marker/pin-combined.svg',
				}
			]
		});

		markerCluster.setCalculator(function(markers, numStyles){
			var isDirect;
			var isNotDirect;
			var index;

			_.forEach(markers, function(marker){
				if(marker.data.is_direct){
					isDirect = true;
				} else {
					isNotDirect = true;
				}
			});

			if(isDirect && isNotDirect){
				index = 3;
			} else if(isNotDirect){
				index = 2;
			} else {
				index = 1;
			}

			return {
				text: markers.length,
				index: index
			};
		});

		var markerClusterHoverIn = function(cluster){
			if(!cluster.hover || !cluster.hover.getMap()){
				cluster.hover = new FlightSearchHoverOverlay(cluster, openDetail);
			}

			cluster.hover.isHoveringMarker = true;
		};

		markerCluster.addListener('mouseover', markerClusterHoverIn);

		markerCluster.addListener('mouseout', function(cluster){
			window.setTimeout(function(){
				cluster.hover.isHoveringMarker = false;

				if(!cluster.hover.isHoveringOverlay && !cluster.hover.isHoveringMarker){
					cluster.hover.setMap(null);
				}
			});
		});
	};

	var closeAllMarkerHover = function(){
		if(!map){
			return;
		}

		_.forEach(markers, function(marker){
			if(marker.hover && marker.hover.isHoveringMarker){
				google.maps.event.trigger(marker, 'mouseout');
			}
		});
	};

	var filter = function(){
		showFilteredMarkers();
		$inputs.autocomplete('setOptions', {lookup: getFilteredDestinations()});
	};

	var showFilteredMarkers = function(){
		if(openMarker || !map){
			return;
		}

		var onlyShowDirect = $filter.prop('checked');

		_.forEach(markers, function(marker){
			if(marker.is_home){
				marker.setVisible(true);
				return;
			}

			if(onlyShowDirect){
				if(marker.data.is_direct){
					marker.setVisible(true);
				} else {
					marker.setVisible(false);
				}
			} else {
				marker.setVisible(true);
			}
		});

		markerCluster.repaint();
	};

	var getFilteredDestinations = function(){
		if($filter.prop('checked')){
			return _.filter(destinations, function(destination){
				return destination.is_direct && !destination.is_home;
			});
		} else {
			return _.filter(destinations, function(destination){
				return !destination.is_home;
			});
		}
	};

	var openDetail = function(detailMarker){
		if(openMarker){
			closeDetail();
		}

		var doverlayPosition = detailMarker.getPosition().lat() < homeMarker.getPosition().lat() ? 'bottom' : 'top';

		openMarker = detailMarker;
		detailMarker.detail = new FlightSearchDetailOverlay(detailMarker, map, doverlayTemplateString, closeDetail, doverlayPosition);

		if(detailMarker !== homeMarker){
			getActiveInput().val(detailMarker.data.value);
		}

		// hide hover overlay
		if(detailMarker.hover){
			detailMarker.hover.setMap(null);
		}

		// hide markers, clusters and hover overlays
		_.forEach(markers, function(marker){
			if(marker === detailMarker || marker.data.is_home){
				marker.setVisible(true);
				return;
			}

			if(marker.hover){
				marker.hover.setMap(null);
			}

			marker.setVisible(false);
		});

		_.forEach(markerCluster.getClusters(), function(cluster){
			if(cluster.hover){
				cluster.hover.setMap(null);
			}
		});

		markerCluster.repaint();

		// show flight curve
		if(detailMarker !== homeMarker){
			if(getActiveDirection() == 'destination'){
				showFlightCurve(homeMarker, detailMarker);
			} else {
				showFlightCurve(detailMarker, homeMarker);
			}
		}

		// center map
		window.setTimeout(function(){
			map.setZoom(5);
			map.fitBounds(getDetailBounds());
		});

		window.setTimeout(function(){
			map.setCenter({
				lat: map.getCenter().lat(),
				lng: openMarker.getPosition().lng(),
			});

			detailMarker.detail.$element.find('.js-doverlay-focus').trigger('focus');

		}, 100);


		checkCheckBox();
	};

	var getDetailBounds = function(){
		var bounds = new google.maps.LatLngBounds();
		var doverlayPosition = openMarker.getPosition().lat() < homeMarker.getPosition().lat() ? 'bottom' : 'top';
		var detailBounds = openMarker.detail.getBounds();
		var projection = map.getProjection();
		var homePoint = projection.fromLatLngToPoint(homeMarker.getPosition());
		var openPoint = projection.fromLatLngToPoint(openMarker.getPosition());

		// balance point mirrors the home marker on the open marker y axis to horizontally center open marker
		var balancePoint = new google.maps.Point(openPoint.x * 2 - homePoint.x, homePoint.y);
		var balanceLatLng = projection.fromPointToLatLng(balancePoint);

		if(doverlayPosition == 'top'){
			balanceLatLng = new google.maps.LatLng(detailBounds.getNorthEast().lat(), balanceLatLng.lng());
		} else {
			balanceLatLng = new google.maps.LatLng(detailBounds.getSouthWest().lat(), balanceLatLng.lng());
		}

		bounds.extend(homeMarker.position);
		bounds.extend(openMarker.position);
		bounds.extend(balanceLatLng);

		return bounds;
	};

	var closeDetail = function(){
		if(!openMarker){
			return;
		}

		// remove the flight path stuff
		if(openMarker.flightCurve){
			google.maps.event.removeListener(openMarker.flightCurve.zoomChangedListener);
			openMarker.flightCurve.animation.stop();
			openMarker.flightCurve.$curvePathSvg.remove();
			openMarker.flightCurve.curveMarker.setMap(null);
			openMarker.flightCurve.planeMarker.setMap(null);
			if(openMarker.flightCurve.nonDirectMarker){
				openMarker.flightCurve.nonDirectMarker.setMap(null);
			}
			delete openMarker.flightCurve;
		}

		// remove the detail overlay
		openMarker.detail.setMap(null);
		delete openMarker.detail;

		openMarker = undefined;
		showFilteredMarkers();

		// clear active input
		getActiveInput().val('').trigger('input');

		checkCheckBox();
	};

	var submitForm = function(){
		if(openMarker){
			getActiveInput().val(openMarker.data.value);
		}

		allowFormSubmit = true;
		$form.submit();
	};

	var showFlightCurve = function(markerStartPoint, markerEndPoint){
		openMarker.flightCurve = {};

		// calculate path curve
		var mapProjection = map.getProjection();
		var p1 = mapProjection.fromLatLngToPoint(markerStartPoint.getPosition());
		var p2 = mapProjection.fromLatLngToPoint(markerEndPoint.getPosition());
		var e = new google.maps.Point(p1.x - p2.x, p1.y - p2.y);
		var m = new google.maps.Point(e.x / 2, e.y / 2);
		var o = new google.maps.Point(0, 1);
		var c = new google.maps.Point(m.x + o.x, m.y + o.y);

		var curvePath = "M 0 0 q " + c.x + " " + c.y + " " + e.x + " " + e.y;

		openMarker.flightCurve.$curvePathSvg = $('<svg><path d="'+curvePath+'" /></svg>');

		var $curvePathElement = openMarker.flightCurve.$curvePathSvg.find('path');
		var curvedPathLength = $curvePathElement[0].getTotalLength();

		openMarker.flightCurve.curveMarker = new google.maps.Marker({
			clickable: false,
			position: markerStartPoint.getPosition(),
			zIndex: 1,
			optimized: false,
			icon: {
				path: curvePath,
				scale: 1 / (Math.pow(2, -map.getZoom())),
				strokeWeight: 2,
				strokeColor: '#000000',
				fillColor: '#000000',
				fillOpacity: 0,
				rotation: 180,
				anchor: new google.maps.Point(0, 0)
			}
		});
		openMarker.flightCurve.curveMarker.setMap(map);

		// redraw path on zoom
		openMarker.flightCurve.zoomChangedListener = google.maps.event.addListener(map, 'zoom_changed', function(){
			var zoom = map.getZoom();
			var scale = 1 / (Math.pow(2, -zoom));
			var icon = {
				path: curvePath,
				scale: scale,
				strokeWeight: 2,
				strokeColor: '#000000',
				fillColor: '#000000',
				fillOpacity: 0,
				rotation: 180,
				anchor: new google.maps.Point(0, 0)
			};
			openMarker.flightCurve.curveMarker.setIcon(icon);
		});

		// add the plane and animate it
		openMarker.flightCurve.planeMarker = new google.maps.Marker({
			clickable: false,
			map: map,
			zIndex: 4,
			position: markerStartPoint.getPosition(),
			icon: {
				path: 'M31.421,19.124c0.351,0.267,0.596,0.843,0.556,1.254l-0.165,1.644c-0.041,0.452-0.412,0.658-0.802,0.472l-12.108-5.446c-0.41-0.164-0.74,0.042-0.76,0.474l-0.103,3.392v0.041l-0.144,4.378c0.041,0.081,0.083,0.123,0.123,0.164l4.194,4.275c0.123,0.165,0.164,0.453,0.041,0.617l-0.842,1.254c-0.104,0.185-0.371,0.246-0.576,0.165l-4.234-1.933c-0.185-0.104-0.514-0.103-0.72-0.021l-4.234,1.932c-0.185,0.102-0.453-0.001-0.576-0.165l-0.843-1.253c-0.144-0.186-0.124-0.452,0.041-0.617l4.173-4.254c0.041-0.041,0.103-0.103,0.123-0.164l-0.248-7.77c-0.02-0.432-0.37-0.659-0.761-0.473L1.471,22.515c-0.411,0.165-0.761-0.02-0.802-0.472l-0.165-1.645c-0.041-0.411,0.207-0.986,0.556-1.253l12.313-9.23c0.351-0.267,0.637-0.843,0.617-1.274l-0.205-5.304c-0.042-1.192,1.007-2.815,2.343-2.836c1.356-0.042,2.466,1.52,2.507,2.712c0,0.043,0,0.083,0,0.125L18.512,7.08l0,0.041L18.471,8.6c0,0.452,0.268,1.006,0.617,1.274L31.421,19.124',
				fillColor: '#000000',
				fillOpacity: 1,
				strokeWeight: 1,
				strokeColor: '#ffffff',
				scale: 1,
				rotation: 20,
				anchor: new google.maps.Point(16.241, 16.171)
			}
		});

		openMarker.flightCurve.animation = $({ progress: 0.1 }).animate({ progress: 0.8 }, {
			duration: 10000,
			easing: 'easeOutCubic',
			step: function(progress){
				var at = curvedPathLength * progress;
				var point = getPointAtLengthWithRotation($curvePathElement[0], at);
				var newLatLng = mapProjection.fromPointToLatLng(new google.maps.Point(p1.x - point.x, p1.y - point.y));
				var newIcon = _.extend(openMarker.flightCurve.planeMarker.icon, {rotation: point.angle + 90});

				openMarker.flightCurve.planeMarker.setPosition(newLatLng);

				if(point.angle !== 0){
					openMarker.flightCurve.planeMarker.setIcon(newIcon);
				}
			}
		});

		// add symbol for non-direct flights
		if(!openMarker.data.is_direct){
			var at = curvedPathLength * 0.5;
			var point = getPointAtLengthWithRotation($curvePathElement[0], at);
			var latLng = mapProjection.fromPointToLatLng(new google.maps.Point(p1.x - point.x, p1.y - point.y));

			openMarker.flightCurve.nonDirectMarker = new google.maps.Marker({
				clickable: false,
				map: map,
				zIndex: 3,
				position: latLng,
				icon: {
					path: 'M1.5,24C0.672,24,0,23.104,0,22V2c0-1.104,0.672-2,1.5-2S3,0.896,3,2v20C3,23.104,2.328,24,1.5,24z M7,22V2c0-1.104-0.672-2-1.5-2S4,0.896,4,2v20c0,1.104,0.672,2,1.5,2S7,23.104,7,22z',
					fillColor: '#000000',
					fillOpacity: 1,
					strokeWeight: 1,
					strokeColor: '#ffffff',
					rotation: point.angle,
					anchor: new google.maps.Point(4, 11)
				}
			});
		}
	};

	var getPointAtLengthWithRotation = function(path, length) {
		var pathLength = path.getTotalLength();
		var p1 = path.getPointAtLength(length);
		var p2 = path.getPointAtLength(length + pathLength * 0.1);
		var deg = Math.atan2(p1.y - p2.y, p1.x - p2.x) * (180 / Math.PI);

		return {
			x: p1.x,
			y: p1.y,
			angle: deg
		};
	};

	var isMapShowing = function(){
		return $(window).width() >= 768;
	};

	var mapStyles = [
		{
			"featureType": "administrative",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#444444"
				}
			]
		},
		{
			"featureType": "administrative.country",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"lightness": "61"
				}
			]
		},
		{
			"featureType": "administrative.country",
			"elementType": "labels",
			"stylers": [
				{
					"lightness": "20"
				},
				{
					"gamma": "1"
				}
			]
		},
		{
			"featureType": "administrative.country",
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "administrative.province",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "administrative.locality",
			"elementType": "labels.text",
			"stylers": [
				{
					"lightness": "10"
				}
			]
		},
		{
			"featureType": "administrative.locality",
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "all",
			"stylers": [
				{
					"color": "#f2f2f2"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -100
				},
				{
					"lightness": 45
				},
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"color": "#dfdfdf"
				},
				{
					"visibility": "on"
				}
			]
		}
	];

	init();
	return api;
};

loop_app.ext['flight-table'] = function($el) {
	var api = {};

	var $element = $el;
	var $body = $element.find('.js-flight-table-body');
	var $overlay = $('.js-overlay');
	var $openRow;

	var template = _.template($element.find('.js-flight-table-template').html());
	var templateOverviewDaySeparator = _.template($element.find('.js-flight-table-template-day-separator').html());
	var templateDay = _.template($element.find('.js-flight-table-template-day').html());
	var templateEmpty = _.template($element.find('.js-flight-table-template-empty').length > 0 ? $element.find('.js-flight-table-template-empty').html() : $('.js-flight-table-template-empty').html());

	var init = function(){
		addListener();
		initStates();
	};

	var initStates = function(){
		enquire.register('screen and (max-width: 767px)', {
			match: function(){},
			unmatch: function(){
				if($openRow){
					closeAccordion($openRow);
				}
			}
		});
	};

	var addListener = function(){
		$element.on('keypress', '.js-flight-table-row', function(e){
			if(e.which == 13){
				$(this).trigger('click');
			}
		});

		$element.on('click', '.js-flight-table-row', function(e){
			e.preventDefault();

			var $row = $(this);
			var windowWidth = $(window).width();

			if(windowWidth < 767){
				toggleAccordion($row);
			} else {
				openOverlay($row.data('href'));
			}
		});

		$element.on('click', '.js-flight-table-overlay-trigger', function(e){
			e.preventDefault();
			e.stopPropagation();

			var $row = $(this).closest('.js-flight-table-row');
			openOverlay($row.data('href'));
		});
	};

	var toggleAccordion = function($row){
		if($row.hasClass('is-open')){
			closeAccordion($row);
		} else {
			openAccordion($row);
		}
	};

	var openOverlay = function(url){
		$overlay.data('obj_overlay').load(url);
	};

	var openAccordion = function($row){
		var $accordion = $row.find('.js-flight-table-accordion');
		var oldAccordionHeight = 0;

		if($openRow){
			oldAccordionHeight = $openRow.find('.js-flight-table-accordion').outerHeight();
			closeAccordion($openRow, false);
		}

		$openRow = $row;

		$row.addClass('is-open');

		$row.trigger('open-flight-table-accordion', {height: $accordion.outerHeight() - oldAccordionHeight});

		$accordion
			.stop()
			.slideDown()
			.velocity({
				opacity: [1, 0]
			}, {
				queue: false
			});

		// for lazy load update
		window.setTimeout(function(){
			$(window).trigger('scroll');
		}, 10);
	};

	var closeAccordion = function($row, triggerEvent){
		if(typeof triggerEvent == 'undefined')
			triggerEvent = true;

		var $accordion = $row.find('.js-flight-table-accordion');

		$openRow = undefined;

		$row.removeClass('is-open');

		if(triggerEvent){
			$row.trigger('close-flight-table-accordion', {height: $accordion.outerHeight()});
		}

		$accordion
			.stop()
			.slideUp()
			.velocity({
				opacity: [0, 1]
			}, {
				queue: false
			});
	};

	var fill = function(data, type){
		if(data.length){
			var html = '';
			var $rows;

			_.forEach(data, function(row){
				row['search_arrival_or_departure'] = type;
				if ( typeof(row.date_separator) !== 'undefined' ) {
					html += templateOverviewDaySeparator(row);
				} else {
					html += template(row);
				}
			});

			$rows = $(html).filter(':not(text)');
			loop_app.initLocalExtensions($rows);

			$rows.each(function(){
				var $row = $(this);

				$row.attr('tabindex', 0);
			});

			$body.html($rows);
			$element.removeClass('is-empty');
		} else {
			empty();
		}
	};

	var fillFlightPlan = function(data, loadMore, loadPrev){
		if(data && data.length){
			var html = '';
			var $days;
			var $rows;
			var first = (loadMore) ? false : true;

			var prependFirstDay = false;

			var translations = {
				previous_flights: 'Earlier Flights',
				previous_day: 'Previous Day',
			};

			if(loop_app.language == 'de'){
				translations = {
					previous_flights: 'Frühere Flüge',
					previous_day: 'Vortag',
				};
			}

			data = _.groupBy(data, function(row){
				return row.datetime.substr(0, 10);
			});

			if (loadPrev) {

				if ($body.find('.flight-table__day:first').data('day') == moment(Object.keys(data)[0]).format('DD/MM/YYYY')) {
					prependFirstDay = true;
				}

			}

			$.each(data, function(key, day) {
				var url = window.location.href;

				var formated_day = moment(key).format('dddd, Do MMMM YYYY');

				if (url.indexOf('/en/') >= 0 ) {
					formated_day = moment(key).format('dddd, MMMM Do YYYY');
				}

				if (!prependFirstDay) {
					html += '<div class="flight-table__day'+ (first ? ' is-top' : '') +'" data-day="'+ moment(key).format('DD/MM/YYYY') +'">' + templateDay({'day': formated_day, 'prev_label': first ? translations.previous_flights : translations.previous_day});
					html += '<div class="wrapper wrapper--main wrapper--flight-plan">';
				}

				first = false;
				_.forEach(day, function(row){
					row.type_long = row.airline_name + ' ' + row.plane_type;
					html += template(row);
				});
				html += '</div></div>';
			});

			$rows = $(html).filter(':not(text)');
			loop_app.initLocalExtensions($rows);

			$rows.find('.js-flight-table-row').each(function(){
				var $row = $(this);

				$row.attr('tabindex', 0);
			});

			if (loadMore) {

				$rows.prepend('<a class="js-load-more-focus" tabindex="-1"></a>');

				var scrollTo = $body.offset().top + $body.height();
				$body.append($rows);
				
				$rows.find('.js-load-more-focus').trigger('focus');

				$('body,html').animate({
					scrollTop: scrollTo - $($('.js-flight-table-row')[0]).outerHeight()
				}, 500);

			} else if (loadPrev) {

				if (!prependFirstDay) {

					$body.prepend($rows);
					$body.find('.flight-table__day.is-top').filter(':gt(0)').removeClass('is-top');
				} else {
					$body.find('.flight-table__day:first>.wrapper.wrapper--main').prepend($rows);

					$body.find('.flight-table__day:first .js-flight-plan-prev').addClass('is-disabled');
				}

			} else {
				$body.html($rows);

			}

			$element.removeClass('is-empty');

			$element.find('.js-flight-plan-load-more').parent().show();

		} else {
			if(!loadMore && !loadPrev){
				empty();
			} else if(loadPrev){
				$body.find('.flight-table__day.is-top .js-flight-plan-prev').addClass('is-disabled');
			}
		}
	};

	api.fill = fill;
	api.fillFlightPlan = fillFlightPlan;

	var empty = function(){
		$body.html(templateEmpty);

		$element.addClass('is-empty');

		$element.find('.js-flight-plan-load-more').parent().hide();
	};
	api.empty = empty;

	init();
	return api;
};

loop_app.ext['form'] = function($el) {
	var api = {};

	var $element = $el;
	var $toggles = $element.find('.js-form-toggle');

	var init = function(){
		if ($element.find('.js-recaptcha').length > 0) {
			loop_app.initRecaptcha();
		}

		if($toggles.length){
			$toggles.hide();
			checkToggles(false);
		}

		initValidation();
		initDateMinElement();
		initLinkOn();
		addListener();
	};

	var initValidation = function(){
		$element.validate({
			ignore: ".js-form-ignore, .js-form-ignore *",
			errorElement: 'span',
			onsubmit: false,
			rules: {
				email: {
					required: true,
					email: true
				},
				recaptcha: {
					required: function(input){
						return !$(input).prev('.js-recaptcha').data('recaptchaValid');
					}
				}
			},
			errorPlacement: function(error, element) {
				error.addClass('form__error');

				if(element.is('[type="radio"]') && element.closest('radiogroup')){
					error.addClass('form__error--radio');
					element.closest('radiogroup').append(error);
				} else {
					error.insertAfter(element);
				}
			}
		});

		// $('input[type="text"], textarea').rules( "add", {
		// 	doNotAllowUrls : true
		// });

		$element.find('input[type="text"]:not([name="email"]), textarea').each(function() {
			$(this).rules( "add", {
				doNotAllowUrls : true
			});
		});
	};

	var initDateMinElement = function(){
		$element.find('[data-datemin-element]').each(function(){
			var $input = $(this);
			var $origin = $element.find($input.attr('data-datemin-element'));
			var mDate = moment($origin.attr('data-rule-datemin'), 'YYYY-MM-DD');

			if($origin.val()){
				mDate = moment($origin.val(), 'DD.MM.YYYY');

				if(!mDate.isValid()){
					mDate = moment($origin.val(), 'YYYY-MM-DD');
				}
			}

			$input.attr('data-rule-datemin', mDate.format('YYYY-MM-DD'));
			$input.attr('data-start-date', mDate.format('YYYY-MM-DD'));

			$input.rules('add', {dateMin: mDate.format('YYYY-MM-DD')});
			$input.trigger('updatedatepicker');

			$origin.off('change.dateminelement datepicker-change.dateminelement');
			$origin.on('change.dateminelement datepicker-change.dateminelement', function(){
				initDateMinElement();
			});
		});
	};

	var initLinkOn = function(){
		$element.find('.js-form-link-on').each(function(){
			var $input = $(this);

			if($input.val() == $input.data('form-link-on-value')){
				$input.val('');
			}

			$input.on('change', function(){
				if($input.val() == $input.data('form-link-on-value')){
					window.alert($input.data('form-link-on-message'));
					window.location.href = $input.data('form-link-on-link');
				}
			});
		});
	};

	var addListener = function(){
		$element.on('submit.form', function(e){
			if(!$element.valid()) {
				e.preventDefault();
			} else if ($(this).hasClass('js-parking-widget')) {

				// $(this).find('[name="data[entry-date]"]').val( moment($(this).find('[name="data[entry-date]"]').val(), 'DD.MM.YYYY').format('DD/MM/YYYY') );
				// $(this).find('[name="data[exit-date]"]').val( moment($(this).find('[name="data[exit-date]"]').val(), 'DD.MM.YYYY').format('DD/MM/YYYY') );

				// e.preventDefault();
				// console.log($(this).serializeArray());

				// var fromDateTime = '';
				// var tillDateTime = '';
				// var fromDateIsToday = true;
				// var tillDateIsToday = true;
				// var now = moment();

				// if ($(this).find('[name=parking_in_date]').val()) {
				// 	fromDateTime = moment($(this).find('[name=parking_in_date]').val(), 'DD.MM.YYYY').format('DD/MM/YYYY');
				// 	fromDateIsToday = (moment($(this).find('[name=parking_in_date]').val(), 'DD.MM.YYYY').isSame(now, "day"));
				// }
				// if ($(this).find('[name=parking_in_time]').val() == '' && fromDateTime != '') {
				// 	fromDateTime += fromDateIsToday ? now.add(5,'minutes').format('HHmm') : '0000';
				// } else {
				// 	fromDateTime += $(this).find('[name=parking_in_time]').val().replace(':','');
				// }

				// if ($(this).find('[name=parking_out_date]').val()) {
				// 	tillDateTime = moment($(this).find('[name=parking_out_date]').val(), 'DD.MM.YYYY').format('DD/MM/YYYY');
				// 	tillDateIsToday = (moment($(this).find('[name=parking_out_date]').val(), 'DD.MM.YYYY').isSame(now, "day"));
				// }
				// if ($(this).find('[name=parking_out_time]').val() == '' && fromDateTime != '') {
				// 	tillDateTime += tillDateIsToday ? now.add(5,'minutes').format('HHmm') : '0000';
				// } else {
				// 	tillDateTime += $(this).find('[name=parking_out_time]').val().replace(':','');
				// }

				// var data = {
				// 	'_method': $(this).find('[name="_method"]').val(),
				// 	'data[entry-date]' : moment($(this).find('[name="data[entry-date]"]').val(), 'DD.MM.YYYY').format('DD/MM/YYYY'),
				// 	'data[entry-time]' : $(this).find('[name="data[entry-time]"]').val(),
				// 	'data[exit-date]' : moment($(this).find('[name="data[exit-date]"]').val(), 'DD.MM.YYYY').format('DD/MM/YYYY'),
				// 	'data[exit-time]' : $(this).find('[name="data[exit-time]"]').val(),
				// }

				// console.log(data);
				// console.log($.param(data));

				// window.location = ($(this).attr('action')+'&'+$.param(data));
			}
		});

		$element.find('select').on('change', function(){
			$(this).valid();
			$(this).blur();
		});

		$element.find('select').on('focus', function(e){
			$(this).trigger('click');
		});

		$element.find('select').on('keypress', function(e){
			if (e.keyCode == 13) {
				e.preventDefault();
				e.stopPropagation();
			}
		});

		$element.find('.js-recaptcha').on('change', function(){
			$(this).next('input').valid();
		});

		if($toggles.length){
			$element.on('change', 'input, select, textarea', function(){
				checkToggles();
			});
		}
	};

	var checkToggles = function(animate){
		if(typeof animate == 'undefined')
			animate = true;

		$toggles.each(function(){
			var $toggle = $(this);
			var name = $toggle.data('form-toggle-name');
			var value = $toggle.data('form-toggle-value');
			var $input = $element.find('[name="'+name+'"]');
			var data = _.keyBy($element.serializeArray(), 'name');

			if(data[name] && data[name].value == value){
				$toggle.removeClass('js-form-ignore');
				initValidation();

				if($toggle.is(':hidden')){
					$toggle.velocity('slideDown', {
						duration: animate ? 400 : 0
					});
				}
			} else if(!data[name] || data[name] && data[name].value != value){
				$toggle.addClass('js-form-ignore');
				initValidation();

				if($toggle.is(':visible')){
					$toggle.velocity('slideUp', {
						duration: animate ? 400 : 0
					});
				}
			}
		});
	};

	init();
	return api;
};

loop_app.ext['gallery'] = function($el) {
	var api = {};

	var $element = $el;
	var $site = $('.js-site');
	var $items = $element.find('.js-gallery-item');

	if ($element.hasClass('js-news-detail-gallery-head')) {
		$.merge($items, $('.js-news-detail-gallery-body').find('.js-gallery-item'));
	}

	var $overlay;
	var $overlayInner;
	var $overlayContent;

	var baseMarkup = '<div class="overlay js-gallery-overlay" role="dialog">' +
		'<div class="overlay__background js-gallery-overlay-background"></div>' +
		'<div class="overlay__inner overlay__inner--gallery js-gallery-overlay-inner">' +
			'<a href="#" class="overlay__close overlay__close--white js-gallery-overlay-close" aria-label="'+loop_app.translations.close+'"></a>' +
			'<div class="overlay__prev js-gallery-overlay-prev u-hide@tablet-landscape" aria-label="'+loop_app.translations.prev_image+'" tabindex="0"></div>' +
			'<div class="overlay__next js-gallery-overlay-next u-hide@tablet-landscape" aria-label="'+loop_app.translations.next_image+'" tabindex="0"></div>' +
			'<div class="overlay__content js-gallery-overlay-content">' +
			'</div>' +
		'</div>' +
		'<div class="overlay__prev js-gallery-overlay-prev u-hide@max-tablet-landscape" tabindex="0" aria-label="'+loop_app.translations.prev_image+'"></div>' +
		'<div class="overlay__next js-gallery-overlay-next u-hide@max-tablet-landscape" tabindex="0" aria-label="'+loop_app.translations.next_image+'"></div>' +
	'</div>';

	var contentTemplate = _.template('<div class="goverlay__image-container" style="padding-bottom: <%- height * 100 / width %>%; max-width: 100%;"><img src="<%- src %>" width="<%- width %>" height="<%- height %>" alt="<%- alt ? alt : "" %>" class="goverlay__image"></div><div class="goverlay__content"><%= content ? content : "" %></div>');

	var activeIndex;

	const overlayFocusTrap = window.focusTrap.createFocusTrap(null, {
		onDeactivate: function(){
			close();
		}
	});

	var init = function() {
		buildOverlay();
		addListener();

		overlayFocusTrap.updateContainerElements($overlay.get(0));
	};

	var addListener = function(){
		$items.on('click', function(e){
			e.preventDefault();
			e.stopImmediatePropagation();
			load($(this));
		});

		$items.on('keypress', function(e) {
			if (e.keyCode == 13) {
				$(this).trigger('click');
			}
		});

		$overlay.on('click', '.js-gallery-overlay-close, .js-gallery-overlay-background', function(e){
			e.preventDefault();
			close();
		});

		loop_app.createA11yButton($overlay.find('.js-gallery-overlay-prev').get(0));
		loop_app.createA11yButton($overlay.find('.js-gallery-overlay-next').get(0));

		$overlay.on('click', '.js-gallery-overlay-prev', function(e){
			e.preventDefault();
			prev();
		});


		$overlay.on('click', '.js-gallery-overlay-next', function(e){
			e.preventDefault();
			next();
		});
	};

	var load = function($trigger, direction){
		var url = $trigger.attr('href') || $trigger.data('gallery-href');
		var animationDefer = $.Deferred();
		var loadingDefer = $.Deferred();
		var scrollTop = $(window).scrollTop();

		if($items.filter(':visible').length <= 1){
			$overlay.find('.js-gallery-overlay-prev, .js-gallery-overlay-next').addClass('is-disabled');
		} else {
			$overlay.find('.js-gallery-overlay-prev, .js-gallery-overlay-next').removeClass('is-disabled');
		}

		if(overlayFocusTrap.active){
			$overlayInner.velocity({
				translateY: -scrollTop
			}, {
				duration: 0
			});

			$(window).scrollTop(0);

			var animationProperties = {
				translateY: [-50 - scrollTop, -scrollTop],
				opacity: [0, 1],
			};

			if(direction == 'next') {
				animationProperties = {
					translateX: [-50, 0],
					opacity: [0, 1],
				};
			}

			if(direction == 'prev') {
				animationProperties = {
					translateX: [50, 0],
					opacity: [0, 1],
				};
			}

			$overlayInner.velocity(animationProperties, {
				duration: 500,
				easing: "easeOutQuart",
				complete: function(){
					animationDefer.resolve();
				}
			});
		} else {

			$site.css({
				position: 'fixed',
				top: -scrollTop,
				left: 0,
				right: 0,
				overflow: 'hidden',
				height: 'calc(100vh + '+scrollTop+'px)'
			});

			$overlay.velocity({
				opacity: [1, 0]
			}, {
				duration: 300,
				complete: function(){
					animationDefer.resolve();

					
				}
			});
		}

		$overlay.addClass('is-loading');

		var $image = $('<img src="'+url+'">');

		$image.on('load', function(){
			loadingDefer.resolve({
				width: $image[0].naturalWidth,
				height: $image[0].naturalHeight,
				src: url,
				$trigger: $trigger,
				animationDirection: direction,
			});
		});

		overlayFocusTrap.activate();

		$.when(loadingDefer, animationDefer).done(function(data){
			show(data);
			var margin = parseInt(($(window).height() - $overlayInner.height()) / 2);
			margin = (margin < 15) ? 15 : margin;
			$overlayInner.css('margin', margin + 'px auto');
			$overlay.removeClass('is-loading');
		});
	};

	var show = function(data){
		var params = {
			width: data.width,
			src: data.src,
			height: data.height,
			alt: data.$trigger.data('gallery-alt'),
			content: data.$trigger.find('.js-gallery-content').html().replace('data-tabindex','tabindex')
		};

		var $newContent = $(contentTemplate(params));
		var $visibleItems = $items.filter(':visible');

		$overlayContent.css('width', params.width);

		$overlayContent.html($newContent);
		loop_app.initLocalExtensions($newContent);

		var animationProperties = {
			translateY: [0, -50],
			opacity: [1, 0]
		};

		if(data.animationDirection == 'next'){
			animationProperties = {
				translateX: [0, 50],
				opacity: [1, 0]
			};
		}

		if(data.animationDirection == 'prev'){
			animationProperties = {
				translateX: [0, -50],
				opacity: [1, 0]
			};
		}

		$overlayInner.velocity(animationProperties, {
			duration: 500,
			easing: "easeOutQuart",
		});

		$overlay.addClass('is-open');

		activeIndex = $visibleItems.index(data.$trigger);
	};

	var close = function(){
		$('.js-gallery-overlay').off('keydown');
		$('.js-site').removeAttr('aria-hidden');

		var scrollTop = parseInt($site.css('top')) * -1;

		$overlay.velocity({
			opacity: 0,
		}, {
			duration: 300,
		});

		overlayFocusTrap.deactivate();


		$overlayInner.velocity({
			translateY: [-50, 0],
			opacity: [0, 1],
		}, {
			duration: 500,
			easing: "easeOutQuart",
			complete: function(){
				if(overlayFocusTrap.active){
					return;
				}

				$site.css({
					position: '',
					top: '',
					left: '',
					right: '',
					overflow: '',
					height: ''
				});

				$overlay.removeClass('is-open');

				$(window).scrollTop(scrollTop);

				$overlayContent.html('');
			},
		});

	};

	var prev = function(){
		var $visibleItems = $items.filter(':visible');
		var prevIndex = activeIndex - 1 < 0 ? $visibleItems.length - 1 : activeIndex - 1;
		var $prevItem = $visibleItems.eq(prevIndex);

		load($prevItem, 'prev');
	};

	var next = function(){
		var $visibleItems = $items.filter(':visible');
		var $nextItem = $visibleItems.eq((activeIndex + 1) % $visibleItems.length);

		load($nextItem, 'next');
	};

	var buildOverlay = function(){
		$overlay = $(baseMarkup);
		$overlay.insertAfter($site);
		$overlayInner = $overlay.find('.js-gallery-overlay-inner');
		$overlayContent = $overlay.find('.js-gallery-overlay-content');
	};

	init();
	return api;
};

loop_app.ext['gate'] = function($el) {
	var api = {};

	var $element = $el;
	var $graphic = $element.find('.js-gate-graphic');
	var $pling = $element.find('.js-gate-pling');
	var $person = $element.find('.js-gate-person');
	var $value = $element.find('.js-gate-value');

	var waitingCount = 1;
	var waitingTimeMinutes = 0;
	var animationRunning = false;
	var interval;
	var animationDeferred = $.Deferred();

	var timeline;

	var init = function(){
		if ($value.data('is-closed') == true) {
			$person.hide();
		}
		else {
			timeline = new TimelineMax({repeat: -1, onRepeat: function(){
				updatePeople(true);
			}});

			$person.show();
			$person.clone().attr('style', '').css('opacity', 0).prependTo($graphic);

			updateTimeline();
		}

		loadData();

		interval = window.setInterval(function(){
			loadData();
		}, 5 * 60 * 1000); // update once every 5 minutes

		enquire.register('screen and (max-width: 767px)', {
			match: function(){
				$element.prependTo($element.parent().parent().parent());
				updateWaitingTime(waitingTimeMinutes);
			},
			unmatch: function(){
				$element.prependTo($element.parent().find('.row .gr-12.u-hide\\@max-tablet'));
				updateWaitingTime(waitingTimeMinutes);
			},
		});
	};

	var loadData = function(){
		$.ajax({
			url: $element.data('api'),
			success: function(data){
				updateWaitingTime(data.waiting_time_minutes);
			},
			error: function(){
				// TODO: error handling
				console.error(arguments);
			}
		});
	};

	var getPeople = function(){
		return $element.find('.js-gate-person');
	};


	var updateTimeline = function(){
		var $people = getPeople();

		timeline.clear();

		$people.each(function(index){
			var $p = $(this);

			if(index + 1 >= $people.length){
				// last person
				timeline.add(TweenMax.fromTo($p, 0.3, {x: 0, y: 0, opacity: 1, scale: 1}, {x: 39, y: 0, opacity: 1, scale: 1, ease: Linear.easeNone}), 0);
			} else if(index === 0){
				// first person
				timeline.add(TweenMax.fromTo($p, 0.2, {x: 18, y: -10, opacity: 0, scale: 1}, {x: 18, y: 0, opacity: 1, scale: 1, ease: Linear.easeNone}), 0.1);
			} else {
				// all other people
				timeline.add(TweenMax.fromTo($p, 0.2, {x: 0, y: 0, opacity: 1, scale: 1}, {x: 18, y: 0, opacity: 1, scale: 1, ease: Linear.easeNone}), 0);
			}
		});

		timeline.add(TweenMax.fromTo($pling, 0.3, {scale: 0.6, opacity: 0}, {scale: 1, opacity: 1, ease: Linear.easeNone}));
		timeline.add(TweenMax.to($pling, 0.2, {scale: 0.6, opacity: 0, ease: Linear.easeNone, delay: 0.6}));
		timeline.add(TweenMax.fromTo($people.last(), 0.3, {scale: 1, opacity: 1, x: 39, y: 0}, {scale: 0.8, opacity: 0, x: 49, y: -8, ease: Linear.easeNone}));
	};

	var updatePeople = function(offset){
		var $people = getPeople();
		var difference = (waitingCount + 1) - $people.length;

		if(difference !== 0){
			timeline.stop();

			if(difference > 0){
				var $newPeople = $();

				for (var i = 0; i < difference; i++) {
					$newPeople = $newPeople.add($person.clone().attr('style', '').css('opacity', 0).prependTo($graphic));
				}

				$newPeople.each(function(index){
					$(this).velocity({
						opacity: 1,
						translateX: (offset ? [18, 18] : 0),
						translateY: [0, -10]
					}, {
						duration: 200,
						delay: ($newPeople.length - index) * 50,
						complete: function(){
							if(index + 1 == $newPeople.length){
								window.setTimeout(function(){
									timeline.seek(0);
									updateTimeline();
									timeline.play();
								}, 300);
							}
						}
					});
				});
			} else {
				var $oldPeople = $people.filter(':gt(0):lt(' + Math.abs(difference) + ')');

				$oldPeople.each(function(index){
					$(this).velocity({
						opacity: 0,
						translateY: 10
					}, {
						duration: 200,
						delay: index * 50,
						complete: function(){
							$(this).remove();

							if(index + 1 == $oldPeople.length){
								window.setTimeout(function(){
									timeline.seek(0);
									updateTimeline();
									timeline.play();
								}, 300);
							}
						}
					});
				});
			}
		}
	};

	var updateWaitingTime = function(minutes){
		waitingTimeMinutes = Math.min(minutes, 60);

		if (waitingTimeMinutes >= 60) {
			$value.html(humanizeDuration(moment.duration(parseInt(waitingTimeMinutes), 'minutes').asMilliseconds(), {language: loop_app.language}));
		} else {
			$value.html(humanizeDuration(moment.duration(parseInt(waitingTimeMinutes), 'minutes').asMilliseconds(), {language: loop_app.language, units: ['m']}));
		}

		if ($value.data('is-closed') == true) {
			$value.html($value.data('is-closed-message'));
		}

		waitingCount = Math.max(1, Math.floor(waitingTimeMinutes / 10));

		if($(window).width() < 768){
			waitingCount = Math.min(2, waitingCount);
		}
	};

	init();
	return api;
};

loop_app.ext['header'] = function($el) {
	var api = {};

	var $element = $el;
	var $navigation = $element.find('.js-header-navigation');
	var $navigationLinks = $element.find('.js-header-navigation-link');
	var $navigationSubs = $element.find('.js-header-navigation-sub');
	var $navigationIndicator = $element.find('.js-header-navigation-indicator');
	var $mask = $element.find('.js-header-mask');
	var $trigger = $element.find('.js-header-trigger');

	var $search = $element.find('.js-header-search');
	var $searchTrigger = $element.find('.js-header-search-trigger');
	var $searchDetail = $element.find('js-search-detail');

	var $searchInput404 = $('.js-search-input-404');
	var $searchReset = $('.js-search-value-reset');
	var $openNavigationSub;
	var isMobileOpen = false;
	var isSubAnimating = false;
	var mobileNavigationBreakPoint = 1130;
	var isMobileSearchOpen = false;

	const searchFocusTrap = window.focusTrap.createFocusTrap($search.get(0), {
		escapeDeactivates: () => {
			$searchTrigger.trigger('click');
			return false;
		},
		clickOutsideDeactivates: false,
		clickOutsideDeactivates: false,
		allowOutsideClick: true,
	});

	var init = function() {
		loop_app.createA11yButton($trigger.get(0))
		loop_app.createA11yButton($searchTrigger.get(0))

		addListener();
		addStateChange();
	};

	var addListener = function(){
		$element.on('focusout', function(e) {
			// Check if the newly focused element is outside the header
			if (e.relatedTarget && !$element.has(e.relatedTarget).length && !e.relatedTarget.closest('[role="dialog"]')) {
				closeSub();
			}
		});

		$navigationLinks.on('keydown', function(e){
			if (e.keyCode == 13) {
				e.preventDefault();
				e.stopPropagation();
				$(this).trigger('click');
			}
		});

		$navigationLinks.on('click.header', function(e){
			e.preventDefault();

			var $link = $(this);
			var $sub = $link.next('.js-header-navigation-sub');

			toggleSub($sub, $link);
		});

		$navigationLinks.on('mouseenter.header', function(e){
			var $link = $(this);

			repositionIndicator($link);
		});

		$navigationLinks.on('mouseleave.header', function(e){
			repositionIndicator($navigationLinks.filter('is-active'));
		});

		$mask.on('click.header', function(e){
			if(isMobile() && isTablet()){
				closeMobileNavigation();
			} else {
				closeSub();
			}
		});

		$trigger.on('click.header', function(e){
			toggleMobileNavigation();
		});

		$searchTrigger.on('click.header', function(e){
			e.preventDefault();

			if(isMobile()){
				toggleMobileSearch();
			} else {
				toggleSub($search);
			}

			// if (!$(this).hasClass('is-open')) {
			// 	$search.find('.adsbygoogle').remove();
			// } else if ($searchDetail.is('visible')) {
			// 	$search.data('obj_search').initSearchAd();
			// }

		});

		// close sub navigation on escape key
		$navigationSubs.add($navigationLinks).on('keydown', function(e){
			if(e.key === 'Escape'){
				if (!$navigationLinks.is(document.activeElement)) {
					if ($navigationLinks.filter('.is-open').length > 0) {
						$navigationLinks.filter('.is-open').trigger('focus');
					} else {
						$searchTrigger.trigger('focus');
					}
				}

				closeSub();
			}
		});

		$(window).on('scroll', _.throttle(function(){
			if($openNavigationSub
				&& $(window).width() >= mobileNavigationBreakPoint
				&& ($openNavigationSub[0] !== $search[0] || !$search.data('obj_search').isSearchDetailOpen())){

				var subOffset = $openNavigationSub.offset();
				var subHeight = $openNavigationSub.height();
				var scrollTop = $(window).scrollTop();

				if(scrollTop >= subOffset.top + subHeight/2){
					closeSub();
				}
			}
		}, 200));

		$(window).resize(function() {
			if ($('html').hasClass('is-mobile-navigation-open')) {
				$('.js-header-navigation-list').css('height', ($(window).height() - 50 - 100) + 'px');
			}
		});
	};

	var addStateChange = function(){
		// desktop
		enquire.register('screen and (min-width: ' + mobileNavigationBreakPoint + 'px)', {
			unmatch: function(){
				$openNavigationSub = undefined;
				$mask.removeClass('is-visible');
				$navigationSubs.attr('style', '');
				$navigationLinks.removeClass('is-open');
				repositionIndicator();
			}
		});

		// mobile
		enquire.register('screen and (max-width: ' + (mobileNavigationBreakPoint - 1) + 'px)', {
			unmatch: function(){
				isMobileOpen = false;
				$openNavigationSub = undefined;
				$mask.removeClass('is-visible');
				$navigationSubs.css('display', '');
				$navigationLinks.removeClass('is-open');
				$('html').removeClass('is-mobile-navigation-open');
				$('html').removeClass('is-mobile-navigation-sub-open');
				repositionIndicator();
			}
		});
	};

	var toggleSub = function($sub){
		if(isMobile()){
			openMobileSub($sub);
		} else {
			if($openNavigationSub && $openNavigationSub[0] === $sub[0]){
				closeSub();
			} else {
				openSub($sub);
			}
		}
	};

	var openSub = function($sub){
		if(isSubAnimating){
			return;
		}

		var $oldSub = $openNavigationSub;
		var isNewSearch = $sub[0] === $search[0];

		$navigationLinks.removeClass('is-open').attr('aria-expanded', 'false');
		$searchTrigger.removeClass('is-open');

		if(isNewSearch){
			$searchTrigger.addClass('is-open');
		} else {
			$sub.prev('.js-header-navigation-link').addClass('is-open').attr('aria-expanded', 'true')
		}

		repositionIndicator();
		isSubAnimating = true;
		$openNavigationSub = $sub;

		if($oldSub){
			var isOldSearch = $oldSub[0] === $search[0];
			var $oldItem = $oldSub.closest('.js-header-navigation-item');
			var $item = $sub.closest('.js-header-navigation-item');
			var newTranslate = [0, '100%'];
			var oldTranslate = '-100%';

			if(isOldSearch || !isNewSearch && $oldItem.index() > $item.index()){
				newTranslate = [0, '-100%'];
				oldTranslate = '100%';
			}

			if(isOldSearch){
				$search.trigger('beforeClose');
			}

			$sub.velocity({
				translateX: newTranslate,
				translateY: ['0%', '0%']
			}, {
				duration: 500,
				display: 'block',
				easing: 'easeInOutQuart',
				complete: function(){
					isSubAnimating = false;

					if(isNewSearch){
						$search.trigger('open');
						searchFocusTrap.activate();
					}

					if(isOldSearch){
						$search.trigger('close');
						searchFocusTrap.deactivate();
					}

					//loop_app.setFocusableOverlayEls($sub);
				}
			});

			$oldSub.velocity({
				translateX: oldTranslate,
				translateY: ['0%', '0%']
			}, {
				duration: 500,
				display: 'none',
				easing: 'easeInOutQuart'
			});
		} else {
			/* $element.on('keydown', function(e) {
				loop_app.handleKeyDownOverlay(e, $element, 'header');
			}); */

			$mask.addClass('is-visible');

			$sub.velocity({
				translateY: ['0%', '-100%'],
				translateX: ['0%', '0%']
			}, {
				duration: 500,
				display: 'block',
				easing: 'easeInOutQuart',
				complete: function(){
					isSubAnimating = false;

					if(isNewSearch){
						$search.trigger('open');
						searchFocusTrap.activate();
					}

					//loop_app.setFocusableOverlayEls($sub);
				}
			});
		}
	};

	var closeSub = function(){
		$element.off('keydown');

		if(!$openNavigationSub || isSubAnimating){
			return;
		}

		var isOpenSearch = false;

		if($openNavigationSub && $openNavigationSub[0] === $search[0]){
			isOpenSearch = true;
		}

		isSubAnimating = true;


		$mask.removeClass('is-visible');
		$navigationLinks.removeClass('is-open').attr('aria-expanded', 'false');
		$searchTrigger.removeClass('is-open');

		if ($search.hasClass('is-external')) {
			$searchInput404.val('');
			$search.removeClass('is-external');
		}

		if (window.location.href.indexOf('?') > -1) {
			history.pushState('', document.title, window.location.pathname);
		}

		repositionIndicator();

		if(isOpenSearch){
			searchFocusTrap.deactivate();
			$search.trigger('beforeClose');
		}

		$openNavigationSub.velocity({
			translateY: '-100%'
		}, {
			duration: 500,
			display: 'none',
			easing: 'easeInOutQuart',
			delay: 10,
			complete: function(){
				$openNavigationSub = undefined;
				isSubAnimating = false;

				if(isOpenSearch){
					$search.trigger('close');
				}
			}
		});
	};

	var repositionIndicator = function($link){
		var width = 0;
		var left = 0;

		if(!$link || !$link.length){
			$link = $navigationLinks.filter('.is-open');
		}

		if($link.length){
			width = $link.width();
			left = $link.offset().left + parseFloat($link.css('padding-left'));
		}

		$navigationIndicator.css({
			'-webkit-transform': 'translateX(' + left + 'px)',
			'-ms-transform': 'translateX(' + left + 'px)',
			'transform': 'translateX(' + left + 'px)',
			'width': width
		});
	};

	var toggleMobileNavigation = function(){
		if(isMobileOpen){
			if($openNavigationSub && !isTablet()){
				closeMobileSub();
			} else {
				closeMobileNavigation();
			}
		} else {
			openMobileNavigation();
		}
	};

	var openMobileNavigation = function(){
		isMobileOpen = true;

		if(isMobileSearchOpen) {
			closeMobileSearch();
		}

		if ($(window).width() < 375) {
			$('.js-header-navigation-list').css('height', ($(window).height() - 50 - 100) + 'px');
		} else {
			$('.js-header-navigation-list').css('height', ($(window).height() - 50 - 80) + 'px');
		}

		if($(window).scrollTop() > 0){
			$('html, body').animate({
				scrollTop: 0
			}, {
				duration: 100,
				complete: function(){
					$('html').addClass('is-mobile-navigation-open');
				}
			});
		} else {
			$('html').addClass('is-mobile-navigation-open');
		}
	};

	var openMobileSub = function($sub){
		if($openNavigationSub){
			if($sub[0] === $openNavigationSub[0])
				return;

			closeMobileSub(function(){
				openMobileSub($sub);
			});

			return;
		}
		$navigationLinks.removeClass('is-open');
		$sub.prev('.js-header-navigation-link').addClass('is-open');

		$openNavigationSub = $sub;
		$sub.css('display', 'block');

		$navigation.addClass('is-animating-sub');
		window.setTimeout(function(){
			$navigation.removeClass('is-animating-sub');
		}, 500);

		// delay add class to let browser render formerly display none sub element (tablet)
		window.setTimeout(function(){
			$('html').addClass('is-mobile-navigation-sub-open');
		}, 1);

		$navigation.animate({
			scrollTop: 0
		}, {
			duration: 100
		});
	};

	var closeMobileSub = function(callback){
		var animate = function(){
			if(!$openNavigationSub)
				return;

			$('html').removeClass('is-mobile-navigation-sub-open');

			window.setTimeout(function(){
				$openNavigationSub.css('display', '');
				$openNavigationSub = undefined;

				if(_.isFunction(callback)){
					callback();
				}
			}, 500);
		};

		if($(window).scrollTop() > 0){
			$('html, body').animate({
				scrollTop: 0
			}, {
				duration: 200,
				complete: function(){
					animate();
				}
			});
		} else {
			animate();
		}
	};

	var closeMobileNavigation = function(){

		if($openNavigationSub){
			closeMobileSub(function(){
				closeMobileNavigation();
			});
		} else {
			isMobileOpen = false;
			$('html').removeClass('is-mobile-navigation-open');

			$('.js-header-navigation-list').removeAttr('style');
		}
	};

	var toggleMobileSearch = function(){
		if(isMobileSearchOpen){
			closeMobileSearch();
		} else {
			openMobileSearch();
		}
	};

	var openMobileSearch = function(){
		isMobileSearchOpen = true;

		$searchTrigger.addClass('is-open');
		$mask.addClass('is-visible');

		$search.velocity({
			opacity: [1, 0],
			translateY: [0, -30]
		}, {
			display: 'block',
			easing: 'easeOutQuart',
			complete: function(){
				$search.trigger('open');
				searchFocusTrap.activate();
			}
		});
	};

	var closeMobileSearch = function(){
		isMobileSearchOpen = false;

		$search.trigger('beforeClose');
		searchFocusTrap.deactivate();

		$searchTrigger.removeClass('is-open');
		$mask.removeClass('is-visible');

		if ($search.hasClass('is-external')) {
			$searchInput404.val('');
			$search.removeClass('is-external');
		}

		if (window.location.href.indexOf('?') > -1) {
			history.pushState('', document.title, window.location.pathname);
		}

		$search.velocity({
			opacity: 0,
			translateY: -30
		}, {
			display: 'none',
			easing: 'easeOutQuart',
			complete: function(){
				$search.trigger('close');
			}
		});
	};

	api.closeOverlay = closeSub;

	var isMobile = function(){
		return $(window).width() < mobileNavigationBreakPoint;
	};

	var isTablet = function(){
		return $(window).width() >= 768;
	};

	init();
	return api;
};

loop_app.ext['hero'] = function($el) {
	var api = {};

	var $element = $el;
	var $swiper = $element.find('.js-hero-swiper');
	var $pagination = $element.find('.js-hero-pagination');
	var $pause = $element.find('.js-hero-swiper-pause');
	var $play = $element.find('.js-hero-swiper-play');

	loop_app.createA11yButton($pause.get(0));
	loop_app.createA11yButton($play.get(0));

	var mySwiper;

	var init = function() {

		if ($swiper.find('.swiper-slide').length > 1) {

			mySwiper = new Swiper($swiper, {
				autoHeight: true,
				pagination: $pagination,
				bulletClass: 'bullet',
				autoplay: 8000,
				speed: 1000,
				loop: true,
				parallax: true,
				paginationClickable: true,
				bulletActiveClass: 'is-active',
				paginationClickableClass: 'is-clickable',
				a11y: true,
				prevSlideMessage: loop_app.translations.prev_slide,
				nextSlideMessage: loop_app.translations.next_slide,
				paginationBulletMessage: loop_app.translations.go_to_slide,
				paginationBulletRender: function (swiper, index, className) {
					return '<span class="' + className + ' bullet--white"></span>';
				},
				onTouchMove: function(swiper){
					swiper.params.speed = 300;
				},
				onTransitionEnd: function(swiper){
					swiper.params.speed = 1000;
					$(window).trigger('scroll');

					$(swiper.slides).attr('inert','true');
					$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
				},
				onInit: function(swiper){
					$(swiper.slides).attr('inert','true');
					$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
				}
			});

			$pause.on('click', function() {
				mySwiper.stopAutoplay();
				$pause.hide().removeAttr('tabindex').attr('aria-hidden','true');
				$play.show().attr('tabindex','0').attr('aria-hidden','false').focus();
			});

			$play.on('click', function() {
				mySwiper.startAutoplay();
				$play.hide().removeAttr('tabindex').attr('aria-hidden','true');
				$pause.show().attr('tabindex','0').attr('aria-hidden','false').focus();
			});

		} else {
			$pagination.hide();
			$pause.hide();
			$play.hide();
		}
	};

	init();
	return api;
};

loop_app.ext['hyphens'] = function($el) {
	var api = {};

	var $element = $el;

	var init = function() {
		$element.hyphenate($('html').attr('lang') || 'de');
	};

	init();
	return api;
};

loop_app.ext['is-input-filled'] = function($el) {
	var api = {};

	var $element = $el;
	var interval;

	var init = function() {
		check();

		if($element.data('is-filled-no-focus') !== true){
			$element.on('focus', function(){
				if (!$element.is('select') && !$element.hasClass('js-datepicker')) {
					addClass();
				}
			});
			$element.on('change', function() {
				addClass();
			});
		}

		$element.on('blur', _.debounce(function(){
			if(!$element.val()){
				removeClass();
			}
		}, 100));

		$element.on('input', function(){
			check();
		});

		// regular checkup for
		interval = window.setInterval(function(){
			if($element.val()){
				addClass();
			} else {
				if(!$element.is(':focus')){
					removeClass();
				}
			}
		}, 1000);

		$element.on('destroy', function(){
			window.clearInterval(interval);
		});
	};

	var check = function(){
		if($element.val()){
			addClass();
		} else {
			removeClass();
		}
	};

	var addClass = function(){
		$element.addClass('is-filled');
	};

	var removeClass = function(){
		$element.removeClass('is-filled');
	};

	init();
	return api;
};

loop_app.ext['lazy'] = function($el) {
	var api = {};

	var $element = $el;
	var src = $element.data('src');
	$element.removeAttr('data-src');

	var defaults = {
		effect: 'fadeIn',
		effectTime: 1000,
		visibleOnly: true,
		attribute: 'data-src-new',
		scrollDirection: 'vertical', // use vertical to load all images on the same horizontal axis (e.g. in a swiper)
		afterLoad: function () {
			$element.trigger('lazy-loaded');
			$element.addClass('is-loaded');
		},
	};

	var init = function () {
		ModernizrWebp.on('webp', function(result) {
			// if (result && src.indexOf('fileadmin/') !== -1) {
			// 	$element.attr('data-src-new', src+'.webp');
			// } else {
			// 	$element.attr('data-src-new', src);
			// }
			$element.attr('data-src-new', src);
			$element.lazy(defaults);
		});
	};

	init();
	return api;
};

loop_app.ext['local-structure'] = function($el) {
	var api = {};

	var init = function() {

	};

	init();
	return api;
};

loop_app.ext['marquee'] = function($el) {
	var api = {};

	var $element = $el;
	var $content = $element.find('.js-marquee-content');
	var $control = $element.find('.js-marquee-control');
	var $text = $element.find('.js-marquee-text');
	var $clones = $();

	var timeline;
	var isStopped = false;

	var init = function() {
		addClones();

		timeline = new TimelineMax({repeat: -1});

		updateTimeline();
		addListener();

		loop_app.createA11yButton($control.get(0));
	};

	var addListener = function(){
		$text.add($clones).on('mouseenter.marquee focusin.marquee', function(){
			if(!isStopped){
				pause();
			}
		});

		$text.add($clones).on('mouseleave.marquee focusout.marquee', function(){
			if(!isStopped){
				resume();
			}
		});

		$control.on('click.marquee', function(e){
			e.preventDefault();

			if(isStopped){
				resume();
			} else {
				pause(true);
			}
		});

		$(window).on('resize.marquee', _.debounce(function(){
			updateTimeline();
		}, 200));
	};

	var addClones = function(){
		var neededClones = Math.max(2, Math.ceil($element.width() / $text.width()));

		for (var i = 0; i < neededClones; i++) {
			var $clone = $text.clone();
			$clone.attr('inert', 'true');
			$content.append($clone);
			$clones = $clones.add($clone);
		}
	};

	var pause = function(stop){
		timeline.pause();

		if(stop){
			$control.addClass('is-paused');
			isStopped = true;
		}
	};

	var resume = function(){
		timeline.play();

		if(isStopped){
			$control.removeClass('is-paused');
			isStopped = false;
		}
	};

	var updateTimeline = function(){
		var windowWidth = $(window).width();

		timeline.clear();
		timeline.add(TweenMax.fromTo($content, 5, {x: windowWidth}, {x: - $text.outerWidth(), ease: Linear.easeNone, onComplete:completeTimeline}));

		if(windowWidth >= 1024){
			timeline.duration(($text.outerWidth() + windowWidth) * 7 / 1000);
		} else {
			timeline.duration(($text.outerWidth() + windowWidth) * 12 / 1000);
		}
	};

	var completeTimeline = function() {
		var windowWidth = $(window).width();

		timeline.clear();
		timeline.add(TweenMax.fromTo($content, 5, {x: 0}, {x: - $text.outerWidth(), ease: Linear.easeNone, onComplete:completeTimeline}));

		if(windowWidth >= 1024){
			timeline.duration($text.outerWidth() * 7 / 1000);
		} else {
			timeline.duration($text.outerWidth() * 12 / 1000);
		}
	}

	init();
	return api;
};

loop_app.ext['moment'] = function($el) {
	var api = {};

	var $element = $el;
	var date = $element.data('moment-date');
	var myMoment = moment(date);
	var interval;

	var init = function() {
		renderDate();

		interval = window.setInterval(function(){
			renderDate();
		}, 6000);
	};

	var renderDate = function(){
		$element.text(myMoment.fromNow());
	};

	init();
	return api;
};

loop_app.ext['new-filter'] = function($el) {
	var api = {};

	var $element = $el;

	var $dates = $element.find('.js-new-filter-datepicker');
	var $selects = $element.find('.js-new-filter-select');
	var $searches = $element.find('.js-new-filter-search');

	var $itemGroups = $element.find('.js-new-filter-item-group');
	var $itemGroupToggles = $element.find('.js-new-filter-item-group-toggle');

	var $focus = $element.find('.js-new-filter-datepicker-focus');

	var init = function() {
		initSelects();
		initDates();
		registerStates();
		addListener();
	};

	var initDates = function(){
		$dates.each(function(){
			var $date = $(this);

			updateDateValue($date);

			if(Modernizr.touch){
				$date.attr('type', 'date');
			}
		});
	};

	var initSelects = function(){
		$selects.each(function(){
			checkSelect($(this));
		});
	};

	var registerStates = function(){

		// console.log($('html').hasClass('no-touch'));

		// enquire.register('screen and (max-width: 1279px)', {
		// 	match: function(){
		// 		// show default select on touch devices
		// 		if(Modernizr.touch){
		// 			$selects.on('change', function(e){
		// 				var $s = $(this);

		// 				if($s.val() == '*'){
		// 					e.preventDefault();
		// 					$s.val('');
		// 					$s.trigger('change');
		// 				}
		// 			});

		// 			$selects.each(function(){
		// 				var $s = $(this);
		// 				var $emptyOption = $s.find('option[value=""]');

		// 				if($emptyOption.length && $s.attr('placeholder')){
		// 					$emptyOption.html($s.attr('placeholder'));
		// 					$emptyOption.prop('disabled', true);
		// 				}
		// 			});
		// 		}
		// 	},
		// 	unmatch: function(){
		// 		$itemGroups
		// 			.removeClass('is-open')
		// 			.css({
		// 				display: '',
		// 				height: '',
		// 				overflow: '',
		// 				padding: '',
		// 				border: '',
		// 				margin: '',
		// 			});

		// 		$selects.removeClass('is-empty');
		// 		$dates.attr('type', 'text');
		// 	},
		// });

		// enquire.register('screen and (min-width: 1280px)', {
		// 	match: function(){
		// 		initDesktopDatepickers();
		// 		initDesktopSelect();
		// 	},
		// });
		if(!Modernizr.touch){
			initDesktopDatepickers();
			initDesktopSelect();
		}
	};

	var initDesktopDatepickers = function(){

		$dates.each(function(){
			var $date = $(this);
			var $dateValue = $date.nextAll('.js-new-filter-datepicker-value');

			$date.attr('data-end-date', moment().format('DD.MM.YYYY'));

			loop_app.createA11yButton($date.get(0));
			$date.attr('readonly', 'readonly');

			let focusTrap = null;

			$date.dateRangePicker({
				singleDate: true,
				singleMonth: true,
				autoClose: true,
				format: 'YYYY-MM-DD',
				defaultTime: moment().startOf('day').toDate(),
				endDate: moment().startOf('day').toDate(),
				showTopbar: false,
				startOfWeek: 'monday',
				language: loop_app.language,
				extraClass: 'date-picker--noise',
				customOpenAnimation: function(cb){
					$(this).find('.month-wrapper').css('width', '');

					$(this)
						.css('display', 'block')
						.velocity({
							translateY: [0, 10],
							opacity: [1, 0]
						}, {
							duration: 200,
							complete: cb,
							display: 'block'
						});
				},
				customCloseAnimation: function(cb){
					$(this).velocity({
						translateY: 10,
						opacity: 0
					}, {
						duration: 200,
						complete: cb,
						display: 'none'
					});
				},
				setValue: function(s)
				{
					$(this).val(s);
				},
			})
			.bind('datepicker-close',function(){
				updateDateValue($date);
				$date.parent().removeClass('active');
				
				if(focusTrap){
					focusTrap.deactivate();
				}
			})
			.bind('datepicker-open',function(){
				$date.parent().addClass('active');
				calcPosition($date);
				focusTrap = loop_app.initDateRangePickerTabNav($date);
			}).unbind('keyup.datepicker');

			$date.data('dateRangePicker').getDatePicker().attr('role','dialog');

			$(window).on('resize', _.debounce(function(){
				if($date.is(':hidden')){
					$date.data('dateRangePicker').close();
				} else {
					calcPosition($date);
				}

			}, 200));
		});
	};

	var calcPosition = function($input){

		var dateRangePicker = $input.data('dateRangePicker');
		var $datePicker = dateRangePicker.getDatePicker();
		var inputOffset = $input.offset();
		var inputWidth = $input.outerWidth();
		var datePickerWidth = $datePicker.outerWidth();

		$datePicker.find('.time').hide();
		$datePicker.find('.month-wrapper').css('width', '');

		$datePicker.removeClass('inline-wrapper');

		$datePicker.css({
			position: 'absolute',
			top: inputOffset.top + $input.outerHeight() - 23,
			left: inputOffset.left + inputWidth / 2 - datePickerWidth / 2,
		});
	};

	var initDesktopSelect = function(){
		$selects.each(function(){
			initSelect2($(this));
		});
	};

	var initSelect2 = function($input){
		$input.attr('tabindex', '0');
		$input.off('select2:selecting');

		$input.select2({
			theme: 'new-filter',
			width: 'auto',
			placeholder: $input.attr('data-placeholder'),
			dropdownAutoWidth: true,
			minimumResultsForSearch: Infinity,
		});

		var select2 = $input.data('select2');

		$input.on('select2:selecting', function(e){
			if(e.params.args.data.id == '*'){
				e.preventDefault();
				e.stopImmediatePropagation();

				$input.val('');
				$input.trigger('change');
				select2.close();
			}
		});

		select2.dropdown._positionDropdown = function(){
			var $window = $(window);

			var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
			var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

			var newDirection = null;

			var offset = this.$container.offset();

			offset.bottom = offset.top + this.$container.outerHeight(false);

			var container = {
				height: this.$container.outerHeight(false)
			};

			container.top = offset.top;
			container.bottom = offset.top + container.height;

			var dropdown = {
				height: this.$dropdown.outerHeight(false)
			};

			var viewport = {
				top: $window.scrollTop(),
				bottom: $window.scrollTop() + $window.height()
			};

			var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
			var enoughRoomBelow = true;
			// var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

			var css = {
				left: offset.left,
				top: container.bottom
			};

			// Determine what the parent element is to use for calciulating the offset
			var $offsetParent = this.$dropdownParent;

			// For statically positoned elements, we need to get the element
			// that is determining the offset
			if ($offsetParent.css('position') === 'static') {
				$offsetParent = $offsetParent.offsetParent();
			}

			var parentOffset = $offsetParent.offset();

			css.top -= parentOffset.top;
			css.left -= parentOffset.left - this.$container.outerWidth() / 2 + this.$dropdown.outerWidth() / 2;

			if (!isCurrentlyAbove && !isCurrentlyBelow) {
				newDirection = 'below';
			}

			if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
				newDirection = 'above';
			} else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
				newDirection = 'below';
			}

			if (newDirection == 'above' ||
				(isCurrentlyAbove && newDirection !== 'below')) {
				css.top = container.top - parentOffset.top - dropdown.height;
			}

			if (newDirection !== null){
				this.$dropdown
					.removeClass('select2-dropdown--below select2-dropdown--above')
					.addClass('select2-dropdown--' + newDirection);
				this.$container
					.removeClass('select2-container--below select2-container--above')
					.addClass('select2-container--' + newDirection);
			}

			this.$dropdownContainer.css(css);
		};

		select2.dropdown._showDropdown = function (decorated) {
			select2.dropdown.$dropdownContainer.find('.select2-dropdown').css('visibility', 'hidden');
			select2.dropdown.$dropdownContainer.appendTo(select2.dropdown.$dropdownParent);

			select2.dropdown._positionDropdown();
			select2.dropdown._resizeDropdown();

			window.setTimeout(function(){
				var $dropdown = select2.dropdown.$dropdownContainer.find('.select2-dropdown');

				select2.dropdown.$dropdownContainer.find('.select2-dropdown').velocity({
					opacity: [1, 0],
					translateY: [0, 10]
				}, {
					duration: 300,
					visibility: 'visible',
					easing: 'easeOutQuart',
					display: 'block'
				});
			}, 10);
		};

		select2.dropdown._hideDropdown = function(){
			select2.dropdown.$dropdownContainer.find('.select2-dropdown').velocity({
				opacity: 0,
				translateY: 10
			}, {
				duration: 300,
				complete: function(){
					select2.dropdown.$dropdownContainer.detach();
				},
				visibility: 'hidden',
				display: 'block'
			});
		};

		$input.on('select2:select', function (e) {
			screenReaderFix($input);
		});

		setTimeout(function(){
			screenReaderFix($input);
		},500);
	};

	var screenReaderFix = function($input){
		if ($input.data('prepend')) {
			$input.next().find('.select2-selection__rendered').prepend('<span class="u-sr-only">'+ $input.data('prepend') + '</span>');
		} else if ($input.data('placeholder') && !$input.find('option:selected').attr('hidden')) {
			$input.next().find('.select2-selection__rendered').prepend('<span class="u-sr-only">'+ $input.data('placeholder') + '</span>');
		}
	};

	var addListener = function(){
		$itemGroupToggles.on('click', function(e){
			if(isMobile()){
				e.preventDefault();

				toggleItemGroup($(this).data('new-filter-key'));
			}
		});

		$dates.on('change', function(){
			if(isMobile()){
				updateDateValue($(this));
			}
		});

		$dates.on('keypress', function(e){
			if (e.keyCode == 13) {
				// $(this).trigger('click');
				$(this).data('dateRangePicker').open(0);

				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
			}
		});

		$selects.on('init blur change focus', function(){
			checkSelect($(this));
		});

		$searches.on('click', function(e){
			if(!isMobile()){
				var $search = $(this);
				var $input = $search.find('.js-new-filter-search-input');
				var $button = $search.find('.js-new-filter-search-button');

				$search.addClass('is-open').blur();
				$input.removeAttr('tabindex').focus();
				$button.attr('aria-label', $button.data('opened-aria-label'));

				$('.js-new-filter-search-close').attr('tabindex','0').attr('role', 'button');
			}
		});

		$searches.on('keypress', function(e){
			if(e.keyCode == 13) {
				$(this).trigger('click');
			}
		});

		$searches.on('click', '.js-new-filter-search-close', function(e){
			var $close = $(this);
			var $search = $searches;
			var $input = $search.find('.js-new-filter-search-input');
			var $button = $search.find('.js-new-filter-search-button');
			
			$button.attr('aria-label', $button.data('hidden-aria-label'));

			if($search.hasClass('is-open')){
				e.stopImmediatePropagation();

				$search.removeClass('is-open');

				if($input.val()){
					$input.val('').trigger('change');
				}
				$input.attr('tabindex','-1');
				$close.removeAttr('tabindex').removeAttr('role');
			}
		});

		$('.js-new-filter-search-close').on('keypress', function(e){
			if(e.keyCode == 13) {
				$('.js-new-filter-search-close').trigger('click');
				e.preventDefault();
				e.stopPropagation();
			}
		});

		$('.js-new-filter-datepicker-value').on('keypress', function(e){
			if(e.keyCode == 13) {
				$(this).parent().find('.js-new-filter-datepicker').trigger('click');
			}
		});
	};

	var toggleItemGroup = function(key){
		var $itemGroup = $itemGroups.filter('[data-new-filter-key="'+key+'"]');

		if($itemGroup.hasClass('is-open')){
			closeItemGroup(key);
		} else {
			openItemGroup(key);
		}
	};

	var openItemGroup = function(key){
		var $itemGroup = $itemGroups.filter('[data-new-filter-key="'+key+'"]');
		var $toggle = $itemGroupToggles.filter('[data-new-filter-key="'+key+'"]');
		var $otherOpenItemGroups = $itemGroups.not($itemGroup).filter('.is-open');

		if($itemGroup.hasClass('is-open')){
			return;
		}

		$itemGroup
			.velocity('slideDown', {
				easing: 'easeOutQuart'
			})
			.addClass('is-open');

		$toggle.addClass('is-active');

		$otherOpenItemGroups.each(function(){
			closeItemGroup($(this).data('new-filter-key'));
		});
	};

	var closeItemGroup = function(key){
		var $itemGroup = $itemGroups.filter('[data-new-filter-key="'+key+'"]');
		var $toggle = $itemGroupToggles.filter('[data-new-filter-key="'+key+'"]');

		if(!$itemGroup.hasClass('is-open')){
			return;
		}

		$itemGroup
			.velocity('slideUp', {
				easing: 'easeOutQuart'
			})
			.removeClass('is-open');

		$toggle.removeClass('is-active');
	};

	var checkSelect = function($select){
		if(isMobile()){
			if($select.val() === '' || $select.val() === null){
				$select.addClass('is-empty');
			} else {
				$select.removeClass('is-empty');
			}
		} else {
			$select.removeClass('is-empty');

			var select2 = $select.data('select2');

			if(select2){
				if($select.val() === ''){
					select2.$container.addClass('is-empty');
				} else {
					select2.$container.removeClass('is-empty');
				}
			}
		}
	};

	var updateDateValue = function($date){
		var $dateValue = $date.nextAll('.js-new-filter-datepicker-value');
		var srLabel = $dateValue.data('sr-label');
		if ($date.val()) {
			var value = $date.val();
			var formattedValue = moment(value).format('DD. MMMM YYYY');

			$dateValue.html(formattedValue).attr('aria-label',srLabel + ': ' + formattedValue);
			$dateValue.removeClass('is-placeholder');
		} else {
			$dateValue.html($date.attr('placeholder')).attr('aria-label',srLabel + ': ' +$date.attr('placeholder'));;
			$dateValue.addClass('is-placeholder');
		}
	};

	var isMobile = function(){
		return $(window).width() < 1280;
	};

	var closeOverlay = function($date) {
		$dates.each(function(){
			$(this).data('dateRangePicker').close();
		});
	}

	api.initSelect2 = initSelect2;
	api.closeOverlay = closeOverlay;

	init();
	return api;
};

loop_app.ext['newsletter-popup'] = function($el) {
	var api = {};

	var $element = $el;
    var $close = $element.find('.js-newsletter-popup-close');
    var $form = $element.find('.js-newsletter-popup-form');
    var $form_error = $element.find('.js-newsletter-popup-form-error');

    loop_app.createA11yButton($close.get(0));

	var init = function(){
        showPopup();

        $close.on('click', hidePopup);
        $form.on('submit', formSubmit);
    };
    
    var showPopup = function() {

        var cookie = Cookies.get($element.data('cookie-name'));

		if (cookie == 1) {
			$element.remove();
			return false;
		} else {

            setTimeout(function(){
                $el.addClass('is-visible');
                $el.removeAttr('inert');
                Cookies.set($element.data('cookie-name'), '1', {expires: $element.data('cookie-expires-after') || 365});

            }, parseInt($el.data('timeout')) * 1000);
        }
    }

    var hidePopup = function(e) {
        e.preventDefault();
        $el.removeClass('is-visible');
        $el.attr('inert', 'true');
    }

    var formSubmit = function(e) {

        if (!validateEmail($form.find('input[name=email]').val())) {
            e.preventDefault();
            $form_error.addClass('is-visible');
        }

    }

    var validateEmail = function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

	init();
	return api;
};

loop_app.ext['noise-table'] = function($el) {
	var api = {};

	var $element = $el;
	var $body = $element.find('.js-noise-table-body');

	var template = _.template($element.find('.js-noise-table-template').html());
	var init = function(){
		addListener();
	};

	var addListener = function(){

	};

	var fill = function(data){

		if(data.length){
			var html = '';
			var $rows;

			_.forEach(data, function(row){
				html += template(row);
			});

			$rows = $(html).filter(':not(text)');
			// loop_app.initLocalExtensions($rows);

			$body.html($rows);
			$element.removeClass('is-empty');


		} else {
			empty();
		}
	};

	api.fill = fill;

	var empty = function(){
		$body.html();
		$element.addClass('is-empty');
	};
	api.empty = empty;

	init();
	return api;
};

loop_app.ext['noise'] = function($el) {
	var api = {};

	var $element = $el;
	var $wrapper = $element.find('.js-noise-graph-wrapper');
	var $wrapperSingle = $element.find('.js-noise-graph-wrapper-single');

	var $scrollWr = $element.find('.js-noise-scroll-wrapper');
	var $scroller = $element.find('.js-noise-scroller');
	var $scrollerWr = $element.find('.js-noise-scroller-wrapper');

	var $date = $element.find('.js-noise-datepicker');
	var $filterSelect = $element.find('.js-filter-select, .js-new-filter-select');
	var $dateValue = $element.find('.js-noise-date-value');
	var $timeFrom = $element.find('.js-noise-time-from-select');
	var $timeTo = $element.find('.js-noise-time-to-select');
	var $filterLocation = $element.find('.js-noise-location-select');
	var $filterForm = $element.find('.js-noise-filter-form');

	var $graphView = $element.find('.js-noise-graph-view');
	var $tableView = $element.find('.js-noise-table');
	var $graphViewTrigger = $element.find('.js-noise-graph-view-trigger');
	var $tableViewTrigger = $element.find('.js-noise-table-view-trigger');

	var $tooltipArrow = $element.find('.js-noise-tooltip-arrow');
	var $tooltipTime = $element.find('.js-noise-tooltip-time');
	var $tooltipNoise = $element.find('.js-noise-tooltip-noise');
	var $tooltipType = $element.find('.js-noise-tooltip-type');
	var $tooltipTypeUnknow = $element.find('.js-noise-tooltip-unknown-type');
	var $tooltipDistance = $element.find('.js-noise-tooltip-distance');
	var $tooltipDuration = $element.find('.js-noise-tooltip-duration');
	var $tooltipLocation = $element.find('.js-noise-tooltip-location');

	var $views = $element.find('.js-noise-views');
	var $noData = $element.find('.js-noise-no-data');

	var $location = $element.find('.js-noise-location');

	var $loader = $element.find('.js-noise-graph-loader');

	var dataCount = 0;
	var data_times = [];
	var data_noiseLevels = [];
	var data_distances = [];
	var data_durations = [];
	var data_types = [];

	var noiseMin = 10000;
	var noiseMax = 0;

	var myChart = [];

	var draging = false;
	var dragStart = 0;
	var dragDelta = 0;
	var currentScroll = 0;
	var numberOfGraphCanvases = 0;

	var init = function() {
		getData();
		addListener();

		refreshLocation.apply($filterLocation[0]);
	};

	var addListener = function(){
		$scrollWr.on('scroll', wrapperScrollListenter);
		$graphViewTrigger.on('click', graphViewTriggerClickListener);
		$tableViewTrigger.on('click', tableViewTriggerClickListener);
		$(window).on('resize', windowResizeListener);

		if(Modernizr.touch){
			$date.bind('change', refreshData);
			$filterSelect.on('change', refreshData);
			$filterLocation.on('change', refreshLocation);
		} else {
			$date.bind('datepicker-change change', refreshData);
			$filterSelect.on('select2:select', refreshData);
			$filterLocation.on('select2:select', refreshLocation);
		}

		$scroller.mousedown(function(e) {
        	draging = true;
        	dragStart = e.pageX;
        	$('body').css('cursor','default');
        	currentScroll =  $(".js-noise-scroll-wrapper").scrollLeft() / ($wrapper.width() / $scrollerWr.width());
	    });

		$scroller.on('keydown', function(e) {
			if (e.keyCode == 37) {
				$(".js-noise-scroll-wrapper").scrollLeft((currentScroll - 10) * ($wrapper.width() / $scrollerWr.width()));
				currentScroll =  $(".js-noise-scroll-wrapper").scrollLeft() / ($wrapper.width() / $scrollerWr.width());
			} else if (e.keyCode == 39) {
				$(".js-noise-scroll-wrapper").scrollLeft((currentScroll + 10) * ($wrapper.width() / $scrollerWr.width()));
				currentScroll =  $(".js-noise-scroll-wrapper").scrollLeft() / ($wrapper.width() / $scrollerWr.width());
			}

		});

	    $('html')
	    .mousemove(function(e) {
	        if (draging) {
	        	dragDelta = e.pageX - dragStart;
	        	$(".js-noise-scroll-wrapper").scrollLeft((currentScroll + dragDelta) * ($wrapper.width() / $scrollerWr.width()));
	        }
	     })
	    .mouseup(function(e) {
	    	if (draging) {
	        	draging = false;
	        	$('body').css('cursor','');
	    	}
	    });
	};

	var setNumberOfCanvases = function (){
		var width = dataCount * 80;

		numberOfGraphCanvases = Math.ceil(width / 4000);
		var html = '';
		$wrapper.html('');
		for (i=0; i < numberOfGraphCanvases; i++) {
			html = '<div class="noise-graph__single js-noise-graph-wrapper-single">\
						<canvas id="js-noise-graph-'+ i +'" data-index="'+ i +'"></canvas>\
					</div>';
			$wrapper.append($(html));
		}
	}

	var initWidth = function(){
		var width = dataCount * 80;

		var scrollerWidth = ($scrollWr.width() / width) * 100;

		$wrapper.css('width',(width - (numberOfGraphCanvases * 40)) + 'px');

		$wrapperSingle = $wrapper.find('.js-noise-graph-wrapper-single');
		$wrapperSingle.css('width', (width / numberOfGraphCanvases) + 'px').css('float','left').css('height','100%');

		if (width > $scrollWr.width()) {
			$scroller.css('width',scrollerWidth + '%');
			$scrollerWr.addClass('visible');
		} else {
			$scrollerWr.removeClass('visible');
		}

	};

	var wrapperScrollListenter = function() {
		var scrollLeft = $(this).scrollLeft();
		$scroller.css('margin-left', ((scrollLeft / $wrapper.width()) * 100) + '%');
	};

	var windowResizeListener = function() {
		initWidth();
	};

	var getData = function() {

		resetChart();

		var jsonData = $.ajax({
			url: $element.data('api'),
			dataType: 'json',
			data: $filterForm.serialize(),
		}).done(function (results) {
			// Split data into separate arrays
			dataCount = results.length;

			if (dataCount) {
				$views.show();
				$noData.hide();

				$scrollWr.scrollLeft(0);
				
				setTimeout(function() {

					$loader.hide();

					setNumberOfCanvases();

					initWidth();

					for (i = 0; i < numberOfGraphCanvases; i++) {
						data_times[i] = [];
						data_noiseLevels[i] = [];
						data_distances[i] = [];
						data_durations[i] = [];
						data_types[i] = [];
					}

					var index = 0;

					results.forEach(function(result) {
						data_times[Math.floor(index/(dataCount/numberOfGraphCanvases))].push(result.time);
						data_noiseLevels[Math.floor(index/(dataCount/numberOfGraphCanvases))].push(parseFloat(result.noise));

						noiseMin = ((parseFloat(result.noise) < noiseMin) ? parseFloat(result.noise) : noiseMin);
						noiseMax = ((parseFloat(result.noise) > noiseMax) ? parseFloat(result.noise) : noiseMax);

						data_distances[Math.floor(index/(dataCount/numberOfGraphCanvases))].push(result.distance);
						data_durations[Math.floor(index/(dataCount/numberOfGraphCanvases))].push(result.duration);
						
						data_types[Math.floor(index/(dataCount/numberOfGraphCanvases))].push(result.typeIco);
						index++;
					});

					drawGraph();

					$tableView.data('obj_noiseTable').fill(results);

				}, 1000);
			} else {
				$loader.hide();
				$views.hide();
				$noData.show();
			}
		});
	};

	var drawGraph = function() {

		var canvasWidth = $('#js-noise-graph').parent().width();
		var canvasHeight = $('#js-noise-graph').parent().height();
		
		var ctx;

		for (i = 0; i < numberOfGraphCanvases; i++) {
			var yAxesOptions = [];
			var chartPaddingLeft = 0;
			if (i > 0) {
				chartPaddingLeft = -20;
			}

			ctx = document.getElementById('js-noise-graph-'+i);
			myChart[i] = new Chart(ctx, {
				type: 'bar',
				data: {
					labels: data_times[i],
					datasets: [{
						data: data_noiseLevels[i],
						backgroundColor: 'rgba(0, 68, 148, 1)',
						borderColor: 'rgba(0, 68, 148, 1)',
						borderWidth: 1
					}]
				},
				label: '',
				options: {
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						display: false
					},
					scales: {
						scaleLineColor: 'transparent',
						yAxes: [{
							gridLines: {
							   drawBorder: false
							},
							ticks: {
								beginAtZero:false,
								fontColor: (i == 0) ? '#221f2a' : 'transparent',
								fontSize: 14,
								fontStyle: 'bold',
								min: Math.floor(noiseMin) - 1,
								max: Math.ceil(noiseMax) + 1,
								stepSize: 5
							},
							scaleLabel: {
								display: false,
								labelString: 'A-bewerteter Schalldruckpegel in dB',
								fontColor: '#5e6162',
								position: 'left',
							},
							afterBuildTicks: function (scale) {
								// remove smallest tick to match the design
								scale.ticks.splice(scale.ticks.length - 1, 1);
								//remove highest tick if it breaks the stepSize = 5
								if (scale.ticks[0] - scale.ticks[1] != 5) {
									scale.ticks.splice(0, 1);
								}
							}
						}],
						xAxes : [{
							// barThickness: 50,
							categoryPercentage: 1,
							barPercentage: 0.6,
							gridLines: {
								display: false,
								drawBorder: false
							},
							ticks: {
								fontColor: '#221f2a',
								fontSize: 14,
								fontStyle: 'bold',
							},
						}],
					},
					tooltips: {
						enabled: false,
						mode: 'index',
						position: 'nearest',
						custom: customTooltips
					},
					layout: {
			            padding: {
			                left: chartPaddingLeft,
			                right: 0,
			                top: 0,
			                bottom: 0
			            }
			        },
					animation: {
						onComplete: function(animation) {
							var chartID = parseInt($(this.canvas).data('index'));
							
							if (chartID == 0) {
								var sourceCanvas = myChart[chartID].chart.canvas;
								var copyWidth = myChart[chartID].scales['y-axis-0'].width - 10;
								var copyHeight = myChart[chartID].scales['y-axis-0'].height + myChart[chartID].scales['y-axis-0'].top + 10;
								$('#js-noise-graph-axis').attr('height',$('#js-noise-graph-0').height());
								var targetCtx = document.getElementById("js-noise-graph-axis").getContext("2d");
								targetCtx.canvas.width = copyWidth;
								targetCtx.canvas.height = copyHeight;

								targetCtx.drawImage(sourceCanvas, 0, 0, window.devicePixelRatio*copyWidth, window.devicePixelRatio*copyHeight, 0, 0, copyWidth, copyHeight);
								$('#js-noise-graph-axis').css('padding-right','10px');
							}
						}
					}
				}
			});
		}
	};

	var fillTable = function(data) {
		if(data.length){
			var html = '';
			var $rows;

			_.forEach(data, function(row){
				html += template(row);
			});

			$rows = $(html).filter(':not(text)');
			// loop_app.initLocalExtensions($rows);

			$body.html($rows);
			$element.removeClass('is-empty');


		} else {
			empty();
		}
	};

	var customTooltips = function(tooltip) {
		var charIndex = $(this._chart.canvas).data('index');

		var chartOffset =  charIndex * ($wrapper.width() / numberOfGraphCanvases);

		// Tooltip Element
		var tooltipEl = document.getElementById('chartjs-noise-tooltip');
		// Hide if no tooltip
		if (tooltip.opacity === 0) {
			tooltipEl.style.opacity = 0;
			return;
		}
		// Set caret Position
		tooltipEl.classList.remove('above', 'below', 'no-transform');
		if (tooltip.yAlign) {
			tooltipEl.classList.add(tooltip.yAlign);
		} else {
			tooltipEl.classList.add('no-transform');
		}

		function getBody(bodyItem) {
			return bodyItem.lines;
		}

		var titleLines = tooltip.title || [];
		var bodyLines = tooltip.body.map(getBody);

		var time = titleLines[0];
		var noise = bodyLines[0][0].replace(": ","");

		$tooltipTime.html(time);
		$tooltipNoise.html(noise);

		var currenIndex = jQuery.inArray(time, data_times[charIndex]);

		$tooltipDistance.html(data_distances[charIndex][currenIndex]);
		$tooltipDuration.html(data_durations[charIndex][currenIndex]);

		if (data_types[charIndex][currenIndex] != '') {
			$tooltipType.show().removeClass('icon--departure icon--arrival icon--touch').addClass('icon--'+data_types[charIndex][currenIndex]);
			$tooltipTypeUnknow.hide();
		} else {
			$tooltipTypeUnknow.show();
			$tooltipType.hide();
		}

		var position = this._chart.canvas.getBoundingClientRect();
		// Display, position, and set styles for font
		tooltipEl.style.opacity = 1;

		var left = tooltip.caretX - $scrollWr.scrollLeft() + chartOffset;
		tooltipEl.style.left = left + 'px';
		tooltipEl.style.top =  tooltip.caretY - $(tooltipEl).outerHeight() - 15 + 'px';


		//if the tooltip gets offscreen, position it properly and adjust the arrow
		repositionTooltipIfItOverflows(left, tooltipEl);
	};

	var repositionTooltipIfItOverflows = function(left, tooltipEl) {
		//overflows left
		if (left < $(tooltipEl).outerWidth() / 2) {

			//when mobile move 30px to the left
			var mobileCorrection = 0;
			if ($(window).width() < 400) {
				mobileCorrection = 30;
				$(tooltipEl).css('width', 'calc(100% + 30px)');
			}

			tooltipEl.style.left = ($(tooltipEl).outerWidth() / 2) - mobileCorrection + 'px';
			offset = ($(tooltipEl).outerWidth() / 2 - left)
			var arrowLeft = 100 - (((offset - mobileCorrection) / ($(tooltipEl).outerWidth() / 2) * 100));
			$tooltipArrow.css('left', (arrowLeft / 2) +'%');

		}
		//overflows right
		else if (left + $(tooltipEl).outerWidth() / 2 > $scrollWr.width() ) {
			tooltipEl.style.left = ($scrollWr.width() - ($(tooltipEl).outerWidth() / 2)) + 'px';
			offset = (($scrollWr.width() - ($(tooltipEl).outerWidth() / 2)) - left);
			var arrowLeft = 100 - ((offset / ($(tooltipEl).outerWidth() / 2) * 100));
			$tooltipArrow.css('left', (arrowLeft / 2) +'%');
		} else {
			$tooltipArrow.removeAttr('style');
		}
	};

	var graphViewTriggerClickListener = function(e) {
		e.preventDefault();
		$graphViewTrigger.addClass('active is-active');
		$graphView.addClass('active is-active').removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');

		$tableViewTrigger.removeClass('active is-active');
		$tableView.removeClass('active is-active').attr('inert','true');

	};

	var tableViewTriggerClickListener = function(e) {
		e.preventDefault();
		$graphViewTrigger.removeClass('active is-active');
		$graphView.removeClass('active is-active').attr('inert','true')

		$tableViewTrigger.addClass('active is-active');
		$tableView.addClass('active is-active').removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
	};

	var resetChart = function() {

		if (myChart) {
			$loader.show();
			$.each(myChart , function(index, item) {
				data_times[index] = [];
				data_noiseLevels[index] = [];
				data_distances[index] = [];
				data_durations[index] = [];
				data_types[index] = [];
				myChart[index].destroy();

				var targetCtx = document.getElementById("js-noise-graph-axis").getContext("2d");
				targetCtx.clearRect(0, 0, targetCtx.canvas.width, targetCtx.canvas.height);
			});
		}

	};

	var dataLoading = function() {
		$loader.show();
	};

	var refreshData = function() {
		$('.js-noise-date-title').html(moment($date.val()).format('DD. MMMM YYYY'));
		getData();
	};
	var refreshLocation = function() {
		var newLocation = $(this).find('option:selected').html();
		$location.html(newLocation);
		$tooltipLocation.html(newLocation);
	};

	init();
	return api;
};

loop_app.ext['overlay'] = function($el) {
	var api = {};

	var $element = $el;
	var $content = $element.find('.js-overlay-content');
	var $inner = $element.find('.js-overlay-inner');
	var $site = $('.js-site');
	var $siteContent = $site.find('.js-site-content');

	var $imageSwiper = $element.find('.js-overlay-destination-image-swiper');
	var $vidSwiper = $element.find('.js-overlay-destination-video-swiper');

	var initialUrl;

	const overlayFocusTrap = window.focusTrap.createFocusTrap($element.get(0), {
		onDeactivate: function(){
			close();
		}
	});

	var init = function() {
		if (isOpen()) {
			overlayFocusTrap.activate();
		}

		addListener();

		$element.find('.js-overlay-close').attr('aria-label', loop_app.translations.close);

		if(Modernizr.history && $element.hasClass('is-open')){
			window.history.replaceState({overlay: true}, '', window.location.href);

			var backgroundUrl = $element.find('.js-overlay-close').attr('href');

			$.ajax({
				url: backgroundUrl,
				success: function(data){
					var html = $(data).find('.js-site-content');

					$siteContent.html(html);
					loop_app.initLocalExtensions(html);

					$site.css({
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						overflow: 'hidden',
						height: '100vh'
					});
				}
			});
		}

		initSwipers();
	};

	var addListener = function(){
		$(document).on('click', '.js-overlay-trigger', function(e){

			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.mozCancelFullScreen) { /* Firefox */
				document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
				document.webkitExitFullscreen();
			} else if (document.msExitFullscreen) { /* IE/Edge */
				document.msExitFullscreen();
			}

			if(Modernizr.history){
				e.preventDefault();

				var $link = $(this);
				var href = $link.attr('href');

				load(href);
			}
		});

		$element.on('click', '.js-overlay-close, .js-overlay-background', function(e){
			if(Modernizr.history){
				e.preventDefault();

				close();
			}
		});

		$(window).on('popstate', function(e){
			if(e.originalEvent.state && e.originalEvent.state.overlay){
				load(window.location.href, false);
			} else if(overlayFocusTrap.active){
				close(false);
			}
		});
	};

	var isOpen = function(){
		return $element.hasClass('is-open');
	};

	var load = function(url, statechange){
		if(typeof statechange === 'undefined')
			statechange = true;

		var animationDefer = $.Deferred();
		var loadingDefer = $.Deferred();
		var scrollTop = $(window).scrollTop();

		if(overlayFocusTrap.active){
			$inner.velocity({
				translateY: -scrollTop
			}, {
				duration: 0
			});

			$(window).scrollTop(0);

			$inner.velocity({
				translateY: [-50 - scrollTop, -scrollTop],
				opacity: [0, 1],
			}, {
				duration: 500,
				easing: "easeOutQuart",
				complete: function(){
					animationDefer.resolve();
				}
			});
		} else {

			$site.css({
				position: 'fixed',
				top: -scrollTop,
				left: 0,
				right: 0,
				overflow: 'hidden',
				height: 'calc(100% + '+scrollTop+'px)'
			});

			$element.velocity({
				opacity: [1, 0]
			}, {
				duration: 300,
				complete: function(){
					animationDefer.resolve();
				}
			});

			initialUrl = window.location.href;
		}

		$element.addClass('is-loading');

		$.ajax({
			url: url,
			success: function(data){
				loadingDefer.resolve(data);
			},
			error: function(){
				// TODO: handle error
				alert('An error occured. Please try again later.');
			}
		});

		$.when(loadingDefer, animationDefer).done(function(data){
			show(data);
			$element.removeClass('is-loading');

			if(statechange){
				window.history.pushState({overlay: true}, '', url);
			}
		});
	};

	var show = function(htmlText){
		var $newContent = $(htmlText).find('.js-overlay-content').children();

		$content.html($newContent);
		loop_app.initLocalExtensions($newContent);

		$inner.velocity({
			translateY: [0, -50],
			opacity: [1, 0]
		}, {
			duration: 500,
			easing: "easeOutQuart",
		});

		$element.addClass('is-open');
		overlayFocusTrap.activate();

		initSwipers();
	};

	var close = function(historyPush){
		if(!isOpen())
			return;


		if(typeof historyPush == 'undefined')
			historyPush = true;

		var scrollTop = parseInt($site.css('top')) * -1;
		var backgroundUrl = initialUrl || $element.find('.js-overlay-close').attr('href');

		$element.velocity({
			opacity: 0,
		}, {
			duration: 300,
		})

		overlayFocusTrap.deactivate();

		$inner.velocity({
			translateY: [-50, 0],
			opacity: [0, 1],
		}, {
			duration: 500,
			easing: "easeOutQuart",
			complete: function(){
				if(overlayFocusTrap.active){
					return;
				}

				$site.css({
					position: '',
					top: '',
					left: '',
					right: '',
					overflow: '',
					height: ''
				});

				$element.removeClass('is-open');

				$(window).scrollTop(scrollTop);

				$content.html('');

				if(historyPush){
					window.history.pushState({overlay: false}, '', backgroundUrl);
					initialUrl = undefined;
				}
			},
		});

	};

	var initSwipers = function() {

		var $imageSwiper = $('.js-overlay-destination-image-swiper');
		var $vidSwiper = $('.js-overlay-destination-video-swiper');

		if ($imageSwiper.length > 0) {
			if ($imageSwiper.find('.swiper-slide').length > 1) {
				var imageSwiper = new Swiper ($imageSwiper, {
					a11y: true,
					prevSlideMessage: loop_app.translations.prev_slide,
					nextSlideMessage: loop_app.translations.next_slide,
					paginationBulletMessage: loop_app.translations.go_to_slide,
					// Navigation arrows
					nextButton: '.js-overlay-destination-image-swiper-next',
					prevButton: '.js-overlay-destination-image-swiper-prev',

					onSlideChangeStart: function(swiper) {
						$(swiper.slides[swiper.activeIndex]).removeAttr('aria-hidden');
						$(swiper.slides[swiper.previousIndex]).attr('aria-hidden','true');
					},

					onTransitionEnd: function(swiper){
	
						if ($('.js-overlay-destination-image-swiper-prev').hasClass('swiper-button-disabled')) {
							$('.js-overlay-destination-image-swiper-prev').attr('tabindex','-1');
						} else {
							$('.js-overlay-destination-image-swiper-prev').attr('tabindex','0');
						}
		
						if ($('.js-overlay-destination-image-swiper-next').hasClass('swiper-button-disabled')) {
							$('.js-overlay-destination-image-swiper-next').attr('tabindex','-1');
						} else {
							$('.js-overlay-destination-image-swiper-next').attr('tabindex','0');
						}
					},

					onInit: function(swiper) {
						
						$(swiper.slides[swiper.activeIndex]).removeAttr('aria-hidden');

						$('.js-overlay-destination-image-swiper-prev').attr('tabindex', '-1');
					},
				});
			} else {
				$('.js-overlay-destination-image-swiper-next, .js-overlay-destination-image-swiper-prev').hide();
			}

		}

		if ($vidSwiper.length > 0) {
			if ($vidSwiper.find('.swiper-slide').length > 1) {
				var videoSwiper = new Swiper ($vidSwiper, {
					a11y: true,
					prevSlideMessage: loop_app.translations.prev_slide,
					nextSlideMessage: loop_app.translations.next_slide,
					paginationBulletMessage: loop_app.translations.go_to_slide,
					// Navigation arrows
					nextButton: '.js-overlay-destination-video-swiper-next',
					prevButton: '.js-overlay-destination-video-swiper-prev',

					onSlideChangeStart: function(swiper) {
						var inactive = swiper.slides.filter(':not(.swiper-slide-active)');

						inactive.each(function(){
							var player = $(this).find('.js-video-embed').data('obj_videoEmbed').player;

							if (player && player.pauseVideo) {
								$(this).find('.js-video-embed').data('obj_videoEmbed').player.pauseVideo();
							}
						});
					
						$(swiper.slides).attr('inert','true');
						$(swiper.slides).find('.js-video-embed-element').attr('tabindex','-1');
						$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
						$(swiper.slides[swiper.activeIndex]).find('.js-video-embed.is-playing .js-video-embed-element').removeAttr('tabindex');
					},

					onTransitionEnd: function(swiper){
		
						if ($('.js-overlay-destination-video-swiper-prev').hasClass('swiper-button-disabled')) {
							$('.js-overlay-destination-video-swiper-prev').attr('tabindex','-1');
						} else {
							$('.js-overlay-destination-video-swiper-prev').attr('tabindex','0');
						}
		
						if ($('.js-overlay-destination-video-swiper-next').hasClass('swiper-button-disabled')) {
							$('.js-overlay-destination-video-swiper-next').attr('tabindex','-1');
						} else {
							$('.js-overlay-destination-video-swiper-next').attr('tabindex','0');
						}
					},

					onInit: function(swiper) {
						$vidSwiper.find('.js-video-embed-element').attr('tabindex','-1');

						$(swiper.slides).attr('inert','true');
						$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
						$('.js-overlay-destination-video-swiper-prev').attr('tabindex', '-1');
					},


				});
			} else {
				$('.js-overlay-destination-video-swiper-next, .js-overlay-destination-video-swiper-prev').hide();
			}

		}
	};

	api.load = load;

	init();
	return api;
};

loop_app.ext['page-nav'] = function($el) {
	var api = {};

	var $element = $el;

	var $navigationWrapper = $element.find('.js-page-nav-wrapper');
	var $navigationIndicator = $element.find('.js-page-nav-indicator');
	var $content = $('.js-page-nav-content');
	var $navigationLinks = $element.find('.js-page-nav-link');
	var $navigationItems = $element.find('.js-page-nav-item');

	var isSticky = !$element.data('page-nav-unsticky');

	var init = function() {
		addListener();

		if(isSticky){
			documentScrollHandler();
		}

		$navigationLinks.each(function(){
			var $link = $(this);

			$link.attr('tabindex', '0');
		});
	};

	var addListener = function(){
		$navigationLinks.on('mouseenter.header', function(e){
			var $link = $(this);
			repositionIndicator($(this).parent(), false);
		});

		$navigationLinks.on('mouseleave.header', function(e){
			repositionIndicator($navigationItems.filter('.is-active'), false);
		});

		$navigationLinks.on('keypress', function(e){
			if(e.which == 13){
				e.preventDefault();
				e.stopPropagation();

				$(this).trigger('click');
			}
		});

		$navigationLinks.on('click', function(e){
			$navigationItems.filter('.is-active').removeClass('is-active');

			if(isSticky){
				$(this).parent().addClass('is-active');
				$navigationIndicator.addClass('dont-move');
			}

			var scroll = $('[data-page-nav-section="'+ $(this).data('page-nav-target') +'"]').offset().top + 1;
			const tabbableElementsInSection = window.tabbable.tabbable($('[data-page-nav-section="'+ $(this).data('page-nav-target') +'"]').get(0))

			if(tabbableElementsInSection.length > 0){
				// temporarily disabled because this caused a bug where other sub menus in the navigation could not be opened (https://loop.slack.com/archives/C06ACRV89L7/p1749716411383409)
				//tabbableElementsInSection[0].focus({preventScroll: true});
			}

			if(isSticky){
				scroll -= $element.outerHeight();
			}

			$('body,html').animate({
				scrollTop: scroll
			}, 500);

			setTimeout(function() {
				$navigationIndicator.removeClass('dont-move');
			}, 500);
		});

		if(isSticky){
			$(document).on('scroll', documentScrollHandler);
		}
	};

	var repositionIndicator = function($link, scrollLinkIntoView){
		if(typeof scrollLinkIntoView == 'undefined')
			scrollLinkIntoView = true;

		if (!$navigationIndicator.hasClass('dont-move')) {
			var width = 0;
			var left = 0;
			var scroll;

			if(!$link || !$link.length){
				$link = $navigationLinks.filter('.is-active');
			}


			if($link.length){
				width = $link.width();
				left = $link.position().left + parseFloat($link.css('padding-left')) + parseFloat($navigationWrapper.css('padding-left'));
			}


			if(scrollLinkIntoView){
				scroll = Math.max(0, left - parseInt($navigationWrapper.css('padding-left')));

				$navigationWrapper.stop().animate({
					scrollLeft: scroll,
				}, {
					duration: 500
				});
			}

			$navigationIndicator.css({
				'-webkit-transform': 'translateX(' + left + 'px)',
				'-ms-transform': 'translateX(' + left + 'px)',
				'transform': 'translateX(' + left + 'px)',
				'width': width
			});
		}
	};

	var documentScrollHandler = function() {
		var $prevElement = $element.prev();

		//fix page nav
		if ($(this).scrollTop() >= ($prevElement.offset().top + $prevElement.outerHeight()) ) {

			if (!$element.hasClass('is-fixed')) {
				$element.addClass('is-fixed');
				$content.css('margin-top', $element.outerHeight());
				$navigationItems.first().addClass('is-active');
				repositionIndicator($navigationItems.first());

			}
		}
		else {
			$element.removeClass('is-fixed');
			$content.removeAttr('style');
			$navigationItems.filter('.is-active').removeClass('is-active');
			repositionIndicator();
		}

		var $currentSectionTrigger = $navigationItems.filter('.is-active');
		var $currentSection = $('[data-page-nav-section="'+ $currentSectionTrigger.children().data('page-nav-target') +'"]');
		//highlight next element
		if ( $currentSectionTrigger.length > 0 && $currentSection.next().length > 0) {
			if ($(this).scrollTop() >= $currentSection.next().offset().top - $element.outerHeight() ) {
				$currentSectionTrigger.removeClass('is-active').next().addClass('is-active');
				repositionIndicator($currentSectionTrigger.next());
			}
		}
		//highlight prev element
		if ( $currentSectionTrigger.length > 0 && $currentSection.prev().length > 0) {
			if ($(this).scrollTop() <  $currentSection.prev().offset().top + $currentSection.prev().outerHeight() - $element.outerHeight() ) {
				$currentSectionTrigger.removeClass('is-active').prev().addClass('is-active');
				repositionIndicator($currentSectionTrigger.prev());
			}
		}
	};

	init();
	return api;
};

loop_app.ext['postmessage-iframe'] = function($el) {
	var api = {};

	var $element = $el;
	var messageCounter = 0;

	let initialScroll = { x: window.pageXOffset, y: window.pageYOffset };



	var init = function() {
		updateIframeParameters();
		wrapIframe();

		if(
			($element.attr('src') && $element.attr('src').indexOf('service.webhost.skidata.com') >= 0) || 
			($element.attr('data-src') && $element.attr('data-src').indexOf('service.webhost.skidata.com')) >= 0
		){
			var iframe = $element.iFrameResize({
				resizedCallback         : function(messageData){
					if ($(window).width() > 1140) {
						$element.parents('.section--booking').css('padding-bottom','30px');0
						$element.css('height', (parseInt(messageData.height)+150)+ 'px');
					} else {
						$element.parents('.section--booking').css('padding-bottom','');
					}
				}
			});
		}

		if($element.attr('src') && $element.attr('src').indexOf('iport.travelport.com') >= 0){
            var iframe = $element.iFrameResize({});
        }

		window.addEventListener("message", receiveMessage, true);

		function receiveMessage(event){
			messageCounter++;

			if (event.origin.indexOf('jobs.salzburg-airport.com') >= 0 ) {
				console.log('postmessage-iframe: jobs.salzburg-airport.com');
				if (typeof event.data === 'string' && event.data.startsWith('[iFrameSizer]')) {
					if (
						event.data.includes('scrollTo') ||
						event.data.includes('scrollToOffset') ||
						event.data.includes('inPageLink')
					) {
						console.log('[iFrameSizer] stop propagation');
						event.stopImmediatePropagation();
					}
				}

				if (typeof event.data === 'string' && event.data.startsWith('[iFrameSizer]')) {
					setTimeout(() => {
						console.log('[iFrameSizer] scroll to initial scroll');
						window.scrollTo(initialScroll.x, initialScroll.y);
					}, 0); // sofort zurückscrollen
				}
			}
			
			//car booking iframe
			if (event.origin.indexOf('partner.sunnycars.at') >= 0 ) {
				var height = event.data.split(';')[0];
				$('.js-car-booking').css('height', height + 'px');

			//flight booking iframe
			} else if (event.origin.indexOf('flr.ypsilon.net') >= 0 || event.origin.indexOf('flr-staging.ypsilon.net') >= 0) {
				var newHeight = event.data['iframe-height'];
				if (!newHeight) {
					newHeight = event.data.split(' ');
					newHeight = newHeight.length === 2 ? newHeight[1] : false;
				}
				if (newHeight) {
					$('.js-flight-booking').height(newHeight);

					var booking = $('.js-booking').data('obj_booking');

					if(booking){
						booking.updateBookingSwiper();
					}
				}
			} else if (event.origin.indexOf('booking.com') >= 0 ) {
				console.log(event.data);
			} else if (event.origin.indexOf('ibe.specials.de') >= 0) {
				var newHeight =  event.data.split(' ');
				var booking = $('.js-booking').data('obj_booking');

				if (newHeight[0] == 'default8899') {
					$('.js-packages-booking-iframe').height(newHeight[1]);

					if(booking){
						booking.updateBookingSwiper();
					}
				} else if (newHeight[0] == 'default1523') {
					$('.js-last-minute-booking-iframe').height(newHeight[1]);

					if(booking){
						booking.updateBookingSwiper();
					}
				}
			} else if (event.origin.indexOf('car.ypsilon.net') >= 0) {
				console.log(event.data)
				var newHeight = typeof event.data === 'number' ? event.data : (event.data['iframe-height'] ? event.data['iframe-height'] : false)
				var booking = $('.js-booking').data('obj_booking');
				if(newHeight) {
					$('.js-packages-booking-iframe').height(newHeight);
					if(booking){
						booking.updateBookingSwiper();
					}
				}
			// job iframe
			} else if (event.origin.indexOf('jobs.salzburg-airport.com') >= 0 ) {
				// scroll up on iframe page load
				if(messageCounter > 1) {
					$('html, body').animate({
						scrollTop: $element.offset().top
					}, {
						duration: 400,
					})
				}
			}
		}
	};

	var wrapIframe = function() {
		if ($element.hasClass('js-flight-booking')) {
			$element.wrap('<div class="booking__iframe__wrapper" />');
			$element.wrap('<div class="booking__iframe__inner__wrapper" />');
		}
	};

	var updateIframeParameters = function(){
		var parameters = getUrlParameter();
		var iframeSrc;
		var iframeParameters;
		var newIframeSrc;

		if ($element.attr('src') && $element.hasClass('js-flight-booking') && $element.attr('src').indexOf('flr.ypsilon.net') >= 0) {
			if(parameters.dstapt1){
				iframeSrc = $element.attr('src');
				iframeParameters = getUrlParameter(iframeSrc);

				if(iframeParameters.url){
					iframeParameters.url += window.encodeURIComponent('&dstapt1=' + parameters.dstapt1);

					newIframeSrc = iframeSrc.split('?')[0] + '?';

					newIframeSrc += _.map(iframeParameters, function(parameter, key){ return key + '=' + parameter; }).join('&');

					$element.attr('src', newIframeSrc);
				}
			}

			if(parameters.depapt1){
				iframeSrc = $element.attr('src');
				iframeParameters = getUrlParameter(iframeSrc);

				if(iframeParameters.url){
					iframeParameters.url += window.encodeURIComponent('&depapt1=' + parameters.depapt1);

					newIframeSrc = iframeSrc.split('?')[0] + '?';

					newIframeSrc += _.map(iframeParameters, function(parameter, key){ return key + '=' + parameter; }).join('&');

					$element.attr('src', newIframeSrc);
				}
			}

			if(loop_app.language == 'en'){
				iframeSrc = $element.attr('src');
				iframeParameters = getUrlParameter(iframeSrc);

				if(iframeParameters.url){
					iframeParameters.url += window.encodeURIComponent('&lang=en_GB');

					newIframeSrc = iframeSrc.split('?')[0] + '?';

					newIframeSrc += _.map(iframeParameters, function(parameter, key){ return key + '=' + parameter; }).join('&');

					$element.attr('src', newIframeSrc);
				}
			}
		}

		// parking booking iframe
		if($element.attr('src') &&  $element.attr('src').indexOf('service.webhost.skidata.com/car2') >= 0){
			parameters = getUrlParameter(undefined, true);

			if(parameters.parking_in_date && parameters.parking_in_time && parameters.parking_out_date && parameters.parking_out_time && parameters.parking_spot){

				var mIn = moment(parameters.parking_in_date + ' ' + parameters.parking_in_time, 'DD.MM.YYYY HH:mm');
				var mOut = moment(parameters.parking_out_date + ' ' + parameters.parking_out_time, 'DD.MM.YYYY HH:mm');

				if(!mIn.isValid()){
					mIn = moment(parameters.parking_in_date + ' ' + parameters.parking_in_time, 'YYYY-MM-DD HH:mm');
				}

				if(!mOut.isValid()){
					mOut = moment(parameters.parking_out_date + ' ' + parameters.parking_out_time, 'YYYY-MM-DD HH:mm');
				}

				if(mIn.isValid()
					&& mOut.isValid()
					&& parameters.parking_spot.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)){

					newIframeSrc = 'https://service.webhost.skidata.com/car2/maxxo/microsite/global/preselect?tag=reservation/product/preselect&tenantAlias=CarportB2Cpost&startDateTime='+mIn.format('YYYYMMDDHHmm')+'&endDateTime='+mOut.format('YYYYMMDDHHmm')+'&specialproduct='+parameters.parking_spot;

					if(loop_app.language == 'en'){
						newIframeSrc += '&lang=en_GB';
					}

					$element.attr('src', newIframeSrc);
				}
			}
		}
	};

	var getUrlParameter = function(url, shouldDecode){
		if(typeof url == 'undefined')
			url = window.location.href;

		if(url.indexOf('?') >= 0){
			url = url.split('?')[1];
		}

		if(shouldDecode){
			url = decodeURIComponent(url);
		}

		return _.fromPairs(_.compact(_.map(url.split('&'), function(item) {  if (item) return item.split('='); })));
	};

	init();
	return api;
};

loop_app.ext['print'] = function($el) {
	var api = {};

	var $element = $el;

	var init = function() {
		addListener();
	};

	var addListener = function(){
		$element.on('click', function(e){
			e.preventDefault();

			window.print();
		});
	};

	init();
	return api;
};

loop_app.ext['recaptcha'] = function($el) {
	var api = {};

	var $element = $el;
	var $hidden = $('<input type="hidden" name="recaptcha" required>');
	var $wrapper = $('<div class="g-recaptcha-wrapper u-position-relative" />');

	var init = function(){
		insertWrapper();
		insertHiddenInput();

		if(loop_app.recaptchaReady){
			loadRecaptcha();
		} else {
			$(window).on('recaptchaReady', function(){
				loadRecaptcha();
			});
		}
	};

	var insertWrapper = function(){
		$element.wrap($wrapper);
	};

	var insertHiddenInput = function(){
		$hidden.insertAfter($element);
	};

	var loadRecaptcha = function(){
		$element.data('grecaptchaId', grecaptcha.render($element[0], {
			'sitekey': $element.data('sitekey'),
			'callback': callback,
			'expired-callback': callback
		}));
	};

	var callback = function(){
		var response = grecaptcha.getResponse($element.data('grecaptchaId'));
		$element.data('recaptchaValid', response !== '');
		$element.trigger('change');

		if ($('html').hasClass('ios')) {
			
			$("html, body").animate({ scrollTop: $element.offset().top - ($(window).height() / 2) + ($element.height() / 2) }, 0);
		
		}
	};

	init();
	return api;
};

loop_app.ext['scrolling-table'] = function($el) {
	var api = {};

	var $element = $el;
	var $rows = $element.find('.js-scrolling-table-row');

	var labelSelector = '.js-scrolling-table-label';
	var scrollContainer = $element.find('.scrolling-table__scroll-container');
	
	var init = function() {
		initStates();
	};

	var myScrollbar;

	var initStates = function(){
		enquire.register('screen and (max-width: 767px)', {
			match: function(){
				$(window).on('resize.scrollingtable orientationchange.scrollingtable load.scrollingtable', _.debounce(function(){
					resetHeight();
					matchHeight();
				}, 200));

				let simpleBar = new SimpleBar($element[0],  { autoHide: false });
				simpleBar.getScrollElement().addEventListener('scroll', function( event ) {
				});
			},
			unmatch: function(){
				$(window).off('resize.scrollingtable orientationchange.scrollingtable load.scrollingtable');
				resetHeight();
			}
		});
	};

	var matchHeight = function(){
		$rows.each(function(){
			var $row = $(this);
			var $label = $row.find(labelSelector);
			var rowHeight = $row.outerHeight();
			var labelHeight = $label.outerHeight();

			if(labelHeight <= rowHeight){
				$label.css('height', rowHeight);
			} else {
				$row.css('height', labelHeight);
			}

		});
	};

	var resetHeight = function(){
		$rows.css('height', '');
		$rows.find(labelSelector).css('height', '');
	};

	init();
	return api;
};

loop_app.ext['scrollup'] = function($el) {
	var api = {};

	var $element = $el;

	var init = function() {
		addListener();
	};

	var addListener = function(){
		$element.on('click.scrollup', function(e){
			e.preventDefault();

			///////////////////////////////////////////////////////////////
			// no idea what is the reason for this if else - commenting out
			///////////////////////////////////////////////////////////////


			// if ($('body#page-143').length > 0 || $('body#page-144').length > 0 || $('body#page-252').length > 0) {

			// 	$('.js-header').velocity('scroll', {
			// 		container: $('.js-site'),
			// 		offset: 0,
			// 		duration: 800,
			// 		easing: 'easeInOutCubic'
			// 	});
			// } else {
			// 	$('html').velocity('scroll', {
			// 		offset: 0,
			// 		duration: 800,
			// 		easing: 'easeInOutCubic'
			// 	});
			// }

			$('html').velocity('scroll', {
				offset: 0,
				duration: 800,
				easing: 'easeInOutCubic'
			});
	
			loop_app.resetFocus();
		});
	};

	init();
	return api;
};

loop_app.ext['search-404'] = function($el) {
	var api = {};

	var $element = $el;
	var $input = $element.find('.js-search-input-404');
	var $form = $element.find('.js-search-form-404');

	var $search = $('.js-search');

	var autocompleteLookup = [];
	var searchData;
	var resultTemplates = {};
	var isOpen = false;

	var init = function() {
		$input.autocomplete({
			lookup: autocompleteLookup,
			width: 'flex',
			onSelect: function(){
				triggerExternalSearch();
			},
			beforeRender: function($container){
				$container.addClass('autocomplete-suggestions--search');
				$container.prepend('<div class="autocomplete-label">' + $input.data('autocomplete-label') + '</div>');
			}
		});

		loadAutocomplete();
		addListener();
	};

	var addListener = function(){
		$form.on('submit', function(e){
			e.preventDefault();

			triggerExternalSearch();
		});
	};

	var loadAutocomplete = function(){
		$.ajax({
			url: $element.data('autocomplete-api'),
			success: function(data){
				autocompleteLookup = data;
				$input.autocomplete('setOptions', {lookup: autocompleteLookup});
			},
			error: function(){
				console.error(arguments);
				// TODO: error handling
			}
		});
	};

	var triggerExternalSearch = function () {
		$search.data('obj_search').searchExternal($input.val());
	}

	init();
	return api;
};

loop_app.ext['search'] = function($el) {
	var api = {};

	var $element = $el;
	var $input = $element.find('.js-search-input');
	var $mask = $element.find('.js-search-mask');
	var $detail = $element.find('.js-search-detail');
	var $form = $element.find('.js-search-form');
	var $searchResults = $element.find('.js-search-result');
	var $searchValue = $element.find('.js-search-value');
	var $searchValueReset = $element.find('.js-search-value-reset');
	var $countAll = $element.find('.js-search-count-all');
	var $counts = $element.find('.js-search-count');
	var $noResult = $element.find('.js-search-no-result');

	var $searchTrigger = $('.js-header-search-trigger');
	var $searchAd = $('.js-ad-element-search');
	var $searchInput404 = $('.js-search-input-404');
	var $site = $('.js-site');

	var autocompleteLookup = [];
	var searchData = {};
	var resultTemplates = {};
	var isOpen = false;
	var searchTypes = ['flights', 'general', 'news'];
	var noResultShowing = false;

	var init = function() {

		$input.autocomplete({
			lookup: autocompleteLookup,
			width: 'flex',
			triggerSelectOnValidInput: false,
			onSelect: function(){
				search();
			},
			beforeRender: function($container){
				$container.addClass('autocomplete-suggestions--search');
				$container.prepend('<div class="autocomplete-label">' + $input.data('autocomplete-label') + '</div>');
			}
		});

		searchExternal();

		loadAutocomplete();
		initResultTemplates();
		addListener();
	};

	var addListener = function(){
		$form.on('submit', function(e){
			e.preventDefault();
			search();
		});

		$element.on('open', function(){
			$input.autocomplete().enable();

			$element.css({
				'transform': 'none',
				'-webkit-transform': 'none',
				'-moz-transform': 'none',
				'-ms-transform': 'none',
				'-o-transform': 'none',
			});
		});

		$element.on('beforeClose', function(){
			$site.trigger('unlock');
		});

		$element.on('close', function(){
			closeDetail(0);
			$input.autocomplete().disable();
		});

		$searchResults.on('click', '.js-search-result-more', function(e){
			e.preventDefault();

			var $result = $(e.delegateTarget);
			var type = $result.data('result-type');
			var data = searchData[type];
			var offset = $result.data('result-offset');

			if(type == 'flights'){
				var table = $(this).data('more-table');

				offset = $result.data('result-offset-' + table);
				data = _.pick(data, table);
			}

			renderItems(data, type, offset, true);
		});

		$searchValueReset.on('click', function(e){
			e.preventDefault();

			closeDetail(500);
			$input.val('');
		});

		$input.on('change input', function(){
			hideNoResult();
		});
	};

	var loadAutocomplete = function(){
		$.ajax({
			url: $element.data('autocomplete-api'),
			success: function(data){
				autocompleteLookup = data;
				$input.autocomplete('setOptions', {lookup: autocompleteLookup});
			},
			error: function(){
				console.error(arguments);
				// TODO: error handling
			}
		});
	};

	var initResultTemplates = function(){
		var $templates = $element.find('.js-search-result-template');


		$templates.each(function(){
			var $template = $(this);

			resultTemplates[$template.data('result-type')] = _.template($template.html());
		});
	};

	var search = function(){
		if(!$input.val() || isOpen)
			return;

		$element.addClass('is-loading');
		lockInput();

		$searchResults.removeData('result-offset');
		$searchResults.removeData('result-offset-departure');
		$searchResults.removeData('result-offset-arrival');

		var deferreds = [];

		_.forEach(searchTypes, function(type){
			var deferred = $.ajax({
				url: $element.data('search-'+type+'-api'),
				data: {
					query: $input.val()
				},
			});

			deferred.type = type;

			deferreds.push(deferred);
		});

		$.when.apply($, deferreds).done(function(){
			searchData = {};

			_.forEach(arguments, function(result){
				if(result[1] == 'success'){
					searchData[result[2].type] = result[0];
				}
			});

			if(_.isEmpty(searchData)){
				unlockInput();
				// TODO show error message
				return;
			}

			$searchValue.text($input.val());

			var count = updateResultCounts();

			if(!count){
				showNoResult();
				unlockInput();
			} else {
				_.forEach(searchData, function(itemsData, key){
					renderItems(itemsData, key);
				});

				showDetail();
				history.pushState(null, null, window.location.pathname + '?search='+$input.val());

				initSearchAd();
			}

			$element.find('.js-flight-plan').data('obj_flightPlan').handleTabindexOfLoadedFLights();
			
			$element.removeClass('is-loading');
		});
	};

	var lockInput = function(){
		isOpen = true;
		$input.blur();
		$input.prop('readonly', true);
	};

	var unlockInput = function(){
		isOpen = false;
		$input.prop('readonly', false);
	};

	var renderItems = function(itemsData, type, offset, shouldAnimate){
		var $result = $searchResults.filter('[data-result-type="'+type+'"]');
		var limit = $result.data('result-limit') || 10;

		if(type === 'flights'){
			if(!itemsData.departure.length && !itemsData.arrival.length){
				// hide search result block if no result found
				$result.hide();
				return;
			}

			$result.show();

			if(typeof offset == 'undefined'){
				offset = 0;
			}

			var data = {
				departure: _.slice(itemsData.departure, 0, offset + limit),
				arrival: _.slice(itemsData.arrival, 0, offset + limit),
			};

			_.forEach(itemsData, function(value, table){
				$result.data('result-offset-' + table, offset + limit);

				if(offset + limit >= itemsData[table].length){
					$result.find('.js-search-result-more[data-more-table="'+table+'"]').hide();
				} else {
					$result.find('.js-search-result-more[data-more-table="'+table+'"]').show();
				}
			});

			$result.data('obj_flight-plan').fillTables(data);

		} else {
			if(!itemsData.length){
				// hide search result block if no result found
				$result.hide();
				return;
			}

			$result.show();

			var template = resultTemplates[type];
			var $container = $result.find('.js-search-result-container');
			var $more = $result.find('.js-search-result-more');
			var html = '';
			var $items;

			if(typeof offset == 'undefined'){
				offset = $container.children().length;
			}

			if($result.length && $container.length && template){
				_.forEach(itemsData.slice(offset, offset + limit), function(itemData){
					html += template(itemData);
				});

				$items = $(html).not('text');
				loop_app.initLocalExtensions($items);

				if(shouldAnimate){
					$items.css('opacity', 0);
					$items.appendTo($container);
					$items.each(function(index){
						$(this).velocity({
							translateY: [0, -10],
							opacity: [1, 0]
						}, {
							duration: 300,
							delay: index * 50
						});
					});
				} else {
					$items.appendTo($container);
				}

				$result.data('result-offset', offset + limit);

				if(itemsData.length <= offset + limit){
					$more.hide();
				} else {
					$more.show();
				}

				window.setTimeout(function(){
					$items.mark($input.val());
				}, 1000);
			}
		}

	};

	var showDetail = function(){
		var maskHeight = $mask.outerHeight();

		$mask.velocity({
			translateY: '-100%',
		}, {
			duration: 500,
			easing: 'easeInOutQuart',
			display: 'none',
			complete: function(){
				$mask.off('keydown');
			}
		});

		$detail.velocity({
			opacity: [1, 0],
			translateY: [-maskHeight, -maskHeight/2]
		}, {
			duration: 500,
			easing: 'easeInOutQuart',
			display: 'block',
			complete: function(){

				loop_app.setFocusableOverlayEls($detail);

				$site.trigger('lock');
				$detail.css({
					'transform': '',
					'-webkit-transform': '',
					'-moz-transform': '',
					'-ms-transform': '',
				});

				$detail.find('.js-flight-plan').trigger('update');
				$detail.removeAttr('aria-hidden');

				$mask.attr('aria-hidden', 'true');
			}
		});

		// manually update dotdotdot
		window.setTimeout(function(){
			$detail.find('.js-dotdotdot').trigger('update');
		});

		window.setTimeout(function(){
			$detail.find('.js-dotdotdot').trigger('update');
		}, 1000);
	};

	var closeDetail = function(duration){


		$element.removeClass('is-external');
		$searchInput404.val('');

		if (window.location.href.indexOf('?') > -1) {
			history.pushState('', document.title, window.location.pathname);
		}

		var maskHeight = $mask.outerHeight();

		$mask.velocity({
			translateY: ['0%', '-100%'],
		}, {
			duration: duration,
			easing: 'easeInOutQuart',
			display: 'block',
			complete: function(){
			}
		});

		$detail.velocity({
			opacity: [0, 1],
			translateY: [-maskHeight/2, -maskHeight]
		}, {
			duration: duration,
			easing: 'easeInOutQuart',
			display: 'none',
			complete: function(){
				$site.trigger('unlock');
				$detail.css({
					'transform': '',
					'-webkit-transform': '',
					'-moz-transform': '',
					'-ms-transform': '',
				});

				$searchResults.each(function(){
					var $result = $(this);
					var $container = $result.find('.js-search-result-container');

					$container.empty();
					$result.data('offset', 0);
				});

				$detail.attr('aria-hidden','true');
				$detail.off('keydown');

				$mask.removeAttr('aria-hidden');
				$mask.find('.js-search-input').trigger('focus');

				unlockInput();
			}
		});
	};

	var searchExternal = function(searchString) {
		if (searchString) {
			$input.val(searchString);
		}

		if ($input.val()) {
			$("html, body").animate({ scrollTop: 0 }, 100);
			$element.addClass('is-external');
			$searchTrigger.trigger('click');
			search();
		}

	};

	var initSearchAd = function() {
		// var html = $searchAd.data('ins')
		// $searchAd.append(html);

		// setTimeout(function(){
		// 	$searchAd.css('width', $searchAd.parents('.js-ad-element-wrapper').width() + 'px');
		// 	(adsbygoogle = window.adsbygoogle || []).push({});
		// },500);
	};

	var updateResultCounts = function(){
		var countAll = 0;

		_.forEach(searchData, function(result, key){
			var count = 0;
			var $count = $counts.filter('[data-result-type="'+key+'"]');

			if(key == 'flights'){
				count += result.arrival.length;
				count += result.departure.length;
			} else {
				count += result.length;
			}

			countAll += count;

			$count.html(count);

			if(!count){
				$count.closest('.js-page-nav-item').hide();
			} else {
				$count.closest('.js-page-nav-item').show();
			}
		});

		$countAll.html(countAll);

		return countAll;
	};

	var showNoResult = function(){
		if(noResultShowing)
			return;

		noResultShowing = true;
		$noResult.velocity({
			opacity: [1, 0],
			translateY: [0, 5],
		}, {
			duration: 400,
			easing: 'easeOutQuart',
			display: 'block',
		});
	};

	var hideNoResult = function(){
		if(!noResultShowing)
			return;

		noResultShowing = false;
		$noResult.velocity({
			opacity: [0, 1],
			translateY: [5, 0],
		}, {
			duration: 400,
			easing: 'easeOutQuart',
			display: 'none',
		});
	};

	var isSearchDetailOpen = function(){
		return isOpen;
	};

 	api.isSearchDetailOpen = isSearchDetailOpen;
 	api.searchExternal = searchExternal;
 	api.initSearchAd = initSearchAd;

	api.closeOverlay = closeDetail;

	init();
	return api;
};

loop_app.ext['sharing'] = function($el) {
	var api = {};

	var $element = $el;
	var $toggle = $element.find('.js-sharing-toggle');
	var $links = $element.find('.js-sharing-link');

	var sharingUrls = {
		facebook: 'https://www.facebook.com/sharer/sharer.php?u={{link}}',
		twitter: 'https://twitter.com/intent/tweet?source={{link}}&text={{link}}',
	};

	var init = function() {
		addListener();
		checkState();
	};

	var addListener = function(){
		$links.on('click', function(e){
			e.preventDefault();

			if($element.hasClass('is-active')){
				var $link = $(this);
				var shareType = $link.data('sharing-type');
				var shareUrl = sharingUrls[shareType];

				if(shareUrl){
					shareUrl = shareUrl.replace(/{{link}}/ig, window.location.href);
					window.open(shareUrl, '', 'width=600,height=400');
				} else {
					window.open($link.attr('href'), '', 'width=600,height=400');
				}
			}
		});

		$toggle.on('change', function(e){
			if($element.hasClass('is-active')){
				e.preventDefault();
				$toggle.prop('checked', true);
			}

			checkState();
		});
	};

	var checkState = function(){
		if($toggle.prop('checked')){
			$element.addClass('is-active');
			$links.removeAttr('tabindex').removeAttr('aria-hidden');
		} else {
			$element.removeClass('is-active')
			$links.attr('tabindex', '-1').attr('aria-hidden','true');
		}
	};

	init();
	return api;
};

loop_app.ext['show-more'] = function($el) {
	var api = {};

	var $element = $el;
	var $hiddens = $element.find('.js-show-more-hidden');
	var $trigger = $element.find('.js-show-more-trigger');

	var limit = $element.data('show-more-limit');

	var init = function() {
		if(!$hiddens.length){
			$trigger.parent().hide();
		}

		$hiddens.hide().removeClass('u-hide');
		addListener();
	};

	var addListener = function(){
		$trigger.on('click', function(e){
			e.preventDefault();

			showMore();
		});
	};

	var showMore = function(){
		var $toShow = $hiddens.filter(':hidden:lt('+ limit +')');

		if($hiddens.filter(':hidden').length <= limit){
			$trigger.parent().hide();
		}

		$toShow.each(function(index){
			var $item = $(this);

			$item.css({
				display: 'block',
				opacity: 0,
			});

			$item.velocity({
				opacity: 1,
				translateY: [0, 10]
			}, {
				duration: 300,
				delay: index * 50,
			});

			if(index === 0){
				window.tabbable.tabbable($item.get(0))[0].focus()
			}
		});

	};

	init();
	return api;
};

loop_app.ext['site-bg'] = function($el) {
	var api = {};

	var $element = $el;

	var init = function() {
		if ($element.height() == 0) {
			$element.css('height', $(window).height() + 'px');
		}
	};

	init();
	return api;
};

loop_app.ext['site'] = function($el) {
	var api = {};

	var $element = $el;
	var $content = $element.find('.js-site-content');

	var init = function() {
		addListener();

		$("body").on("contextmenu", "img", function(e) {
		  return false;
		});

		$('input[type=checkbox]').on('keypress', function(e){
			if (e.keyCode == 13) {
				$(this).prop('checked',!$(this).is(':checked'));
				$(this).trigger('change');
			}
		});
	};

	var addListener = function(){
		$element.on('lock', function(){
			lockContent();
		});

		$element.on('unlock', function(){
			unlockContent();
		});

		$( "a[href^='tel']").on('click', function(e) {
			if ($('html').hasClass('no-touch')) {
				e.preventDefault();
			}
		});
	};

	var lockContent = function(){
		$content.addClass('is-locked');
	};

	var unlockContent = function(){
		$content.removeClass('is-locked');
	};

	init();
	return api;
};

loop_app.ext['social-hub'] = function($el) {
	var api = {};

	var $element = $el;
	var $swiper = $element.find('.js-social-hub-swiper');
	var $filterTriggers = $element.find('.js-social-hub-filter');
	var $filterIndicator = $element.find('.js-social-hub-filter-indicator');
	var $loader = $element.find('.js-social-hub-loader');
	var $prev = $element.find('.js-social-hub-prev');
	var $next = $element.find('.js-social-hub-next');

	var mySwiper;
	var isLoading = false;
	var pageNumber = 1;
	var activeFilter = '';
	var postTemplate = _.template($element.find('.js-social-hub-post-template').html());
	var noMoreToLoad = false;
	var swiperSettingsMobile = {
		slidesPerView: 'auto',
		slidesPerGroup: 1,
		spaceBetween: 10,
	};
	var swiperSettingsDesktop = {
		slidesPerView: 4,
		slidesPerGroup: 4,
		spaceBetween: 20,
	};

	var init = function() {
		mySwiper = new Swiper($swiper, _.assign({
			speed: 600,
			autoHeight: false,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			slideVisibleClass: 'is-visible',
			nextButton: $next,
			prevButton: $prev,
			buttonDisabledClass: 'is-disabled',
			a11y: true,
			prevSlideMessage: loop_app.translations.prev_slide,
			nextSlideMessage: loop_app.translations.next_slide,
			paginationBulletMessage: loop_app.translations.go_to_slide,
			onSlideChangeStart: function(swiper){
				if(mySwiper.slides.length - mySwiper.activeIndex <= 12 && !noMoreToLoad){
					loadPosts();
				}
				
				for( var i = swiper.previousIndex; i < (swiper.previousIndex + swiper.params.slidesPerView); i++) {
					$(swiper.slides[i]).attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
				}

				for( var i = swiper.activeIndex; i < (swiper.activeIndex + swiper.params.slidesPerView); i++) {
					$(swiper.slides[i]).removeAttr('aria-hidden').find('a').removeAttr('tabindex');
				}
			},
			onTouchMove: function(swiper){
				swiper.params.speed = 300;
			},
			onTransitionEnd: function(swiper){
				swiper.params.speed = 600;

				// for lazy loading update
				$(window).trigger('scroll');

				if ($prev.hasClass('is-disabled')) {
					$prev.attr('tabindex','-1');
				} else {
					$prev.attr('tabindex','0');
				}

				if ($next.hasClass('is-disabled')) {
					$next.attr('tabindex','-1');
				} else {
					$next.attr('tabindex','0');
				}
			},
			onInit: function(swiper) {
				if ($prev.hasClass('is-disabled')) {
					$prev.attr('tabindex','-1');
				} else {
					$prev.attr('tabindex','0');
				}
			}
		}, swiperSettingsMobile));

		initStates();
		addListener();
		loadPosts(true);
		positionIndicator();

		// a11y for filter icons
		$filterTriggers.each(function(){
			var $filter = $(this);
			var filterValue = $filter.data('filter');

			if(filterValue){
				$filter.attr('aria-label', filterValue);
			}

		});
	};

	var initStates = function(){
		enquire.register('screen and (min-width: 1280px)', {
			match: function(){
				mySwiper.params = _.assign(mySwiper.params, swiperSettingsDesktop);
				mySwiper.update(true);
			},
			unmatch: function(){
				mySwiper.params = _.assign(mySwiper.params, swiperSettingsMobile);
				mySwiper.update(true);
			}
		});
	};

	var addListener = function(){
		$filterTriggers.on('click.social-hub', function(e){
			e.preventDefault();

			var newFilter = $(this).data('filter');

			filter(newFilter);
		});

		$(window).on('resize load', _.debounce(function(){
			positionIndicator();
		}, 200));
	};

	var loadPosts = function(clear){
		if(typeof clear == 'undefined'){
			clear = false;
		}

		if(isLoading){
			return;
		}

		isLoading = true;

		if(clear){
			showLoader();
			mySwiper.wrapper.velocity({
				opacity: 0
			}, {
				duration: 200
			});
		}

		let sourceType = ''
		if(activeFilter === 'facebook'){
			sourceType = 5;
		} else if(activeFilter === 'instagram'){
			sourceType = 33;
		}

		let apiURL = `${$element.data('api-url')}?offset=${(pageNumber - 1) * 15}&limit=15&source_type=${sourceType}`;
		fetch(apiURL).then((response) => {
			return response.json();
		}).then((data) => {
			if(clear){
				hideLoader();
			}

			isLoading = false;


			if(data.posts.length){

				var postHtml = '';
				var $posts;


				pageNumber++;


				_.forEach(data.posts, function(item){
					// strip all tags from text, except for <br>

					item.unformatted_message = item.unformatted_message ? item.unformatted_message.replace( /<[^br].*?>/g, '' ) : item.unformatted_message;
					item.normalizedText = String(item.text || '').normalize('NFKC');
					postHtml += postTemplate(item);
				});

				$posts = $(postHtml).filter(':not(text)');
				
				if (mySwiper.slides.length == 0) {
					$posts.filter(':lt('+ mySwiper.params.slidesPerView +')').removeAttr('aria-hidden').find('a').removeAttr('tabindex');
				}

				loop_app.initLocalExtensions($posts);

				if(clear){
					mySwiper.removeAllSlides();
					mySwiper.slideTo(0);
					mySwiper.wrapper.velocity({
						opacity: 1
					}, {
						duration: 200
					});
				}

				mySwiper.appendSlide($posts);

				$element.find('.js-dotdotdot').trigger('update');

				$posts.each(function(index, element){
					$(this).css('opacity', 0).velocity({
						translateY: [0, -10],
						opacity: 1
					}, {
						duration: 300,
						delay: index * 50
					});
				});

				$("html, body").animate({ scrollTop: ($("html, body").scrollTop() + 1) + "px"});
				$("html, body").animate({ scrollTop: ($("html, body").scrollTop() - 1) + "px"});

			} else {
				noMoreToLoad = true;
			}
		}).catch((error) => {
			console.log(error);
		});
	};

	var filter = function(newFilter){
		activeFilter = newFilter;
		pageNumber = 1;
		noMoreToLoad = false;

		$filterTriggers
			.removeClass('is-active')
			.filter('[data-filter="'+newFilter+'"]')
			.addClass('is-active');

		positionIndicator();
		loadPosts(true);
	};

	var positionIndicator = function(){
		var $activeFilterTrigger = $filterTriggers.filter('.is-active');
		var position = $activeFilterTrigger.position();
		var width = $activeFilterTrigger.outerWidth();
		var marginLeft = parseInt($activeFilterTrigger.css('margin-left'));

		$filterIndicator.css({
			width: width,
			transform: 'translateX(' + (position.left + marginLeft) + 'px)'
		});
	};

	var showLoader = function(){
		$loader.velocity({
			opacity: [1, 0]
		}, {
			duration: 200,
			display: 'block'
		});
	};
	api.showLoader = showLoader;

	var hideLoader = function(){
		$loader.velocity('stop').velocity({
			opacity: 0
		}, {
			duration: 200,
			display: 'none'
		});
	};
	api.hideLoader = hideLoader;

	init();
	return api;
};

loop_app.ext['timepicker'] = function($el) {
	var api = {};

    var $element = $el;

    var init = function(){

        if ($('html').hasClass('mobile')) {
             $el.attr('type', 'time');
        } else {

            /* $el.on('keydown', function(e) {
                e.preventDefault();
            }); */

            $el.timepicker({
                timeFormat: 'HH:mm',
                interval: 30,
                dynamic: false,
                dropdown: true,
                scrollbar: true,
                change: function(time) {
                    $element.trigger('change');
                }
            });
        }

    }
    
    init();
	return api;
};
loop_app.ext['tourist-info'] = function($el) {
	var api = {};

	var $element = $el;
	var $select = $element.find('.js-tourist-info-select');
	var $swiper = $element.find('.js-tourist-info-swiper');
	var $linkSwiper = $element.find('.js-tourist-info-link-swiper');
	var mySwiper;
	var myLinkSwiper;
	var $pagination = $element.find('.js-tourist-info-pagination');

	var init = function() {
		enquire.register('screen and (min-width: 1280px)', {
			match: function(){
				destroySwipers();
				initSwipers('desktop');
			},
		});

		enquire.register('screen and (max-width: 1279px)', {
			match: function(){
				destroySwipers();
				initSwipers('mobile');
			},
		});

		initSelect();
		addListener();
	};

	var initSwipers = function(type){
		mySwiper = new Swiper($swiper, {
			speed: 600,
			pagination: $pagination,
			bulletClass: 'bullet',
			bulletActiveClass: 'is-active',
			paginationClickable: true,
			paginationClickableClass: 'is-clickable',
			spaceBetween: getSpaceBetween(),
			a11y: true,
			prevSlideMessage: loop_app.translations.prev_slide,
			nextSlideMessage: loop_app.translations.next_slide,
			paginationBulletMessage: loop_app.translations.go_to_slide,
			onSlideChangeStart: function(swiper){
				$select
					.val(mySwiper.activeIndex)
					.trigger('change');

				if(Modernizr.touch){
					updateTouchSelectWidth();
				}

				$(swiper.slides).attr('inert','true');
				$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
			},
			onInit: function(swiper) {
				$swiper.find('span.bullet').each(function(){
					var slideTitle = $select.data('prepend')+ ' ' +$($select.find('option')[$(this).index()]).html() + ' ' + $select.data('append');
					$(this).attr('aria-label',$(this).attr('aria-label')+': '+slideTitle);
				});

				$(swiper.slides).attr('inert','true');
				$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
			}
		});

		if($linkSwiper.length){
			myLinkSwiper = new Swiper($linkSwiper, {
				a11y: true,
				prevSlideMessage: loop_app.translations.prev_slide,
				nextSlideMessage: loop_app.translations.next_slide,
				paginationBulletMessage: loop_app.translations.go_to_slide,
				speed: 600,
				autoHeight: type == 'mobile',

				onTransitionEnd: function(swiper){
					$(swiper.slides).attr('inert','true');
					$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
				},
	
				onInit: function(swiper){
					$(swiper.slides).attr('inert','true');
					$(swiper.slides[swiper.activeIndex]).removeAttr('inert').removeAttr('aria-hidden').find('[data-tabindex="0"]').removeAttr('data-tabindex').removeAttr('tabindex');
				}
			});

			if(type != 'mobile'){
				myLinkSwiper.disableTouchControl();
			}

			myLinkSwiper.params.control = mySwiper;
			mySwiper.params.control = myLinkSwiper;
		}
	};

	var destroySwipers = function(){
		mySwiper && mySwiper.destroy(true, true);
		myLinkSwiper && myLinkSwiper.destroy(true, true);
	};

	var initSelect = function(){
		if(Modernizr.touch)
			return;

		var select2;

		$select.select2({
			theme: 'tourist-info',
			width: 'auto',
			dropdownAutoWidth: true,
			minimumResultsForSearch: Infinity,
		});

		select2 = $select.data('select2');

		select2.dropdown._showDropdown = function (decorated) {
			select2.dropdown.$dropdownContainer.find('.select2-dropdown').css('visibility', 'hidden');
			select2.dropdown.$dropdownContainer.appendTo(select2.dropdown.$dropdownParent);

			select2.dropdown.$dropdownContainer.find('.select2-dropdown').css('height', '');

			select2.dropdown._positionDropdown();
			select2.dropdown._resizeDropdown();

			window.setTimeout(function(){
				var $dropdown = select2.dropdown.$dropdownContainer.find('.select2-dropdown');
				var $selectedOption = select2.$results.find('[aria-selected="true"]');
				var dropdownHeight = $dropdown.outerHeight();
				var dropdownWidth = $dropdown.outerWidth();
				var position = $selectedOption.position();
				var paddingTop = parseInt($selectedOption.css('padding-top'));
				var paddingLeft = parseInt($selectedOption.css('padding-left'));

				select2.dropdown.$dropdownContainer.find('.select2-dropdown').velocity({
					opacity: [1, 0],
					height: [dropdownHeight, $selectedOption.outerHeight()],
					width: [dropdownWidth, dropdownWidth - paddingLeft * 2],
					top: [-position.top - paddingTop, 0],
					left: [0, paddingLeft],
				}, {
					duration: 300,
					complete: function(){
						select2.$container.addClass('is-open');
						select2.dropdown.$dropdownContainer.addClass('is-open');
					},
					visibility: 'visible',
					display: 'block'
				});

				select2.dropdown.$dropdownContainer.find('.select2-results').velocity({
					marginTop: [0, -position.top - paddingTop],
					marginLeft: [0, - paddingLeft]
				}, {
					duration: 300
				});
			});

		};

		select2.dropdown._hideDropdown = function(){
			select2.$container.removeClass('is-open');
			select2.dropdown.$dropdownContainer.removeClass('is-open');

			select2.dropdown.$dropdownContainer.find('.select2-dropdown').velocity({
				opacity: 0
			}, {
				duration: 300,
				complete: function(){
					select2.dropdown.$dropdownContainer.detach();
				},
				visibility: 'hidden',
				display: 'block'
			});
		};

		select2.dropdown._positionDropdown = function(){
			var $window = $(window);

			var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
			var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

			var newDirection = null;

			var offset = this.$container.offset();

			offset.bottom = offset.top + this.$container.outerHeight(false);

			var container = {
				height: this.$container.outerHeight(false)
			};

			container.top = offset.top;
			container.bottom = offset.top + container.height;

			var dropdown = {
				height: this.$dropdown.outerHeight(false)
			};

			var viewport = {
				top: $window.scrollTop(),
				bottom: $window.scrollTop() + $window.height()
			};

			var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
			var enoughRoomBelow = true;
			// var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

			var css = {
				left: offset.left,
				top: container.bottom
			};

			// Determine what the parent element is to use for calciulating the offset
			var $offsetParent = this.$dropdownParent;

			// For statically positoned elements, we need to get the element
			// that is determining the offset
			if ($offsetParent.css('position') === 'static') {
				$offsetParent = $offsetParent.offsetParent();
			}

			var parentOffset = $offsetParent.offset();

			css.top -= parentOffset.top;
			css.left -= parentOffset.left;

			if (!isCurrentlyAbove && !isCurrentlyBelow) {
				newDirection = 'below';
			}

			if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
				newDirection = 'above';
			} else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
				newDirection = 'below';
			}

			if (newDirection == 'above' ||
				(isCurrentlyAbove && newDirection !== 'below')) {
				css.top = container.top - parentOffset.top - dropdown.height;
			}

			if (newDirection !== null){
				this.$dropdown
					.removeClass('select2-dropdown--below select2-dropdown--above')
					.addClass('select2-dropdown--' + newDirection);
				this.$container
					.removeClass('select2-container--below select2-container--above')
					.addClass('select2-container--' + newDirection);
			}

			this.$dropdownContainer.css(css);
		};
		$select.on('select2:select', function (e) {
			screenReaderFix();
		});


		$select.on('select2:open', function (e) {
			setTimeout(function(){
				$select.data('select2').$dropdown.find('.select2-results__option').prepend('<span class="u-sr-only">'+ $select.data('prepend') + '</span>').append('<span class="u-sr-only">'+ $select.data('append') + '</span>');
			}, 250);
		});


		setTimeout(function(){
			screenReaderFix();
		},500);
		
		// open on hover
		// select2.$container.on('mouseenter', function(){
		// 	$select.select2('open');
		// });
	};
	var screenReaderFix = function(){
		$select.next().find('.select2-selection__rendered').prepend('<span class="u-sr-only">'+ $select.data('prepend') + '</span>').append('<span class="u-sr-only">'+ $select.data('append') + '</span>');
	}
	var	addListener = function(){
		$(window).on('resize.tourist-info', _.debounce(function(){
			mySwiper.params.spaceBetween = getSpaceBetween();
			mySwiper.update(true, true);

			if(Modernizr.touch){
				updateTouchSelectWidth();
			}
		}, 200));

		$select.on('change', function(){
			mySwiper.slideTo($select.val());

			if(Modernizr.touch){
				updateTouchSelectWidth();
			}
		});
	};

	var getSpaceBetween = function(){
		return $swiper.offset().left;
	};

	var updateTouchSelectWidth = function(){
		var $fakeSelect = $select.clone();
		var width;

		$fakeSelect.css({
			width: 'auto',
			position: 'absolute',
			opacity: 0,
			visibility: 'hidden'
		});

		$fakeSelect.find('option[value!="'+$select.val()+'"]').remove();
		$fakeSelect.insertAfter($select);

		width = $fakeSelect.width();

		$fakeSelect.remove();

		$select.css('width', width);
	};

	api.updateTouchSelectWidth = updateTouchSelectWidth;

	init();
	return api;
};

loop_app.ext['ultimate-rte'] = function($el) {
	var api = {};

	var $element = $el;

	var $buttons = $element.find('.link.link--styled');
	var $tables = $element.find('.contenttable');

	var $mags = $element.find('.js-ultimate-rte-mag');
	var $vids = $element.find('.js-ultimate-rte-youtube');

	var init = function() {
		initTables();
		initButtons();
		initMag();
		initVids();
	};

	var initTables = function(){
		$tables.each(function(){
			var $table = $(this);

			$table.wrap('<div class="contenttable-container" />');
		});
	};

	var initMag = function(){
		$mags.each(function(){
			var $mag = $(this);

			$mag.wrap('<div class="ultimate-rte__mag-container" />');
		});
	};

	var initVids = function(){
		$vids.each(function(){
			var $vid = $(this);
			var $vidIframe = $(this).find('iframe');

			var width = $vidIframe.attr('width');
			var height = $vidIframe.attr('height');

			$vid.wrap('<div class="ultimate-rte__vid-container" style="padding-top:'+ (height/width) * 100 +'%"/>');
		});
	};

	var initButtons = function(){
		$buttons.each(function(){
			var $button = $(this);

			$button.addClass('button button--ghost button--chevron-right');
			$button.removeClass('link link--styled');
		});
	};

	init();
	return api;
};

loop_app.ext['video-embed'] = function($el) {
	var api = {};

	var $element = $el;
	var $preview = $element.find('.js-video-embed-preview');
	var $embed = $element.find('.js-video-embed-element');
	var $duration = $element.find('.js-video-embed-duration');

	var player;

	var init = function() {
		loop_app.initYoutube();

		if(loop_app.youtubeReady){
			initPlayer();
		} else {
			$(window).on('youtubeReady', function(){
				initPlayer();
			});
		}

		addListener();

		if ($preview.parents('.swiper-slide').length == 0) {
			loop_app.createA11yButton($preview.get(0));
		}
	};

	var addListener = function() {
		$preview.on('click', function(e){
			e.preventDefault();

			play();
		});
	};

	var initPlayer = function(){
		player = new YT.Player($embed[0], {
			events: {
				onReady: function(){
					updateDuration();
					checkThumbnail();
				}
			}
		});

		api.player = player;
	};

	var play = function(){
		if(player && player.playVideo){

			$embed.removeAttr('tabindex');

			player.playVideo();
			$element.addClass('is-playing');
		}
	};

	var updateDuration = function(){
		$duration.text(moment.utc(player.getDuration() * 1000).format('mm:ss'));
	};

	var checkThumbnail = function(){
		if($preview.css('background-image') == 'none'){
			var id = player.getVideoData().video_id;

			$preview.css('background-image', 'url(https://img.youtube.com/vi/'+id+'/sddefault.jpg)');
		}
	};

	api.player = player;

	init();
	return api;
};

loop_app.ext["webcam-threesixty"] = function ($jqueryElement) {
  const api = {};

  const element = $jqueryElement.get(0);

  const playButton = element.querySelector(".js-webcam-threesixty-play");
  const pauseButton = element.querySelector(".js-webcam-threesixty-pause");

  function init() {
    addListener();
  }

  function addListener() {
    playButton.addEventListener("click", playHandler);
    pauseButton.addEventListener("click", pauseHandler);
  }

  function playHandler() {
    element.classList.remove("is-stopped");
    pauseButton.focus();
  }

  function pauseHandler() {
    element.classList.add("is-stopped");
    playButton.focus();
  }

  init();

  return api;
};

loop_app.ext['webcams'] = function($el) {
	var api = {};

	var $element = $el;

	var $form = $el.find('.js-webcams-form');
	var $container = $el.find('.js-webcams-container');
	var $select = $el.find('.js-webcams-select');
	var $loader = $el.find('.js-webcams-loader');

	var template = _.template($el.find('.js-webcams-template').html());

	var init = function() {
		addListener();
	};
	
	var addListener = function() {
		$select.on('change', timeChangeHandler);
		$form.on('submit', formSubmitHandler);
	};

	var timeChangeHandler = function() {
		$form.trigger('submit');
	};

	var formSubmitHandler = function(e) {
		e.preventDefault();

		$loader.addClass('is-visible');

		var url = $(this).data('api');
		console.log(url);
		$.ajax({
			url: url,
			method: 'POST',
			data: {
				time: $select.val()
			},
			success: function(data){

				// data = $.parseJSON(data);

				var html = '';

				_.forEach(data, function(row){
					// console.log(row);

					html += template(row);

					// console.log(html);
				});

				$container.html(html);

				loop_app.initLocalExtensions($container.parent());

				$loader.removeClass('is-visible');
			},
			error: function(){
				// TODO: error handling
				console.error(arguments);
				$loader.removeClass('is-visible');
			}
		});
	};

	init();
	return api;
};

loop_app.ext['wishable'] = function($el) {
	var api = {};

	var $element = $el;
	var $adders = $('.js-wishable-add');
	var $itemContainer = $('.js-wishable-item-container');
	var $itemCount = $('.js-wishable-item-count');
	var $empty = $('.js-wishable-empty');
	var $icon = $('.js-wishable-icon');
	var $download = $('.js-wishable-download');
	var $submit = $('.js-wishable-submit');
	var $list = $('.js-wishable-list');
	var $listLabel = $('.js-wishable-list-label');
	var $dropDown = $('.js-wishable-list-dropdown');

	var itemHtml = '<div class="wishlist__item">' +
			'<div class="wishlist__item__thumb" style="background-image: url(<%- image %>);"></div>' +
			'<div class="wishlist__item__text"><%- text %></div>' +
			'<div class="wishlist__item__remove js-wishable-remove" data-id="<%- id %>" tabindex="0" role="button" aria-label="Remove Item">' +
				'<i class="icon icon--x-thick"></i>' +
			'</div>' +
		'</div>';
	var itemTemplate = _.template(itemHtml);
	var items = [];
	var cookiePrefix = $element.data('wishable-cookie-prefix');

	var init = function() {
		getItemsFromCookie();
		addListener();
	};

	var addListener = function(){
		$adders.on('click', function(e){
			e.preventDefault();
			e.stopImmediatePropagation();

			var $adder = $(this);
			var data = $adder.data('wishable-data');

			if($adder.hasClass('is-added')){
				removeItem(data.id);
			} else {
				addItem(data);
			}
		});

		$(document).on('click', '.js-wishable-add-external[data-wishable-cookie-prefix="'+cookiePrefix+'"]', function(e){
			e.preventDefault();

			var $adder = $(this);
			var data = $adder.data('wishable-data');

			if($adder.hasClass('is-added')){
				removeItem(data.id);
			} else {
				addItem(data);
			}
		});

		$(document).on('keypress', '.js-wishable-add-external[data-wishable-cookie-prefix="'+cookiePrefix+'"]', function(e){
			if(e.which == 13){
				$(this).trigger('click');
			}
		});

		$itemContainer.on('click', '.js-wishable-remove', function(e){
			e.preventDefault();

			removeItem($(this).data('id'));
		});

		$itemContainer.on('keypress', '.js-wishable-remove', function(e){
			e.preventDefault();
			if (e.keyCode == 13) {
				removeItem($(this).data('id'));
			}
		});


		$download.on('click', function(e){
			e.preventDefault();

			var ids = _.map(items, 'id');

			window.location = $element.data('wishable-submit') + '?ids=' + ids.join(',');
		});

		if(Modernizr.touch){
			$listLabel.on('click', function(e){
				e.preventDefault();

				$list.toggleClass('is-open');
			});

			$(document).on('click', function(e){
				if($list.hasClass('is-open')){
					var $target = $(e.target);

					if(!$target.closest($list).length){
						$list.removeClass('is-open');
					}
				}
			});
		}

		$list.on('keypress', function(e){
			if (e.keyCode == 13) {
				if ($(this).find('.js-wishable-remove').length) {
					$(this).addClass('is-open');
					console.log($(this).find('.js-wishable-list-focus'));
					$(this).find('.js-wishable-list-focus').trigger('focus');
					
					$dropDown.on('keydown', function(e) {
						loop_app.handleKeyDownOverlay(e, $element, 'wishable');
					});
					$('.js-site-content').attr('aria-hidden', 'true');
				}
			}
		});
	};

	var addItem = function(data){
		var foundItem = _.find(items, {id: data.id});

		// already added
		if(foundItem){
			return;
		}

		var $item = $(itemTemplate(data));

		$itemContainer.append($item);
		$item.velocity('slideDown', { duration: 300 });

		data.$element = $item;

		items.push(data);

		markAdder(data.id);
		updateCount();
		updateCookie();

		$empty.velocity('slideUp', { duration: 300 });
		$list.attr('tabindex','0');
		
		$submit.removeClass('is-disabled');
		$icon.removeClass('is-animating');

		window.setTimeout(function(){
			$icon.addClass('is-animating');
		});
	};

	var removeItem = function(id){
		var foundItem = _.find(items, {id: id});

		if(!foundItem){
			return;
		}

		foundItem.$element.velocity('slideUp', {
			duration: 300,
			complete: function(){
				$(this).remove();
			}
		});

		_.remove(items, {id: id});

		unmarkAdder(id);
		updateCount();
		updateCookie();

		if(!items.length){
			$submit.addClass('is-disabled');
			$empty.velocity('slideDown', { duration: 300 });
			$list.removeAttr('tabindex');
		}
	};

	var markAdder = function(id){
		$adders.add('.js-wishable-add-external').each(function(){
			var $adder = $(this);
			var data = $adder.data('wishable-data');

			if(data.id == id){
				$adder.addClass('is-added');
			}
		});
	};

	var unmarkAdder = function(id){
		$adders.add('.js-wishable-add-external').each(function(){
			var $adder = $(this);
			var data = $adder.data('wishable-data');

			if(data.id == id){
				$adder.removeClass('is-added');
			}
		});
	};

	var updateCount = function(){
		$itemCount.text(items.length);
		var label = $list.data('aria-label');
		$list.attr('aria-label', label.replace('[nr_of_items]', items.length));
	};

	var updateCookie = function(){
		var ids = _.map(items, 'id');
		Cookies.set(cookiePrefix + '_wishable', JSON.stringify(ids));
	};

	var getItemsFromCookie = function(){
		var cookieData = Cookies.get(cookiePrefix + '_wishable');

		if(!cookieData){
			return;
		}

		var ids = JSON.parse(cookieData);

		if(ids.length){
			_.forEach(ids, function(id){
				$adders.each(function(){
					var $adder = $(this);
					var data = $adder.data('wishable-data');

					if(data.id == id){
						addItem(data);
						return false;
					}
				});
			});

			loop_app.setFocusableOverlayEls($list);
		}
	};

	var closeOverlay = function($date) {
		$list.removeClass('is-open');
	}

	api.closeOverlay = closeOverlay;

	init();
	return api;
};
